(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":14}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":15}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };
},{"core-js/library/fn/is-iterable":16}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":17}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":18}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":19}],7:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":20}],8:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _promise = require("../core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
},{"../core-js/promise":5}],9:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":4}],10:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _isIterable2 = require("../core-js/is-iterable");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require("../core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
},{"../core-js/get-iterator":2,"../core-js/is-iterable":3}],11:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":1}],12:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":6,"../core-js/symbol/iterator":7}],13:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":109}],14:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":28,"../../modules/es6.array.from":97,"../../modules/es6.string.iterator":102}],15:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');

},{"../modules/core.get-iterator":95,"../modules/es6.string.iterator":102,"../modules/web.dom.iterable":108}],16:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');

},{"../modules/core.is-iterable":96,"../modules/es6.string.iterator":102,"../modules/web.dom.iterable":108}],17:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":28,"../../modules/es6.object.assign":99}],18:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;

},{"../modules/_core":28,"../modules/es6.object.to-string":100,"../modules/es6.promise":101,"../modules/es6.string.iterator":102,"../modules/es7.promise.finally":104,"../modules/es7.promise.try":105,"../modules/web.dom.iterable":108}],19:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":28,"../../modules/es6.object.to-string":100,"../../modules/es6.symbol":103,"../../modules/es7.symbol.async-iterator":106,"../../modules/es7.symbol.observable":107}],20:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":92,"../../modules/es6.string.iterator":102,"../../modules/web.dom.iterable":108}],21:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],22:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],23:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],24:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":48}],25:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":83,"./_to-iobject":85,"./_to-length":86}],26:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":27,"./_wks":93}],27:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],28:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],29:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":61,"./_property-desc":73}],30:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":21}],31:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],32:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":37}],33:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":39,"./_is-object":48}],34:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],35:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":66,"./_object-keys":69,"./_object-pie":70}],36:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":28,"./_ctx":30,"./_global":39,"./_has":40,"./_hide":41}],37:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],38:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":24,"./_ctx":30,"./_is-array-iter":46,"./_iter-call":49,"./_to-length":86,"./core.get-iterator-method":94}],39:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],40:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],41:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":32,"./_object-dp":61,"./_property-desc":73}],42:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":39}],43:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":32,"./_dom-create":33,"./_fails":37}],44:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],45:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":27}],46:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":54,"./_wks":93}],47:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":27}],48:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],49:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":24}],50:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":41,"./_object-create":60,"./_property-desc":73,"./_set-to-string-tag":77,"./_wks":93}],51:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":36,"./_hide":41,"./_iter-create":50,"./_iterators":54,"./_library":55,"./_object-gpo":67,"./_redefine":75,"./_set-to-string-tag":77,"./_wks":93}],52:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":93}],53:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],54:[function(require,module,exports){
module.exports = {};

},{}],55:[function(require,module,exports){
module.exports = true;

},{}],56:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":37,"./_has":40,"./_is-object":48,"./_object-dp":61,"./_uid":89}],57:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":27,"./_global":39,"./_task":82}],58:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":21}],59:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":32,"./_fails":37,"./_iobject":45,"./_object-gops":66,"./_object-keys":69,"./_object-pie":70,"./_to-object":87}],60:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":24,"./_dom-create":33,"./_enum-bug-keys":34,"./_html":42,"./_object-dps":62,"./_shared-key":78}],61:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":24,"./_descriptors":32,"./_ie8-dom-define":43,"./_to-primitive":88}],62:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":24,"./_descriptors":32,"./_object-dp":61,"./_object-keys":69}],63:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":32,"./_has":40,"./_ie8-dom-define":43,"./_object-pie":70,"./_property-desc":73,"./_to-iobject":85,"./_to-primitive":88}],64:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":65,"./_to-iobject":85}],65:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":34,"./_object-keys-internal":68}],66:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],67:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":40,"./_shared-key":78,"./_to-object":87}],68:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":25,"./_has":40,"./_shared-key":78,"./_to-iobject":85}],69:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":34,"./_object-keys-internal":68}],70:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],71:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],72:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":24,"./_is-object":48,"./_new-promise-capability":58}],73:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],74:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":41}],75:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":41}],76:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":28,"./_descriptors":32,"./_global":39,"./_object-dp":61,"./_wks":93}],77:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":40,"./_object-dp":61,"./_wks":93}],78:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":79,"./_uid":89}],79:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":28,"./_global":39,"./_library":55}],80:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":21,"./_an-object":24,"./_wks":93}],81:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":31,"./_to-integer":84}],82:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":27,"./_ctx":30,"./_dom-create":33,"./_global":39,"./_html":42,"./_invoke":44}],83:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":84}],84:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],85:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":31,"./_iobject":45}],86:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":84}],87:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":31}],88:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":48}],89:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],90:[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":39}],91:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":28,"./_global":39,"./_library":55,"./_object-dp":61,"./_wks-ext":92}],92:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":93}],93:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":39,"./_shared":79,"./_uid":89}],94:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":26,"./_core":28,"./_iterators":54,"./_wks":93}],95:[function(require,module,exports){
var anObject = require('./_an-object');
var get = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

},{"./_an-object":24,"./_core":28,"./core.get-iterator-method":94}],96:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};

},{"./_classof":26,"./_core":28,"./_iterators":54,"./_wks":93}],97:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":29,"./_ctx":30,"./_export":36,"./_is-array-iter":46,"./_iter-call":49,"./_iter-detect":52,"./_to-length":86,"./_to-object":87,"./core.get-iterator-method":94}],98:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":22,"./_iter-define":51,"./_iter-step":53,"./_iterators":54,"./_to-iobject":85}],99:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":36,"./_object-assign":59}],100:[function(require,module,exports){

},{}],101:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var userAgent = require('./_user-agent');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":21,"./_an-instance":23,"./_classof":26,"./_core":28,"./_ctx":30,"./_export":36,"./_for-of":38,"./_global":39,"./_is-object":48,"./_iter-detect":52,"./_library":55,"./_microtask":57,"./_new-promise-capability":58,"./_perform":71,"./_promise-resolve":72,"./_redefine-all":74,"./_set-species":76,"./_set-to-string-tag":77,"./_species-constructor":80,"./_task":82,"./_user-agent":90,"./_wks":93}],102:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":51,"./_string-at":81}],103:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":24,"./_descriptors":32,"./_enum-keys":35,"./_export":36,"./_fails":37,"./_global":39,"./_has":40,"./_hide":41,"./_is-array":47,"./_is-object":48,"./_library":55,"./_meta":56,"./_object-create":60,"./_object-dp":61,"./_object-gopd":63,"./_object-gopn":65,"./_object-gopn-ext":64,"./_object-gops":66,"./_object-keys":69,"./_object-pie":70,"./_property-desc":73,"./_redefine":75,"./_set-to-string-tag":77,"./_shared":79,"./_to-iobject":85,"./_to-object":87,"./_to-primitive":88,"./_uid":89,"./_wks":93,"./_wks-define":91,"./_wks-ext":92}],104:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":28,"./_export":36,"./_global":39,"./_promise-resolve":72,"./_species-constructor":80}],105:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":36,"./_new-promise-capability":58,"./_perform":71}],106:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":91}],107:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":91}],108:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":39,"./_hide":41,"./_iterators":54,"./_wks":93,"./es6.array.iterator":98}],109:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

},{"./runtime":110}],110:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);

},{}],111:[function(require,module,exports){
"use strict";

angular.module('ox').directive('checkDateFormat', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elm, attrs, ctrl) {

            ctrl.$parsers.unshift(checkValue);
            ctrl.$formatters.unshift(checkValue);

            function checkValue(value) {
                if (moment(value, 'DD.MM.YYYY', true).isValid()) {
                    ctrl.$setValidity('checkDateFormat', true);
                    return value;
                } else {
                    ctrl.$setValidity('checkDateFormat', false);
                    return value;
                }
            }
        }
    };
});

},{}],112:[function(require,module,exports){
"use strict";

angular.module('ox').directive('checkDateRange', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(checkValue);
            ctrl.$formatters.unshift(checkValue);

            scope.$watch(function () {
                return attrs.minDate || attrs.maxDate;
            }, function () {
                return checkValue(ctrl.$modelValue);
            });

            function checkValue(value) {

                var valueMoment = moment(value, 'DD.MM.YYYY', true),
                    minMoment = attrs.minDate && moment(attrs.minDate, 'DD.MM.YYYY', true) || false,
                    maxMoment = attrs.maxDate && moment(attrs.maxDate, 'DD.MM.YYYY', true) || false;

                if (valueMoment.isValid()) {
                    if (minMoment && valueMoment.isBefore(minMoment)) {
                        ctrl.$setValidity('checkDateRange', false);
                        return value;
                    } else if (maxMoment && valueMoment.isAfter(maxMoment)) {
                        ctrl.$setValidity('checkDateRange', false);
                        return value;
                    } else {
                        ctrl.$setValidity('checkDateRange', true);
                        return value;
                    }
                } else {
                    ctrl.$setValidity('checkDateRange', false);
                    return value;
                }
            }
        }
    };
});

},{}],113:[function(require,module,exports){
"use strict";

angular.module('ox').directive('checkEquals', function () {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function link(scope, elem, attrs, ctrl) {

            if (!ctrl) {
                return;
            }

            attrs.$observe('checkEquals', function () {
                validate(ctrl.$viewValue);
            });

            ctrl.$parsers.unshift(validate);
            ctrl.$formatters.unshift(validate);

            function validate(value) {
                var equalValue = attrs.checkEquals;

                ctrl.$setValidity('checkEquals', !value || !equalValue || value === equalValue);

                return value;
            }
        }
    };
});

},{}],114:[function(require,module,exports){
"use strict";

angular.module('ox').directive('cleanPhone', ['backend', function (backend) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(checkPhone);
            ctrl.$formatters.unshift(checkPhone);

            function checkPhone(value) {
                var re = new RegExp(backend.getParam('customer.phoneRegexp'));

                if (value) {
                    value = value.replace(/\s/g, '');
                    value = value.replace(/\+/g, '');
                    value = value.replace(/\(/g, '');
                    value = value.replace(/\)/g, '');
                    value = value.replace(/-/g, '');

                    ctrl.$setValidity('pattern', re.test(value));
                } else {

                    ctrl.$setValidity('pattern', true);
                }

                return value;
            }
        }
    };
}]);

},{}],115:[function(require,module,exports){
"use strict";

angular.module('ox').directive('clickTracking', ['watchman', function (watchman) {
    return {
        restrict: 'A',
        link: function link($scope, element, attrs) {

            element.on('click', function () {
                if (element.hasClass('disabled')) {
                    return;
                }
                var categoryAttr = element.attr('data-tracking-category');
                var labelAttr = element.attr('data-tracking-label');
                var eventPrams = {
                    name: attrs.clickTracking
                };
                if (categoryAttr || labelAttr) {
                    eventPrams.data = {};
                    if (categoryAttr) {
                        eventPrams.data.category = categoryAttr;
                    }
                    if (labelAttr) {
                        eventPrams.data.label = labelAttr;
                    }
                }
                watchman.notifyUserInterfaceEvent(eventPrams);
            });
        }
    };
}]);

},{}],116:[function(require,module,exports){
"use strict";

angular.module('ox').directive('iframeOnload', function () {
    return {
        scope: {
            callBack: '=iframeOnload'
        },
        link: function link(scope, element) {
            element.on('load', scope.callBack);
        }
    };
});

},{}],117:[function(require,module,exports){
"use strict";

require('./wrap/wrap');
require('./checkEquals/checkEquals');
require('./cleanPhone/cleanPhone');
require('./multipattern/multipattern');
require('./uppercase/uppercase');
require('./preventBrowserSuggestions/preventBrowserSuggestions');
require('./phone-mask/phoneMask');
require('./iframe-onload/iframeOnload');
require('./check-date-format/checkDateFormat');
require('./check-date-range/checkDateRange');
require('./uppercase-by-input/uppercaseByInput');
require('./ui-select-tracking/uiSelectTracking');
require('./click-tracking/clickTracking');
require('./quick-search-order-on-paste/quickSearchOrderOnPaste');
require('./ui-select-custom/uiSelectCustom');

},{"./check-date-format/checkDateFormat":111,"./check-date-range/checkDateRange":112,"./checkEquals/checkEquals":113,"./cleanPhone/cleanPhone":114,"./click-tracking/clickTracking":115,"./iframe-onload/iframeOnload":116,"./multipattern/multipattern":118,"./phone-mask/phoneMask":119,"./preventBrowserSuggestions/preventBrowserSuggestions":120,"./quick-search-order-on-paste/quickSearchOrderOnPaste":121,"./ui-select-custom/uiSelectCustom":122,"./ui-select-tracking/uiSelectTracking":123,"./uppercase-by-input/uppercaseByInput":124,"./uppercase/uppercase":125,"./wrap/wrap":126}],118:[function(require,module,exports){
"use strict";

angular.module('ox').directive('multipattern', function () {
    return {
        require: 'ngModel',
        scope: {
            patternsList: '=multipattern'
        },
        link: function link(scope, elm, attrs, ctrl) {

            scope.$watch('patternsList', function () {
                validate(ctrl.$viewValue);
            });

            ctrl.$parsers.unshift(validate);

            function validate(value) {
                var i = 0,
                    tmpRe = void 0;

                if (!value || !scope.patternsList || !scope.patternsList.length) {
                    ctrl.$setValidity('pattern', true);
                    return value;
                }

                while (i < scope.patternsList.length) {
                    tmpRe = new RegExp(scope.patternsList[i]);

                    if (tmpRe.test(value)) {
                        ctrl.$setValidity('pattern', true);
                        return value;
                    }

                    i++;
                }

                ctrl.$setValidity('pattern', false);

                return null;
            }
        }
    };
});

},{}],119:[function(require,module,exports){
"use strict";

angular.module('ox').directive('phoneMask', ['backend', function (backend) {

    function link(scope, element) {
        jQuery(element).inputmasks({
            inputmask: {
                definitions: {
                    '#': { validator: '[0-9]', cardinality: 1 }
                },
                showMaskOnHover: false,
                autoUnmask: true
            },
            match: /[0-9]/,
            replace: '#',
            list: backend.getPhoneCodesMask(),
            listKey: 'mask',
            onMaskChange: MaskChangeHandler
        });
    }

    function MaskChangeHandler(maskObj, completed) {
        var descElement = jQuery(this).next('div.phone-mask-desc');
        if (!descElement.length) {
            jQuery(this).after('<div class="phone-mask-desc"></div>');
            descElement = jQuery(this).next('div.phone-mask-desc');
        }
        descElement.html(completed ? backend.getCountryLocalNameByCode(maskObj.cc) : '');
    }

    return {
        link: link
    };
}]);

},{}],120:[function(require,module,exports){
"use strict";

angular.module('ox').directive('preventBrowserSuggestions', [function () {
    return {
        restrict: 'A',
        link: function link(scope, elm, attrs) {
            attrs.$set('autocomplete', 'off');
            attrs.$set('autocorrect', 'off');
            attrs.$set('autocapitalize', 'off');
            attrs.$set('autocomplete', 'off');
            attrs.$set('spellcheck', 'false');
        }
    };
}]);

},{}],121:[function(require,module,exports){
"use strict";

angular.module('ox').directive('quickSearchOrderOnPaste', ['backend', '$window', '$q', function (backend, $window, $q) {
    return {
        restrict: 'A',
        link: function link($scope, element) {

            element[0].focus();

            if (!o2context.debug) {
                return;
            }

            element.on('paste', function (event) {
                try {
                    var passengerLastNameRegexp = new RegExp(backend.applicationConstants.passengerLastNameRegexp);
                    var ticketRegexp = new RegExp(backend.applicationConstants.ticketRegexp);
                    var text = (event.originalEvent.clipboardData || $window.clipboardData).getData('text');
                    text = text.toUpperCase();
                    text = text.replace(/([0-9]{3})[ ]+([0-9]{10})/g, '$1$2');
                    var lines = text.split('\n').map(function (line) {
                        var fields = line.match(/\S+/g);
                        var lineState = {};
                        if (fields.length === 2) {
                            fields.forEach(function (field) {
                                if (passengerLastNameRegexp.test(field)) {
                                    lineState.lastName = field;
                                } else if (ticketRegexp.test(field)) {
                                    lineState.ticket = field;
                                }
                            });
                        }
                        return lineState;
                    }).filter(function (lineState) {
                        return lineState.ticket && lineState.lastName;
                    });
                    if (lines.length) {
                        jQuery('#preloader').show();
                        quickSearchHandler(lines).then(function () {
                            $window.location.reload();
                        });
                        return false;
                    }
                } catch (e) {
                    // ignore errors
                }
            });

            function quickSearchHandler(paramsList, recall) {
                return $q(function (resolve, reject) {
                    backend.searchOrderByParams(paramsList[0], recall).then(function (resp) {
                        if (paramsList.length > 1) {
                            var paramsListCopy = angular.copy(paramsList);
                            paramsListCopy.shift();
                            quickSearchHandler(paramsListCopy, true).then(resolve, reject);
                        } else if (resp.orderCompletelyInitialized) {
                            resolve();
                        } else {
                            backend.finishSeparatePassengersSearch().then(resolve, reject);
                        }
                    }, reject);
                });
            }
        }
    };
}]);

},{}],122:[function(require,module,exports){
"use strict";

angular.module('ox').directive('uiSelectCustom', ['$timeout', function ($timeout) {
    return {
        require: 'uiSelect',
        restrict: 'A',
        link: function link($scope, element, attrs, ctrl) {

            /**
             * Смена елемента по табуляции
             */
            changeElementByTabEvent();

            function changeElementByTabEvent() {
                var autoopen = true;

                angular.element(ctrl.focusser).on('focus', function () {
                    if (autoopen) {
                        ctrl.activate();
                    }
                });

                //Дизейблим autoopen, когда выбранный элемент активирован
                $scope.$on('uis:activate', function () {
                    autoopen = false;
                });

                $scope.$on('uis:close', function () {
                    //Чтобы focusser после закрытия не выполнял re-activate
                    autoopen = false;
                    //250ms специально для IE
                    $timeout(function () {
                        autoopen = true;
                    }, 250);
                });
            }
        }
    };
}]);

},{}],123:[function(require,module,exports){
"use strict";

angular.module('ox').directive('uiSelectTracking', ['watchman', function (watchman) {
    return {
        require: 'uiSelect',
        restrict: 'A',
        link: function link($scope, element, attrs) {

            $scope.$on('uis:select', function () {
                watchman.notifyUserInterfaceEvent({
                    name: attrs.uiSelectTracking,
                    data: $scope.$select.selected
                });
            });
        }
    };
}]);

},{}],124:[function(require,module,exports){
"use strict";

angular.module('ox').directive('uppercaseByInput', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elem, attrs, ctrl) {

            if (!ctrl) {
                return;
            }

            ctrl.$parsers.push(formatParam);

            function formatParam(value) {
                return (value || '').toUpperCase();
            }
        }
    };
}]);

},{}],125:[function(require,module,exports){
"use strict";

angular.module('ox').directive('uppercase', function () {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function link(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (input) {
                return input ? input.toUpperCase() : '';
            });

            element.css('text-transform', 'uppercase');
        }
    };
});

},{}],126:[function(require,module,exports){
"use strict";

angular.module('ox').directive('wrap', function () {
    return {
        restrict: 'A'
    };
});

},{}],127:[function(require,module,exports){
"use strict";

angular.module('ox').filter('alias', ['backend', function (backend) {
    return backend.getAlias;
}]);

},{}],128:[function(require,module,exports){
"use strict";

angular.module('ox').filter('aliasDynamic', ['backend', function (backend) {
    return backend.getAliasDynamic;
}]);

},{}],129:[function(require,module,exports){
"use strict";

angular.module('ox').filter('aliasStatic', ['backend', function (backend) {
    return backend.getAlias;
}]);

},{}],130:[function(require,module,exports){
"use strict";

angular.module('ox').filter('aliasWithPrefix', ['backend', function (backend) {
    return backend.getAliasWithPrefix;
}]);

},{}],131:[function(require,module,exports){
"use strict";

angular.module('ox').filter('capitalize', ['utils', function (utils) {
    return utils.capitalize;
}]);

},{}],132:[function(require,module,exports){
"use strict";

angular.module('ox').filter('capitalizeFirstLetter', ['utils', function (utils) {
    return utils.capitalizeFirstLetter;
}]);

},{}],133:[function(require,module,exports){
"use strict";

angular.module('ox').filter('currencySign', ['utils', function (utils) {
    return function (currency) {
        return '<span class="currency_sign">' + utils.getUnicodeCurrencySign(currency) + '</span>';
    };
}]);

},{}],134:[function(require,module,exports){
"use strict";

angular.module('ox').filter('dayshift', function () {
    return function (num) {
        if (num > 0) {
            return '+' + num;
        } else if (num < 0) {
            return '' + num;
        } else {
            return '';
        }
    };
});

},{}],135:[function(require,module,exports){
"use strict";

angular.module('ox').filter('externalStoragePrefix', ['backend', function (backend) {
    return function (input) {
        var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');
        return '' + externalStorageUrl + input;
    };
}]);

},{}],136:[function(require,module,exports){
"use strict";

angular.module('ox').filter('formatDate', function () {
    return function (input, formatDate) {
        if (formatDate === 'month-for-day') {
            return moment(input, 'DD.MM.YYYY').format('D MMMM').split(' ')[1];
        } else {
            return moment(input, 'DD.MM.YYYY').format(formatDate);
        }
    };
});

},{}],137:[function(require,module,exports){
"use strict";

require('./alias');
require('./aliasStatic');
require('./aliasDynamic');
require('./aliasWithPrefix');
require('./param');
require('./price');
require('./currencySign');
require('./formatDate');
require('./lowerCase');
require('./dayshift');
require('./sessionParam');
require('./capitalize');
require('./capitalizeFirstLetter');
require('./timeAsWords');
require('./unsafeHtml');
require('./externalStoragePrefix');
require('./staticWebContentRootPrefix');

},{"./alias":127,"./aliasDynamic":128,"./aliasStatic":129,"./aliasWithPrefix":130,"./capitalize":131,"./capitalizeFirstLetter":132,"./currencySign":133,"./dayshift":134,"./externalStoragePrefix":135,"./formatDate":136,"./lowerCase":138,"./param":139,"./price":140,"./sessionParam":141,"./staticWebContentRootPrefix":142,"./timeAsWords":143,"./unsafeHtml":144}],138:[function(require,module,exports){
"use strict";

angular.module('ox').filter('lowerCase', function () {
    return function (str) {
        return String(str).toLowerCase();
    };
});

},{}],139:[function(require,module,exports){
"use strict";

angular.module('ox').filter('param', ['backend', function (backend) {
    return backend.getParam;
}]);

},{}],140:[function(require,module,exports){
"use strict";

angular.module('ox').filter('price', ['backend', 'utils', function (backend, utils) {
    return function (input) {
        if (input.currency === 'miles') {
            input.currency = backend.getAlias('web.ffpCurrency');
        }

        return utils.formatPrice(input);
    };
}]);

},{}],141:[function(require,module,exports){
"use strict";

angular.module('ox').filter('sessionParam', ['backend', function (backend) {
    return function (code) {
        return backend.sessionParams[code] || code;
    };
}]);

},{}],142:[function(require,module,exports){
"use strict";

angular.module('ox').filter('staticWebContentRootPrefix', ['$window', function ($window) {
    return function (input) {
        var staticWebContentRoot = $window.o2context.staticWebContentRoot;
        return staticWebContentRoot + '/' + input;
    };
}]);

},{}],143:[function(require,module,exports){
"use strict";

angular.module('ox').filter('timeAsWords', ['backend', function (backend) {
    return function (str) {
        var strArr = String(str).split(':');

        if (strArr.length === 2) {
            str = parseInt(strArr[0], 10) + ' ' + backend.getAlias('web.reduction.hour');

            if (strArr[1] !== '00') {
                str += ' ' + parseInt(strArr[1], 10) + ' ' + backend.getAlias('web.reduction.minute');
            }
        }

        return str;
    };
}]);

},{}],144:[function(require,module,exports){
"use strict";

angular.module('ox').filter('unsafeHtml', ['$sce', function ($sce) {
    return $sce.trustAsHtml;
}]);

},{}],145:[function(require,module,exports){
"use strict";
// jscs:disable

angular.module('ox').config(['$httpProvider', function ($httpProvider) {

    $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

    /**
    * The workhorse; converts an object to x-www-form-urlencoded serialization.
    * @param {Object} obj
    * @return {String}
    */
    function param(obj) {
        var query = '',
            name = void 0,
            value = void 0,
            fullSubName = void 0,
            subName = void 0,
            subValue = void 0,
            innerObj = void 0,
            i = void 0;

        for (name in obj) {
            value = obj[name];

            if (value instanceof Array) {
                for (i = 0; i < value.length; ++i) {
                    subValue = value[i];
                    fullSubName = name + '[' + i + ']';
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += param(innerObj) + '&';
                }
            } else if (value instanceof Object) {
                for (subName in value) {
                    subValue = value[subName];
                    fullSubName = name + '[' + subName + ']';
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += param(innerObj) + '&';
                }
            } else if (value !== undefined && value !== null) {
                query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
            }
        }

        return query.length ? query.substr(0, query.length - 1) : query;
    }

    // Override $http service's default transformRequest
    $httpProvider.defaults.transformRequest = [function (data) {
        return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
    }];
}]);

},{}],146:[function(require,module,exports){
"use strict";

angular.module('ox', []);

require('./http.conf');
require('./services');
require('./filters');
require('./components');

},{"./components":117,"./filters":137,"./http.conf":145,"./services":150}],147:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('ox').factory('backend', ['$q', '$http', '$location', '$timeout', '$window', 'utils', 'watchman', 'uniqueTabIdGenerator', function ($q, $http, $location, $timeout, $window, utils, watchman, uniqueTabIdGenerator) {
    var service = {
        ready: init(),
        setSessionInactiveHandler: setSessionInactiveHandler,
        setCancelSessionHandler: setCancelSessionHandler,
        triggerCancelSessionHandler: triggerCancelSessionHandler,
        hasAlias: hasAlias,
        getAlias: getAlias,
        getAliasWithPrefix: getAliasWithPrefix,
        getAliasDynamic: getAliasDynamic,
        getParam: getParam,
        sessionParams: {},
        clearSession: clearSession,
        clearOrderFromSession: clearOrderFromSession,
        login: login,
        logout: logout,
        registration: registration,
        activate: activate,
        checkLogin: checkLogin,
        forgetPassword: forgetPassword,
        resendActivationMail: resendActivationMail,
        tempChangePassword: tempChangePassword,
        getDependenceCitiesList: getDependenceCitiesList,
        getDependenceCitiesListForCity: getDependenceCitiesListForCity,
        getDependenceCachedCitiesListForCity: getDependenceCachedCitiesListForCity,
        getPlainCityDict: getPlainCityDict,
        getCityByCode: getCityByCode,
        getPortByCode: getPortByCode,
        getGeoPointByCodes: getGeoPointByCodes,
        searchVariantsMonoBrandCartesian: searchVariantsMonoBrandCartesian,
        companySearchVariants: companySearchVariants,
        searchVariantsPricingRouteAndMonoBrand: searchVariantsPricingRouteAndMonoBrand,
        searchPricevariant: searchPricevariant,
        searchVariants: searchVariants,
        getSearchVariantsResult: getSearchVariantsResult,
        getStoredSearchParams: getStoredSearchParams,
        searchNearestDates: searchNearestDates,
        getSchedulePeriod: getSchedulePeriod,
        searchVariantsFFP: searchVariantsFFP,
        lastSearchParams: lastSearchParams,
        clearLastSearchParams: clearLastSearchParams,
        ffpBonus: ffpBonus,
        ffpBalance: ffpBalance,
        searchCartesianPeriod: searchCartesianPeriod,
        searchMonthPeriod: searchMonthPeriod,
        searchVariantsPeriod: searchVariantsPeriod,
        routeAvailability: routeAvailability,
        routeAvailabilityAdvanced: routeAvailabilityAdvanced,
        oneWayAvailabilityRossiya: oneWayAvailabilityRossiya,
        pricingVariant: pricingVariant,
        pricingVariantCancel: pricingVariantCancel,
        pricingVariantMonoBrand: pricingVariantMonoBrand,
        passengersCheck: passengersCheck,
        passengersAdd: passengersAdd,
        modifyPassenger: modifyPassenger,
        updatePassengerPhone: updatePassengerPhone,
        customerAdd: customerAdd,
        getPrivatePassengers: getPrivatePassengers,
        savePrivatePassengers: savePrivatePassengers,
        addPrivatePassenger: addPrivatePassenger,
        modifyPrivatePassenger: modifyPrivatePassenger,
        removePrivatePassenger: removePrivatePassenger,
        getBonusPrograms: getBonusPrograms,
        getOrderInfo: getOrderInfo,
        updateOrderInfo: updateOrderInfo,
        clearOrderInfo: clearOrderInfo,
        clearOrderInfoListeners: clearOrderInfoListeners,
        addOrderInfoListener: addOrderInfoListener,
        addAuthoriseCustomerListener: addAuthoriseCustomerListener,
        getBrandConfig: getBrandConfig,
        getFfpCompareConfig: getFfpCompareConfig,
        getRefundConfig: getRefundConfig,
        getSearchGroupsConfig: getSearchGroupsConfig,
        getTaxesGroupsList: getTaxesGroupsList,
        getEnvironmentUrls: getEnvironmentUrls,
        getEnvironmentUrl: getEnvironmentUrl,
        getPhoneCodesMask: getPhoneCodesMask,
        getBrandName: getBrandName,
        getBrandByCode: getBrandByCode,
        getBrandProps: getBrandProps,
        checkBrandExist: checkBrandExist,
        getBannersConfig: getBannersConfig,
        getBannerByCode: getBannerByCode,
        getCountriesList: getCountriesList,
        getDefaultNationalityCode: getDefaultNationalityCode,
        getCountryByCode: getCountryByCode,
        getCountryLocalNameByCode: getCountryLocalNameByCode,
        getRemark: getRemark,
        getExchangeRemark: getExchangeRemark,
        ffpLogin: ffpLogin,
        ffpLogout: ffpLogout,
        saveProfile: saveProfile,
        deleteProfile: deleteProfile,
        changePassword: changePassword,
        priceVariant: priceVariant,
        paymentVariants: paymentVariants,
        eraseConflictServices: eraseConflictServices,
        doBookingAndRegisterOrder: doBookingAndRegisterOrder,
        startPaymentForExtraServices: startPaymentForExtraServices,
        retryRegister: retryRegister,
        waitPayment: waitPayment,
        getDocumentsList: getDocumentsList,
        getAvailableDocumentsForAeroexpress: getAvailableDocumentsForAeroexpress,
        getUserBankDetailsList: getUserBankDetailsList,
        saveUserBankDetailsList: saveUserBankDetailsList,
        getOrders: getOrders,
        searchOrder: searchOrder,
        searchOrderByParams: searchOrderByParams,
        searchOrderByToken: searchOrderByToken,
        finishSeparatePassengersSearch: finishSeparatePassengersSearch,
        searchFvSpecialOrderByParams: searchFvSpecialOrderByParams,
        quickSearchHandler: quickSearchHandler,
        updateOrderServices: updateOrderServices,
        addUpdateOrderServicesListener: addUpdateOrderServicesListener,
        clearUpdateOrderServicesListeners: clearUpdateOrderServicesListeners,
        switchDefaultSelectedServices: switchDefaultSelectedServices,
        getExtraServices: getExtraServices,
        modifyExtraService: modifyExtraService,
        removeExtraService: removeExtraService,
        setServicesPriceChangesHandler: setServicesPriceChangesHandler,
        addExtraServiceListener: addExtraServiceListener,
        addExtraServiceErrorListener: addExtraServiceErrorListener,
        aeroexpressSchedule: aeroexpressSchedule,
        seatMap: seatMap,
        flownStatus: flownStatus,
        calcRefund: calcRefund,
        manualRefund: manualRefund,
        confirmRefund: confirmRefund,
        cancelOrder: cancelOrder,
        exchangeVariants: exchangeVariants,
        exchangeSelect: exchangeSelect,
        exchangeConfirm: exchangeConfirm,
        sunInfo: sunInfo,
        getBookingLimits: getBookingLimits,
        getSoftBookingLimits: getSoftBookingLimits,
        switchCurrencyLanguage: switchCurrencyLanguage,
        switchCurrency: switchCurrency,
        switchLanguage: switchLanguage,
        setSwitchCurrencyLanguageListener: setSwitchCurrencyLanguageListener,
        setCaptchaRequiredHandler: setCaptchaRequiredHandler,
        setOrderEmailRequiredHandler: setOrderEmailRequiredHandler,
        sendErrorReport: sendErrorReport,
        sendReceipt: sendReceipt,
        requestIssueTickets: requestIssueTickets,
        confirmIssueTickets: confirmIssueTickets,
        cancelIssueTickets: cancelIssueTickets,
        bindOrder: bindOrder,
        changePaymentForm: changePaymentForm,
        aeroexpressRefund: aeroexpressRefund,
        checkServiceRemovalProhibited: checkServiceRemovalProhibited,
        unsubscribe: unsubscribe,
        getCountryByIp: getCountryByIp,
        confirmCountryDetection: confirmCountryDetection,
        removePaymentCard: removePaymentCard,
        changePayMethod: changePayMethod,
        markTrackingEventProcessed: markTrackingEventProcessed,
        getSpecialNeedSsrs: getSpecialNeedSsrs,
        getFfpMemberTypesConfig: getFfpMemberTypesConfig,
        getGroupedSpecialNeedSsrs: getGroupedSpecialNeedSsrs,
        calculateYnaoDiscount: calculateYnaoDiscount,
        getScannedDocs: getScannedDocs,
        uploadScannedDoc: uploadScannedDoc,
        removeScannedDoc: removeScannedDoc,
        getFakeExchangeVariants: getFakeExchangeVariants,
        getSvcs: getSvcs,
        generateLegacyCityObject: generateLegacyCityObject,
        getGeoPointByLegacyCityObject: getGeoPointByLegacyCityObject,
        generateInsuranceAgreeText: generateInsuranceAgreeText,
        addFfpCards: addFfpCards,
        modifyParent: modifyParent,
        getPersonalWheelchairBatteryTypes: getPersonalWheelchairBatteryTypes,
        confirmRemoveProfile: confirmRemoveProfile
    },
        citiesIndex = {},
        airportsIndex = {},
        aliasesIndex = {},
        paramsIndex = {},
        orderInfoStateListeners = [],
        authoriseCustomerListeners = [],
        extraServiceListeners = [],
        extraServiceErrorListeners = [],
        cacheCityListForCity = {},
        cacheAvailabilityForDirection = [],
        cacheMonthSearch = [],
        declarationAliasesIndex = {};

    var plainCityDict = void 0,
        dependenceCityDict = void 0,
        isCountriesDictSorted = false,
        switchCurrencyLanguageListener = false,
        orderInfo = false,
        pricingVariantCanceler = void 0,
        sessionInactiveHandler = void 0,
        cancelSessionHandler = void 0,
        maxInactiveInterval = void 0,
        alertInactiveTimeout = void 0,
        useSessionTimer = false,
        sessionTimer = void 0,
        captchaRequiredHandler = false,
        orderEmailRequiredHandler = false,
        searchVariantsResult = void 0,
        storedSearchParams = void 0,
        needUpdatePaymentVariantsGlobalState = void 0,
        brandsList = [],
        bannersList = [],
        ffpCompareConfig = {},
        refundConfig = {},
        monthSearchConfig = {},
        searchGroupsConfig = [],
        taxesGroupsList = [],
        environmentUrls = {},
        specialNeedSsrs = [],
        ffpMemberTypesConfig = [],
        personalWheelchairBatteryTypes = [],
        phoneCodesMask = [],
        countriesDict = [],
        orderInfoListeners = [],
        orderServicesListeners = [],
        declarationAliasesPrefixList = [],
        servicesPriceChangesHandler = function servicesPriceChangesHandler() {};

    return service;

    function init() {
        if (!checkTabIdParam()) {
            $window.location = './';
            return;
        }
        return $q.all([fetchJSON('json/get-aliases?lang=' + o2context.lang).then(initAliases), fetchJSON(o2context.debug ? 'aliases-declaration/aliases-declaration.json?cacheStamp=' + o2context.buildNumber : o2context.staticWebContentRoot + '/themes/' + o2context.oxyTheme + '/aliases-declaration/aliases-declaration.json?cacheStamp=' + o2context.buildNumber).then(initAliasesDeclaration), fetchJSON(o2context.debug ? 'aliases-declaration/aliases-prefix-declaration.json?cacheStamp=' + o2context.buildNumber : o2context.staticWebContentRoot + '/themes/' + o2context.oxyTheme + '/aliases-declaration/aliases-prefix-declaration.json?cacheStamp=' + o2context.buildNumber).then(initAliasesPrefixDeclaration), fetchJSON('json/get-params').then(initParams), fetchJSON('json/session-params').then(initSessionParams), fetchJSON('json/application-constants').then(initApplicationConstants)]).then(initDicts);
    }

    function initDicts() {
        var reqList = [fetchJSON('json/dict-cities').then(initPlainCityDict), fetchJSON('json/countries').then(initCountriesDict)];

        if (getParam('site.isCompany')) {
            reqList.push(fetchJSON('json/dependence-cities', 'POST', {
                isBooking: true,
                lang: service.sessionParams.lang
            }).then(initDependenceCityDict));
        }

        return $q.all(reqList);
    }

    function setSessionInactiveHandler(fn) {
        sessionInactiveHandler = fn;
    }

    function setCancelSessionHandler(fn) {
        cancelSessionHandler = fn;
    }

    function triggerCancelSessionHandler() {
        if (cancelSessionHandler) {
            cancelSessionHandler(false);
        }
    }

    function getAlias(code, ignoreDeclarationCheck) {
        if (o2context.advancedAliasesMode) {
            return code;
        }

        if (code) {
            if (declarationAliasesIndex[code] === undefined && !ignoreDeclarationCheck) {
                if (storeAliasToList(code, 'undeclaredAliases')) {
                    // eslint-disable-next-line
                    console.error('Alias not declared: ', code);
                }
            }

            if (aliasesIndex[code] === undefined) {
                if (storeAliasToList(code, 'undefinedAliases')) {
                    // eslint-disable-next-line
                    console.debug('Alias not defined: ', code);
                    sendErrorReport('CONFIG_ERROR', 'Alias not defined: ' + code);
                }

                if (declarationAliasesIndex[code] === undefined || ignoreDeclarationCheck) {
                    return code;
                } else {
                    storeAliasToList(code, 'undefinedButDeclaredAliases');
                    return declarationAliasesIndex[code];
                }
            } else {
                return aliasesIndex[code];
            }
        }
    }

    function getAliasDynamic(code) {
        return getAlias(code, true);
    }

    function getAliasWithPrefix(prefix, postfix) {
        var code = prefix + postfix;

        if (!utils.hasInList(declarationAliasesPrefixList, prefix)) {
            // eslint-disable-next-line
            console.error('Alias prefix not declared: ', prefix);

            storeAliasToList(prefix, 'undeclaredAliasesPrefix');
        }

        return getAlias(code, true);
    }

    function storeAliasToList(aliasCode, listCode) {
        if (!o2context[listCode]) {
            o2context[listCode] = [];
        }

        if (!utils.hasInList(o2context[listCode], aliasCode)) {
            o2context[listCode].push(aliasCode);

            return true;
        } else {
            return false;
        }
    }

    function hasAlias(code) {
        return aliasesIndex[code] !== undefined;
    }

    function getParam(code) {
        var value = paramsIndex[code],
            numValue = void 0;

        if (value === "true") {
            value = true;
        } else if (value === "false" || value === "") {
            value = false;
        } else {
            numValue = value * 1;

            if (numValue === 0 || numValue && typeof numValue === 'number') {
                value = numValue;
            }
        }

        return value;
    }

    function addAuthoriseCustomerListener(cb) {
        authoriseCustomerListeners.push(cb);

        if (service.sessionParams.authoriseCustomer) {
            cb(service.sessionParams.authoriseCustomer);
        }
    }

    function login(params) {
        useSessionTimer = true;

        return $q(function (resolve, reject) {
            fetchJSON('json/login', 'POST', params, { keyEvent: 'login' }).then(function (resp) {
                fetchJSON('json/session-params').then(function (data) {
                    initSessionParams(data);
                    authoriseCustomerListeners.forEach(function (cb) {
                        cb(service.sessionParams.authoriseCustomer || false);
                    });
                    resolve(resp);
                }, reject);
            }, reject);
        });
    }

    function logout() {
        return $q(function (resolve, reject) {
            fetchJSON('json/logout', 'POST', {}, { keyEvent: 'logout' }).then(function () {
                service.sessionParams.authoriseCustomer = false;

                authoriseCustomerListeners.forEach(function (cb) {
                    cb(false);
                });

                resolve();
            }, reject);
        });
    }

    function registration(params) {
        return fetchJSON('json/registration', 'POST', reformatRegistrationParams(params), {
            keyEvent: 'registration',
            ignoreCaptchaRequired: true
        });
    }

    function activate(identity) {
        return fetchJSON('json/activate', 'POST', { identity: identity }, { keyEvent: 'activate' });
    }

    function checkLogin(login) {
        return fetchJSON('json/checkLogin', 'POST', { login: login });
    }

    function forgetPassword(params) {
        params.url = getCurrentLocation();

        return fetchJSON('json/forget-password', 'POST', params, { keyEvent: 'forget-password' });
    }

    function resendActivationMail(params) {
        params.url = getCurrentLocation();

        return fetchJSON('json/resend-activation-mail', 'POST', params, { keyEvent: 'resend-activation-mail' });
    }

    function tempChangePassword(params) {
        return fetchJSON('json/temp-change-password', 'POST', {
            'newPassword[]': params.newPassword,
            userRole: params.userRole,
            tempAuthIdentity: params.tempAuthIdentity
        }, { keyEvent: 'temp-change-password' });
    }

    function getPlainCityDict() {
        return plainCityDict;
    }

    function getDependenceCitiesList(direction) {
        return dependenceCityDict[direction];
    }

    function getDependenceCitiesListForCity(returnPoints, cityCode) {
        return fetchJSON('json/dependence-cities', 'POST', {
            returnPoints: returnPoints,
            cityCode: cityCode,
            isBooking: true,
            lang: service.sessionParams.lang
        });
    }
    function getDependenceCachedCitiesListForCity(returnPoints, cityCode) {
        if (!cacheCityListForCity[cityCode]) {
            cacheCityListForCity[cityCode] = {};
        }
        if (!cacheCityListForCity[cityCode][returnPoints]) {
            cacheCityListForCity[cityCode][returnPoints] = getDependenceCitiesListForCity(returnPoints, cityCode);
        }
        return cacheCityListForCity[cityCode][returnPoints];
    }

    function getCountriesList() {
        var defSorter = void 0,
            priorityNationalityList = [];

        if (!isCountriesDictSorted) {
            defSorter = utils.getPropSorter(service.sessionParams.localNamePropName);

            if (getParam('passengers.priorityNationalityCode')) {
                priorityNationalityList = getParam('passengers.priorityNationalityCode').split(',').map(function (code) {
                    return code.trim();
                });
            }

            countriesDict.sort(function (a, b) {
                var indexOfA = priorityNationalityList.indexOf(a.code),
                    indexOfB = priorityNationalityList.indexOf(b.code);

                if (indexOfA === indexOfB) {
                    return defSorter(a, b);
                } else {
                    if (indexOfA === -1) {
                        return 1;
                    } else if (indexOfB === -1) {
                        return -1;
                    } else {
                        return indexOfA > indexOfB ? 1 : -1;
                    }
                }
            });

            isCountriesDictSorted = true;
        }

        return countriesDict;
    }

    function getDefaultNationalityCode() {
        return (getParam('passengers.defaultNationalityCode') || '').split(',').map(function (code) {
            return code.trim();
        })[0];
    }

    function getCountryLocalNameByCode(code) {
        var country = getCountryByCode(code);

        if (country && country[service.sessionParams.localNamePropName]) {
            return country[service.sessionParams.localNamePropName];
        } else {
            return code;
        }
    }

    function getCountryByCode(code) {
        return _.findWhere(countriesDict, { code: code });
    }

    function getCityByCode(code) {
        var city = citiesIndex[code],
            port = void 0;

        if (!city) {
            port = getPortByCode(code);

            if (port) {
                city = citiesIndex[port.cityCodeEn];
            }
        }

        return city;
    }

    function getPortByCode(code) {
        return airportsIndex[code];
    }

    function getGeoPointByCodes(codes) {
        var result = void 0;
        codes.forEach(function (code) {
            var city = getCityByCode(code);
            var port = getPortByCode(code);
            if (city) {
                result = {
                    cityCode: city.codeEn,
                    cityName: city[service.sessionParams.localNamePropName],
                    countryName: city[service.sessionParams.localCountryNamePropName]
                };
                if (port && port.codeEn !== city.codeEn) {
                    result.portCode = port.codeEn;
                    result.portName = port[service.sessionParams.localNamePropName];
                }
            }
        });
        return result;
    }

    function searchVariantsMonoBrandCartesian(searchParams) {
        useSessionTimer = true;

        return $q(function (resolve, reject) {
            fetchJSON('json/search-variants-mono-brand-cartesian', 'POST', utils.reformatSearchParams(searchParams), { keyEvent: 'search-variants-mono-brand-cartesian' }).then(function (resp) {

                if (resp.prices && resp.prices.length === 2) {
                    resp = filterBadFlights(resp);
                }

                resolve(resp);
            }, reject);
        });
    }

    function searchVariantsPricingRouteAndMonoBrand(searchParams, segment, alreadySelectedBySegments) {
        useSessionTimer = true;
        var params = searchParams ? utils.reformatSearchParams(searchParams) : {};
        if (segment && alreadySelectedBySegments) {
            params.calculateForSegment = segment;
            alreadySelectedBySegments.forEach(function (alreadySelectedBySegment, num) {
                params['flightchain-id[' + num + ']'] = alreadySelectedBySegment.chainId;
                params['brand[' + num + ']'] = alreadySelectedBySegment.brand;
                params['artificial-price[' + num + ']'] = alreadySelectedBySegment.artificialPriceForChain;
            });
        }
        return fetchJSON('json/search-variants-pricing-route-and-mono-brand', 'POST', params, { keyEvent: 'search-variants-pricing-route-and-mono-brand' });
    }

    /**
     * Фильтрует response.prices[0], оставляет только те рейсы, с которых можно успеть на обратный
     * @param response
     * @returns {*}
     */
    function filterBadFlights(response) {
        var pricesOne = response.prices[0],
            pricesTwo = response.prices[1],
            pricesOneKeys = Object.keys(pricesOne),
            pricesTwoKeys = Object.keys(pricesTwo),
            flights = response.flights,
            pricesOneFilter = [],
            pricesTwoFilter = [],
            pricesOneEnd = [];

        pricesTwoKeys.forEach(function (chainId) {
            flights.forEach(function (flight) {
                var flights = flight.flights;

                if (chainId === flight.chainId) {
                    pricesTwoFilter.push({
                        chainId: chainId,
                        departuretime: flights[0].departuretime,
                        departuredate: flights[0].departuredate
                    });
                }
            });
        });

        pricesOneKeys.forEach(function (chainId) {
            flights.forEach(function (flight) {
                var flights = flight.flights,
                    flightsLength = flights.length;

                if (chainId === flight.chainId) {
                    pricesOneFilter.push({
                        chainId: chainId,
                        arrivaltime: flights[flightsLength - 1].arrivaltime,
                        arrivaldate: flights[flightsLength - 1].arrivaldate
                    });
                }
            });
        });

        pricesOneFilter.forEach(function (one) {
            var check = false;

            pricesTwoFilter.forEach(function (two) {
                var comparetime = utils.compareStringTime(one.arrivaltime, two.departuretime),
                    comparedate = utils.compareStringDate(one.arrivaldate, two.departuredate);

                if (comparetime === -1 && comparedate === 0 || comparedate === -1) {
                    check = true;
                }
            });

            if (!check) {
                pricesOneEnd.push({
                    chainId: one.chainId,
                    arrivaltime: one.arrivaltime,
                    arrivaldate: one.arrivaldate
                });
            }
        });

        return pricesOneEnd.length ? filterChainInResponse(response, pricesOneEnd) : response;

        /**
         * Удаляем ненужные рейсы
         * @param response
         * @param pricesOneEnd
         * @returns {*}
         */
        function filterChainInResponse(response, pricesOneEnd) {
            var pricesOne = response.prices[0],
                pricesOneKeys = Object.keys(pricesOne);

            pricesOneEnd.forEach(function (price) {
                if (pricesOneKeys.indexOf(price.chainId) !== -1) {
                    delete response.prices[0][price.chainId];
                }
            });

            return response;
        }
    }

    function companySearchVariants(searchParams) {
        useSessionTimer = true;

        return fetchJSON('json/company-search-variants', 'POST', utils.reformatSearchParams(searchParams), { keyEvent: 'search-variants' });
    }

    function searchPricevariant(pureSearchParams) {
        useSessionTimer = true;

        return fetchJSON('json/search-pricevariant', 'POST', utils.reformatPureSearchParams(pureSearchParams), { keyEvent: 'search-pricevariant' });
    }

    function searchVariants(searchParams, rawResultData) {
        useSessionTimer = true;
        storedSearchParams = searchParams;

        return $q(function (resolve, reject) {
            fetchJSON('json/search-variants', 'POST', utils.reformatSearchParams(searchParams), { keyEvent: 'search-variants' }).then(function (resp) {
                if (rawResultData) {
                    resolve(resp);
                } else {
                    searchVariantsResult = reformatSearchVariantsResult(resp);
                    resolve(searchVariantsResult);
                }
            }, reject);
        });
    }

    function getSearchVariantsResult() {
        return $q(function (resolve, reject) {
            if (searchVariantsResult) {
                resolve(searchVariantsResult);
            } else {
                lastSearchParams().then(function (lsp) {
                    if (lsp.result !== 'empty') {
                        searchVariants(reformatLastSearchParams(lsp)).then(resolve, reject);
                    } else {
                        reject();
                    }
                }, reject);
            }
        });
    }

    function reformatLastSearchParams(lsp) {
        return {
            passengers: {
                adults: lsp.adultsAmount,
                children: lsp.childrenAmount,
                infantsWithoutSeat: lsp.infantsWithoutSeatAmount,
                infantsWithSeat: lsp.infantsWithSeatAmount
            },
            segments: lsp.dates.map(function (date, i) {
                return {
                    date: date,
                    origin: getCityByCode(lsp.originCodes[i]),
                    destination: getCityByCode(lsp.destinationCodes[i])
                };
            }),
            business: lsp.business
        };
    }

    function getStoredSearchParams() {
        return storedSearchParams;
    }

    function searchNearestDates(searchParams) {
        return $q(function (resolve, reject) {
            fetchJSON('json/search-nearest-dates', 'POST', utils.reformatSearchParams(searchParams), { keyEvent: 'search-nearest-dates' }).then(function (resp) {
                var list = void 0;

                if (resp.result) {
                    list = reformatNearestDates(resp.result, searchParams);

                    if (list.length) {
                        resolve(list);
                    } else {
                        reject();
                    }
                } else {
                    reject();
                }
            }, reject);
        });
    }

    function getSchedulePeriod(searchParams) {
        return fetchJSON('json/get-schedule-period', 'POST', searchParams, { keyEvent: 'search-schedule' });
    }

    function searchVariantsFFP(searchParams) {
        useSessionTimer = true;

        return fetchJSON('json/search-variants-ffp', 'POST', utils.reformatSearchParams(searchParams), { keyEvent: 'search-variants-ffp' });
    }

    function lastSearchParams() {
        return fetchJSON('json/get-last-search-params');
    }

    function clearLastSearchParams() {
        return fetchJSON('json/clear-last-search-params');
    }

    function ffpBonus() {
        return fetchJSON('json/ffp-bonus');
    }

    function ffpBalance(cardNumber) {
        return $q(function (resolve, reject) {
            fetchJSON('json/ffp-balance', 'POST', { cardNumber: cardNumber }).then(function (resp) {
                if (resp.ffpUser) {
                    resolve(resp.ffpUser);
                } else {
                    reject();
                }
            }, reject);
        });
    }

    function searchMonthPeriod(params) {
        return $q(function (resolve, reject) {
            if (!monthSearchConfig.enabled) {
                reject();
                return;
            }
            var existCacheRecord = _.findWhere(cacheMonthSearch, params);
            if (existCacheRecord) {
                resolve(existCacheRecord.resp);
            } else {
                var handleResult = function handleResult(datePrices) {
                    var cacheRecord = angular.copy(params);
                    cacheRecord.resp = datePrices;
                    cacheMonthSearch.push(cacheRecord);
                    resolve(datePrices);
                };
                fetchJSON('json/month-search', 'POST', (0, _extends3.default)({}, params, {
                    searchGroupId: 'standard',
                    adultsCount: 1
                }), {
                    ignoreCaptchaRequired: true,
                    keyEvent: 'month-search-period'
                }).then(function (resp) {
                    if (resp.datePrices) {
                        handleResult(resp.datePrices);
                    } else {
                        handleResult([]);
                    }
                }, function () {
                    handleResult([]);
                });
            }
        });
    }

    function searchCartesianPeriod(searchParams) {
        var apiParams = utils.reformatSearchParams(searchParams);

        apiParams.lang = service.sessionParams.lang;
        apiParams.currency = service.sessionParams.currency;

        if (getParam('search.showCartesianPeriod')) {
            return fetchJSON('json/cartesian-search-period', 'POST', apiParams, {
                ignoreCaptchaRequired: true,
                keyEvent: 'cartesian-search-period'
            });
        } else {
            return $q(function (resolve, reject) {
                reject();
                return;
            });
        }
    }

    function cachedAvailabilityForDirection(apiParams) {
        return $q(function (resolve, reject) {
            var existCacheRecord = _.findWhere(cacheAvailabilityForDirection, apiParams);
            if (existCacheRecord) {
                resolve(existCacheRecord.resp);
            } else {
                fetchJSON('json/get-availability-for-direction', 'POST', apiParams, { ignoreCaptchaRequired: true }).then(function (resp) {
                    var cacheRecord = angular.copy(apiParams);
                    cacheRecord.resp = resp;
                    cacheAvailabilityForDirection.push(cacheRecord);
                    resolve(resp);
                }, reject);
            }
        });
    }

    function routeAvailability(params) {
        if (getParam('search.showAvailabilityForDirection')) {
            return $q.all([cachedAvailabilityForDirection(reformatRouteAvailabilityParams(params, false)), cachedAvailabilityForDirection(reformatRouteAvailabilityParams(params, true))]);
        } else {
            return $q(function (resolve, reject) {
                return reject();
            });
        }
    }

    function routeAvailabilityAdvanced(paramsList) {
        if (getParam('search.showAvailabilityForDirection')) {
            var requestList = paramsList.map(function (params) {
                if (!params.cityA || !params.cityB) {
                    return $q(function (resolve, reject) {
                        reject();
                    });
                } else {
                    return cachedAvailabilityForDirection(reformatRouteAvailabilityParams(params));
                }
            });
            return $q.all(requestList);
        } else {
            return $q(function (resolve, reject) {
                return reject();
            });
        }
    }

    function oneWayAvailabilityRossiya(params) {
        return $q.all([fetchJSON('json/get-rossiya-availability-for-direction', 'POST', reformatRouteAvailabilityParams(params, false), { ignoreCaptchaRequired: true })]);
    }

    function searchVariantsPeriod(searchParams) {
        return fetchJSON('json/search-variants-period', 'POST', utils.reformatSearchParams(searchParams), {
            ignoreCaptchaRequired: true,
            keyEvent: 'search-variants-period'
        });
    }

    function pricingVariantCancel() {
        pricingVariantCanceler.resolve();
    }

    function pricingVariant(selectedVariants, mode, agencyRequest) {
        var apiParams = void 0;

        pricingVariantCanceler = $q.defer();

        if (agencyRequest) {
            apiParams = reformatAgencyPricingVariantParams(selectedVariants, mode);
        } else {
            apiParams = reformatPricingVariantParams(selectedVariants, mode);
        }

        return fetchJSON('json/pricing-variant', 'POST', apiParams, {
            timeout: pricingVariantCanceler.promise,
            keyEvent: 'pricing-variant'
        });
    }

    function pricingVariantMonoBrand(selectedVariant) {
        var pricingVariantCanceler = $q.defer(),
            segments = selectedVariant.segments.map(function (segment) {
            return segment.flights.map(function (flight) {
                return {
                    departure: flight.originport || flight.origincity,
                    arrival: flight.destinationport || flight.destinationcity,
                    departureDate: flight.departuredate,
                    airline: flight.carrier,
                    flightNumber: flight.racenumber
                };
            });
        });

        return fetchJSON('json/pricing-mono-brand', 'POST', {
            segments: JSON.stringify(segments),
            clientId: selectedVariant.clientId
        }, {
            timeout: pricingVariantCanceler.promise,
            keyEvent: 'pricing-mono-brand'
        });
    }

    function addOrderInfoListener(callback, stateCallback, initCall) {
        orderInfoListeners.push(callback);

        if (stateCallback) {
            orderInfoStateListeners.push(stateCallback);
        }

        if (initCall) {
            if (orderInfo) {
                callback(orderInfo);
            }
        }
    }

    function getOrderInfo() {
        return orderInfo;
    }

    function setOrderInfo(data) {
        orderInfo = data;

        orderInfoListeners.forEach(function (cb) {
            cb(orderInfo);
        });
    }

    function clearOrderInfoListeners() {
        orderInfoListeners = [];
    }

    function clearOrderInfo() {
        setOrderInfo(false);
    }

    function updateOrderInfo(sirenaUpdate) {
        orderInfoStateListeners.forEach(function (cb) {
            cb(false);
        });

        return $q(function (resolve, reject) {
            fetchJSON('json/v2/order-info', 'GET', sirenaUpdate ? { sirenaUpdate: sirenaUpdate } : {}, { keyEvent: 'order-info' }).then(function (resp) {
                if (!resp.passengers && !resp.flights) {
                    clearOrderInfo();
                    reject({
                        error: 'web.messages.emptyOrder'
                    });
                    return;
                }
                useSessionTimer = true;
                setOrderInfo(reformatOrderInfo(resp));
                orderInfoStateListeners.forEach(function (cb) {
                    cb(true);
                });
                if (resp.events) {
                    checkOrderEvents(resp.events);
                }
                resolve(getOrderInfo());
            }, reject);
        });
    }

    function passengersCheck() {
        return $q(function (resolve, reject) {
            fetchJSON('json/passengers-check', 'GET', {}, { keyEvent: 'passengers-check' }).then(function (resp) {
                resolve(reformatPassengersCheck(resp));
            }, reject);
        });
    }

    function getPrivatePassengers() {
        return $q(function (resolve, reject) {
            return fetchJSON('json/getPassengers').then(function (resp) {
                resolve(reformatPrivatePassengersList(resp));
            }, reject);
        });
    }

    function passengersAdd(list) {
        return fetchJSON('json/passengers-add', 'POST', reformatPassengersAddList(list), { keyEvent: 'passengers-add' });
    }

    function modifyPassenger(params) {
        return fetchJSON('json/modify-order-passenger', 'POST', params, { keyEvent: 'modify-order-passenger' });
    }

    function updatePassengerPhone(passengerId, phone) {
        var oldPhone = false;
        for (var i = 0; i < orderInfo.passengers.length; i++) {
            if (orderInfo.passengers[i].oldPhone && orderInfo.passengers[i].id === passengerId) {
                oldPhone = orderInfo.passengers[i].oldPhone;
            }
        }
        var request = {};
        if (oldPhone) {
            if (phone) {
                request.modify = [{ oldPhone: oldPhone, newPhone: phone, oldPassengerId: passengerId }];
            } else {
                request.remove = [{ phone: oldPhone, passengerId: passengerId }];
            }
        } else {
            request.add = [{ phone: phone, passengerId: passengerId }];
        }
        return $q(function (resolve, reject) {
            fetchJSON('json/modify-contacts', 'POST', { request: JSON.stringify(request) }, { keyEvent: 'modify-order-passenger' }).then(function (resp) {
                for (var _i = 0; _i < orderInfo.passengers.length; _i++) {
                    if (orderInfo.passengers[_i].id === passengerId) {
                        orderInfo.passengers[_i].oldPhone = phone;
                    }
                }
                resolve(resp);
            }, reject);
        });
    }

    function customerAdd(params) {
        return fetchJSON('json/customer-add', 'POST', params, { keyEvent: 'customer-add' });
    }

    function getBrandConfig() {
        return brandsList;
    }

    function getBannersConfig() {
        return bannersList;
    }

    function getFfpCompareConfig() {
        return ffpCompareConfig;
    }

    function getRefundConfig() {
        return refundConfig;
    }

    function getSearchGroupsConfig() {
        return searchGroupsConfig;
    }

    function getTaxesGroupsList() {
        return taxesGroupsList;
    }

    function getEnvironmentUrls() {
        return environmentUrls;
    }

    function getEnvironmentUrl(code) {
        return environmentUrls[code] || false;
    }

    function getPhoneCodesMask() {
        return phoneCodesMask;
    }

    function getBrandByCode(code) {
        var i = 0;

        while (i < brandsList.length) {
            if (brandsList[i].code === code) {
                return brandsList[i];
            }

            i++;
        }

        return false;
    }

    function getBannerByCode(code) {
        var i = 0;
        while (i < bannersList.length) {
            if (bannersList[i].code === code) {
                return bannersList[i];
            }

            i++;
        }

        return false;
    }

    function getBrandName(code) {
        var brand = getBrandByCode(code);

        var brandName = '';

        if (brand) {
            brandName = brand.name;
        }

        return brandName;
    }

    function getBrandProps(code, available) {
        var brand = getBrandByCode(code);

        var props = [];

        if (brand) {
            props = brand.props.filter(function (prop) {
                return prop.available === available;
            }).map(function (prop) {
                var str = prop.name;

                if (prop.count) {
                    str += ' ' + prop.count;
                } else if (prop.shortDesc) {
                    str += ' ' + prop.shortDesc;
                }

                return str;
            });
        }

        return props;
    }

    function checkBrandExist(brandCode) {
        if (brandCode) {
            if (getBrandByCode(brandCode)) {
                return true;
            }
            // eslint-disable-next-line
            console.log('Brand not exist: ', brandCode);

            sendErrorReport('CONFIG_ERROR', 'Brand not exist: ' + brandCode);
        }
        return false;
    }

    function getRemark() {
        return fetchJSON('json/remark', 'GET', {}, { keyEvent: 'remark' });
    }

    function getExchangeRemark() {
        return fetchJSON('json/exchange-remark', 'GET', {}, { keyEvent: 'exchange-remark' });
    }

    function ffpLogout() {
        return fetchJSON('json/ffp-logout', 'GET', {}, { keyEvent: 'ffp-logout' });
    }

    function ffpLogin(params) {
        return $q(function (resolve, reject) {
            fetchJSON('json/ffp-login', 'POST', {
                ffp_card_number: params.ffpCardNumber,
                ffp_card_password: params.ffpCardPassword
            }, { keyEvent: 'ffp-login' }).then(function (resp) {
                if (resp.ffpUser) {
                    resolve(resp.ffpUser);
                } else {
                    reject();
                }
            }, reject);
        });
    }

    function saveProfile(params) {
        return $q(function (resolve, reject) {
            fetchJSON('json/update-profile', 'POST', params, { keyEvent: 'update-profile' }).then(function (resp) {
                resolve(resp);

                service.sessionParams.authoriseCustomer.firstName = params.firstName;
                service.sessionParams.authoriseCustomer.lastName = params.lastName;
                service.sessionParams.authoriseCustomer.phone = params.phone;
            }, reject);
        });
    }

    function deleteProfile() {
        return fetchJSON('json/remove-profile', 'POST', {}, { keyEvent: 'delete-profile' });
    }

    function changePassword(params) {
        return fetchJSON('json/change-password', 'POST', {
            'newPassword[]': params.newPassword,
            oldPassword: params.oldPassword
        }, { keyEvent: 'change-password' });
    }

    function priceVariant() {
        return $q(function (resolve, reject) {
            fetchJSON('json/available-payment-forms-and-prices', 'GET', {}, { keyEvent: 'pricevariant' }).then(function (resp) {
                var priceVariantData = reformatPriceVariant(resp);
                resolve(priceVariantData);
            }, reject);
        });
    }

    function paymentVariants() {
        return $q(function (resolve, reject) {
            fetchJSON('json/available-payment-forms-and-prices', 'GET', {}, { keyEvent: 'paymentVariants' }).then(function (resp) {
                var paymentVariants = reformatPaymentVariants(resp);
                resolve(paymentVariants);
            }, reject);
        });
    }

    function eraseConflictServices(params) {
        return fetchJSON('json/erase-extra-service', 'POST', params, { keyEvent: 'erase-extra-service' });
    }

    function removePaymentCard(cardToken) {
        return fetchJSON('json/delete-card', 'POST', {
            'card_token': cardToken
        });
    }

    function confirmRemoveProfile(removeProfileToken, userRole) {
        return fetchJSON('json/confirm-remove-profile', 'POST', { removeProfileToken: removeProfileToken, userRole: userRole });
    }

    function changePayMethod(fic, paymentType, orderEmail) {
        var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
            card_token = _ref.card_token,
            save_new_card = _ref.save_new_card;

        var params = {
            fic: fic,
            customerEmail: orderEmail,
            card_token: card_token,
            save_new_card: save_new_card
        };

        if (paymentType !== fic) {
            params.paymentType = paymentType;
        }

        return fetchJSON('json/change-payment-form-after-booking', 'POST', params);
    }

    function calculateYnaoDiscount(passengerSegments) {
        return fetchJSON('json/calculate-ynao-discount', 'POST', {
            passengerSegments: JSON.stringify(passengerSegments)
        });
    }

    function getScannedDocs() {
        return fetchJSON('json/get-scanned-docs');
    }

    function removeScannedDoc(passengerIndex, fileIndex) {
        return fetchJSON('json/remove-scanned-doc', 'POST', { passengerIndex: passengerIndex, fileIndex: fileIndex });
    }

    function uploadScannedDoc(passengerIndex, fileName, data) {
        return fetchJSON('json/upload-scanned-doc', 'POST', { passengerIndex: passengerIndex, fileName: fileName, data: data });
    }

    function getFakeExchangeVariants() {
        return {
            "result": "ok",
            "flights": [[{
                "available": true,
                "flightTime": "02:20",
                "chainId": "42",
                "connections": [],
                "flights": [{
                    "company": {
                        "code_en": "UT",
                        "name_en": "UTAIR AVIATION PJSC",
                        "code": "UT",
                        "name": "UTAIR AVIATION PJSC"
                    },
                    "racenumber": "249",
                    "departuredate": "26.07.2019",
                    "departuretime": "11:10",
                    "arrivaldate": "26.07.2019",
                    "arrivaltime": "13:30",
                    "delaydays": "0",
                    "departuredayshift": 0,
                    "arrivaldayshift": 0,
                    "airplane": "737",
                    "airplaneName": "BOEING 737 PASSENGER",
                    "vehicleCodeEn": "737",
                    "destinationcity": "AER",
                    "destinationcityName": "Sochi",
                    "origincity": "MOW",
                    "origincityName": "Moscow",
                    "originport": "VKO",
                    "originportName": "Vnukovo",
                    "originTerminal": "A",
                    "flighttime": "02:20",
                    "seatsFound": 4,
                    "landingsAmount": 0
                }],
                "flightsInfo": {
                    "origincityName": "Moscow",
                    "origincity": "MOW",
                    "originportName": "Vnukovo",
                    "originport": "VKO",
                    "destinationcityName": "Sochi",
                    "destinationcity": "AER",
                    "departuretime": "11:10",
                    "departuredate": "26.07.2019",
                    "departuredayshift": 0,
                    "arrivaltime": "13:30",
                    "arrivaldate": "26.07.2019",
                    "arrivaldayshift": 0,
                    "flighttime": "02:20",
                    "landings": [],
                    "connections": [],
                    "connectionsMessage": "Non-stop flight"
                },
                "landingsAmount": 0
            }], [{
                "available": true,
                "flightTime": "00:30",
                "chainId": "43",
                "connections": [],
                "flights": [{
                    "company": {
                        "code_en": "UT",
                        "name_en": "UTAIR AVIATION PJSC",
                        "code": "UT",
                        "name": "UTAIR AVIATION PJSC"
                    },
                    "racenumber": "580",
                    "departuredate": "30.08.2019",
                    "departuretime": "06:00",
                    "arrivaldate": "30.08.2019",
                    "arrivaltime": "06:30",
                    "delaydays": "0",
                    "departuredayshift": 0,
                    "arrivaldayshift": 0,
                    "airplane": "737",
                    "airplaneName": "BOEING 737 PASSENGER",
                    "vehicleCodeEn": "737",
                    "destinationcity": "MOW",
                    "destinationcityName": "Moscow",
                    "origincity": "AER",
                    "origincityName": "Sochi",
                    "destinationport": "VKO",
                    "destinationportName": "Vnukovo",
                    "destinationTerminal": "A",
                    "flighttime": "00:30",
                    "seatsFound": 9,
                    "landingsAmount": 0
                }],
                "flightsInfo": {
                    "origincityName": "Sochi",
                    "origincity": "AER",
                    "destinationcityName": "Moscow",
                    "destinationcity": "MOW",
                    "destinationportName": "Vnukovo",
                    "destinationport": "VKO",
                    "departuretime": "06:00",
                    "departuredate": "30.08.2019",
                    "departuredayshift": 0,
                    "arrivaltime": "06:30",
                    "arrivaldate": "30.08.2019",
                    "arrivaldayshift": 0,
                    "flighttime": "00:30",
                    "landings": [],
                    "connections": [],
                    "connectionsMessage": "Non-stop flight"
                },
                "landingsAmount": 0
            }, {
                "available": true,
                "flightTime": "02:00",
                "chainId": "44",
                "connections": [],
                "flights": [{
                    "company": {
                        "code_en": "UT",
                        "name_en": "UTAIR AVIATION PJSC",
                        "code": "UT",
                        "name": "UTAIR AVIATION PJSC"
                    },
                    "racenumber": "250",
                    "departuredate": "30.08.2019",
                    "departuretime": "14:30",
                    "arrivaldate": "30.08.2019",
                    "arrivaltime": "16:30",
                    "delaydays": "0",
                    "departuredayshift": 0,
                    "arrivaldayshift": 0,
                    "airplane": "737",
                    "airplaneName": "BOEING 737 PASSENGER",
                    "vehicleCodeEn": "737",
                    "destinationcity": "MOW",
                    "destinationcityName": "Moscow",
                    "origincity": "AER",
                    "origincityName": "Sochi",
                    "destinationport": "VKO",
                    "destinationportName": "Vnukovo",
                    "destinationTerminal": "A",
                    "flighttime": "02:00",
                    "seatsFound": 9,
                    "landingsAmount": 0
                }],
                "flightsInfo": {
                    "origincityName": "Sochi",
                    "origincity": "AER",
                    "destinationcityName": "Moscow",
                    "destinationcity": "MOW",
                    "destinationportName": "Vnukovo",
                    "destinationport": "VKO",
                    "departuretime": "14:30",
                    "departuredate": "30.08.2019",
                    "departuredayshift": 0,
                    "arrivaltime": "16:30",
                    "arrivaldate": "30.08.2019",
                    "arrivaldayshift": 0,
                    "flighttime": "02:00",
                    "landings": [],
                    "connections": [],
                    "connectionsMessage": "Non-stop flight"
                },
                "landingsAmount": 0
            }]]
        };
    }

    function markTrackingEventProcessed(event_id) {
        return fetchJSON('json/mark-event-processed-by-js', 'POST', { event_id: event_id });
    }

    function doBookingAndRegisterOrder(paymentForm, paymentType, removeInsuranceAeroexpress) {
        var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
            card_token = _ref2.card_token,
            save_new_card = _ref2.save_new_card;

        var params = {
            'payment-form': paymentForm,
            'payment-type': paymentType || paymentForm,
            'removeInsuranceAeroexpress': removeInsuranceAeroexpress || false,
            card_token: card_token,
            save_new_card: save_new_card
        };

        return $q(function (resolve, reject) {
            fetchJSON('json/do-booking-and-register-order', 'POST', params, {
                keyEvent: 'do-booking-and-register-order'
            }).then(function (resp) {
                resolve(reformatExtraServicesPayment(resp));
            }, reject);
        });
    }

    function startPaymentForExtraServices(paymentForm, paymentType, removeInsuranceAeroexpress, contacts) {
        var _ref3 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
            card_token = _ref3.card_token,
            save_new_card = _ref3.save_new_card;

        var extraServicesToRemove = arguments[5];

        var params = {
            'payment-form': paymentForm,
            'payment-type': paymentType || paymentForm,
            'removeInsuranceAeroexpress': removeInsuranceAeroexpress || false,
            card_token: card_token,
            save_new_card: save_new_card,
            extraServicesToRemove: JSON.stringify(extraServicesToRemove)
        };

        if (contacts) {
            if (contacts.email) {
                params.email = contacts.email;
            }
            if (contacts.phone) {
                params.phone = contacts.phone;
            }
            if (contacts.contactsPassengerId) {
                params.contactsPassengerId = contacts.contactsPassengerId;
            }
        }

        return $q(function (resolve, reject) {
            fetchJSON('json/start-payment-for-extra-services', 'POST', params, {
                keyEvent: 'start-payment-for-extra-services'
            }).then(function (resp) {
                if (resp.priceChanges && resp.priceChanges.length) {
                    servicesPriceChangesHandler(resp.priceChanges);
                }
                resolve(reformatExtraServicesPayment(resp));
            }, reject);
        });
    }

    function retryRegister(removeInsuranceAeroexpress, contacts) {
        var params = { removeInsuranceAeroexpress: removeInsuranceAeroexpress || false };
        if (contacts) {
            if (contacts.email) {
                params.email = contacts.email;
            }
            if (contacts.phone) {
                params.phone = contacts.phone;
            }
            if (contacts.contactsPassengerId) {
                params.contactsPassengerId = contacts.contactsPassengerId;
            }
        }
        return checkOrderEmail(function () {
            return fetchJSON('json/retry-register', 'POST', params, { keyEvent: 'retry-register' });
        });
    }

    function waitPayment(pnr, lastName, loopNumber) {
        if (!loopNumber) {
            loopNumber = 0;
        }

        return $q(function (resolve, reject) {
            fetchJSON('json/payment-status', 'POST', {
                pnr: pnr,
                lastName: lastName
            }, { keyEvent: 'payment-status' }).then(function (resp) {
                if (resp.result === 'paid') {
                    resolve();
                } else if (resp.result === 'being_paid') {
                    if (loopNumber >= getParam('payment.maxAttemptsPaymentStatus')) {
                        reject({ error: 'web.messages.maxAttemptsPaymentStatus' });
                    } else {
                        $timeout(function () {
                            waitPayment(pnr, lastName, loopNumber + 1).then(resolve, reject);
                        }, getParam('payment.timeoutPaymentStatus') * 1000);
                    }
                } else if (resp.result === 'cannot_be_paid') {
                    reject({ error: 'web.messages.cannotBePaid' });
                } else {
                    reject({ error: 'web.messages.waitPaymentError' });
                }
            }, reject);
        });
    }

    function getDocumentsList() {
        return $q(function (resolve, reject) {
            fetchJSON('json/documents-dictionary').then(function (list) {
                resolve(list.map(function (doc) {
                    if (doc.nationality) {
                        doc.expiry = service.sessionParams.todayDate;
                    }

                    return doc;
                }));
            }, reject);
        });
    }

    function getAvailableDocumentsForAeroexpress(params) {
        return fetchJSON('json/available-documents-for-aeroexpress', 'POST', params);
    }

    function savePrivatePassengers(list) {
        return fetchJSON('json/savePassengers', 'POST', reformatPrivatePassengersSaveList(list));
    }

    function addPrivatePassenger(pax) {
        var passenger = reformatPrivatePassengerSaveItem(pax);
        return fetchJSON('json/add-user-passenger', 'POST', {
            request: JSON.stringify({ passenger: passenger })
        });
    }

    function modifyPrivatePassenger(pax) {
        var passenger = reformatPrivatePassengerSaveItem(pax);
        return fetchJSON('json/modify-user-passenger', 'POST', {
            request: JSON.stringify({ passenger: passenger })
        });
    }

    function removePrivatePassenger(id) {
        return fetchJSON('json/remove-user-passengers', 'POST', {
            request: JSON.stringify({ passengerIds: [id] })
        });
    }

    function getBonusPrograms() {
        return fetchJSON('json/get-bonus-programs');
    }

    function getUserBankDetailsList() {
        return fetchJSON('json/user-bank-details-list-get');
    }

    function saveUserBankDetailsList(list) {
        return $q.all(list.map(function (bankDetails) {
            return fetchJSON('json/user-bank-details-list-update', 'POST', bankDetails);
        }));
    }

    function getOrders(params) {
        params = params || {};
        params.searchType = params.searchType || 'USER';

        return $q(function (resolve, reject) {
            fetchJSON('json/getOrders', 'POST', params).then(function (resp) {
                var ordersList = resp.orders || [];

                ordersList.sort(function (a, b) {
                    return -1 * utils.compareStringDateTime(a.book_time, b.book_time);
                });

                resolve(ordersList);
            }, reject);
        });
    }

    function searchOrder(number, lastName, withoutUpdateOrderInfo) {
        var params = {
            lastName: lastName,
            agreeWithSearchConditions: true
        };

        params[number.length > 6 ? 'ticket' : 'pnr'] = number;

        useSessionTimer = true;

        return $q(function (resolve, reject) {
            fetchJSON('json/search-order', 'POST', params, { keyEvent: 'search-order' }).then(function () {
                if (withoutUpdateOrderInfo) {
                    resolve();
                } else {
                    updateOrderInfo().then(resolve, reject);
                }
            }, reject);
        });
    }

    function searchOrderByToken(token) {
        return fetchJSON('json/search-order', 'POST', { token: token }, { keyEvent: 'search-order' });
    }

    function searchOrderByParams(params, addToExistingOrder) {
        var apiParams = angular.copy(params);
        if (apiParams.pnrOrTicketNumber) {
            apiParams[apiParams.pnrOrTicketNumber.length > 6 ? 'ticket' : 'pnr'] = apiParams.pnrOrTicketNumber;
            delete apiParams.pnrOrTicketNumber;
        } else if (getParam('site.searchOrdersBy') === 'LAST_NAME_PNR_TICKET') {
            if (params.pnr) {
                apiParams.pnr = params.pnr;
            } else if (params.ticket) {
                apiParams.ticket = params.ticket;
            }
        } else if (getParam('site.searchOrdersBy') === 'LAST_NAME_TICKET') {
            if (params.ticket) {
                apiParams.ticket = params.ticket;
            }
        }
        apiParams.agreeWithSearchConditions = true;
        apiParams.mode = addToExistingOrder ? 'add_to_order' : 'new_search';
        useSessionTimer = true;
        return fetchJSON('json/search-order', 'POST', apiParams, { keyEvent: 'search-order' });
    }

    function searchFvSpecialOrderByParams(params) {
        var apiParams = angular.copy(params);
        apiParams.agreeWithSearchConditions = true;
        useSessionTimer = true;
        return fetchJSON('json/search-rossiya-special-order', 'POST', apiParams);
    }

    function finishSeparatePassengersSearch() {
        return fetchJSON('json/search-order', 'POST', {
            mode: 'finish_separate_search',
            agreeWithSearchConditions: true
        }, { keyEvent: 'finish-separate-search-order' });
    }

    function quickSearchHandler(paramsList, recall) {
        return $q(function (resolve, reject) {
            searchOrderByParams(paramsList[0], recall).then(function (resp) {
                if (paramsList.length > 1) {
                    var paramsListCopy = angular.copy(paramsList);
                    paramsListCopy.shift();
                    quickSearchHandler(paramsListCopy, true).then(resolve, reject);
                } else if (resp.orderCompletelyInitialized) {
                    resolve();
                } else {
                    finishSeparatePassengersSearch().then(resolve, reject);
                }
            }, reject);
        });
    }

    function getExtraServices() {
        return fetchJSON('json/v2/extra-services-new', 'GET', {}, { keyEvent: 'extra-services-new' });
    }

    function addUpdateOrderServicesListener(successCallback, errorCallback) {
        orderServicesListeners.push({
            success: successCallback,
            error: errorCallback
        });
    }

    function clearUpdateOrderServicesListeners() {
        orderServicesListeners = [];
    }

    function updateOrderServices(needUpdatePaymentVariants) {
        if (needUpdatePaymentVariants) {
            needUpdatePaymentVariantsGlobalState = true;
        }

        return $q(function (resolve, reject) {
            getExtraServices().then(function (extraServicesResp) {
                updateOrderInfo().then(function (orderInfoResp) {
                    var extraServicesRespSorted = sortExtraServices(mergeExtraServicesUnavailableBecauseOfCheckIn(extraServicesResp.extraServices, extraServicesResp.svcsUnavailableBecauseOfCheckIn, orderInfoResp, extraServicesResp.checkinStatus));
                    var availableBundlesByPassengerSegments = getAvailableBundlesByPassengerSegments(extraServicesResp.availableSvcsBundles, orderInfoResp);
                    if (needUpdatePaymentVariants || needUpdatePaymentVariantsGlobalState) {
                        paymentVariants().then(function (paymentVariants) {
                            handleSuccess([extraServicesRespSorted, orderInfoResp, paymentVariants, availableBundlesByPassengerSegments]);
                        }, handleError);
                    } else {
                        handleSuccess([extraServicesRespSorted, orderInfoResp, false, availableBundlesByPassengerSegments]);
                    }
                }, handleError);
            }, handleError);

            function handleSuccess(resp) {
                orderServicesListeners.forEach(function (listener) {
                    if (listener.success) {
                        listener.success(resp);
                    }
                });

                resolve(resp);

                return resp;
            }

            function handleError(resp) {
                orderServicesListeners.forEach(function (listener) {
                    if (listener.error) {
                        listener.error(resp);
                    }
                });

                reject(resp);

                return resp;
            }
        });
    }

    function sortExtraServices(list) {
        var definedOrder = void 0;
        if (getParam('extraServices.order')) {
            try {
                definedOrder = JSON.parse(getParam('extraServices.order'));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Invalid extraServices.order: ', err);
                sendErrorReport('CONFIG_ERROR', 'Invalid extraServices.order', err.message);
            }
        }
        if (definedOrder) {
            return definedOrder.map(function (code) {
                return _.findWhere(list, { code: code });
            }).filter(function (item) {
                return !!item;
            });
        } else {
            return list;
        }
    }

    function mergeExtraServicesUnavailableBecauseOfCheckIn(extraServices, svcsUnavailableBecauseOfCheckIn, orderInfo, checkinStatus) {
        if (svcsUnavailableBecauseOfCheckIn && svcsUnavailableBecauseOfCheckIn.length && _.findWhere(svcsUnavailableBecauseOfCheckIn, { groupCode: 'seat' })) {

            var seatService = _.findWhere(extraServices, { code: 'seat' });
            var unavailableSegments = orderInfo.plainFlights.map(function (segment) {
                return !!_.findWhere(svcsUnavailableBecauseOfCheckIn, {
                    groupCode: 'seat',
                    segmentId: segment.id
                });
            });
            var checkinStatusBySegments = false;

            if (checkinStatus) {
                checkinStatusBySegments = orderInfo.plainFlights.map(function (segment) {
                    return _.findWhere(checkinStatus, {
                        segmentId: segment.id
                    });
                });
            }

            if (!seatService) {
                extraServices.push({
                    code: 'seat',
                    svcs: [],
                    unavailableBecauseOfCheckInBySegments: unavailableSegments,
                    checkinStatusBySegments: checkinStatusBySegments
                });
            } else {
                seatService.unavailableBecauseOfCheckInBySegments = unavailableSegments;
                seatService.checkinStatusBySegments = checkinStatusBySegments;
            }
        }

        return extraServices;
    }

    function getAvailableBundlesByPassengerSegments(availableSvcsBundles, orderInfo) {
        return orderInfo.passengers.map(function (passenger) {
            return orderInfo.plainFlights.map(function (flight) {
                return _.where(availableSvcsBundles, {
                    passengerId: passenger.id,
                    segmentId: flight.id
                }).map(function (item) {
                    return item.ssr;
                });
            });
        });
    }

    function switchDefaultSelectedServices(esList, es, orderInfo) {
        var defaultSelectedServices = (esList || []).filter(function (code) {
            return !es[code].active && es[code].defaultSelected;
        }).map(function (code) {

            if (code === 'meal') {
                return getDefaultSelectedServiceItems(es[code], orderInfo);
            } else {
                return { code: code };
            }
        }),
            queue = void 0;

        defaultSelectedServices = _.flatten(defaultSelectedServices);

        if (defaultSelectedServices.length) {
            defaultSelectedServices.forEach(function (params, num) {
                var isLast = num === defaultSelectedServices.length - 1;
                if (!queue) {
                    queue = modifyExtraService(params, !isLast);
                } else {
                    queue = queue.then(function () {
                        return modifyExtraService(params, !isLast);
                    });
                }
            });

            return queue;
        } else {
            return $q(function (resolve) {
                resolve();
            });
        }
    }

    function getDefaultSelectedServiceItems(service, orderInfo) {
        var defaultSelectedServiceItems = [];

        service.itemsByPassengerSegments.forEach(function (itemsByPassenger, passengerNum) {
            if (itemsByPassenger && itemsByPassenger.length) {
                itemsByPassenger.forEach(function (itemsBySubgroups, segmentNum) {
                    if (itemsBySubgroups && itemsBySubgroups.length) {
                        itemsBySubgroups.forEach(function (items, subgroupNum) {
                            if (items && items.length) {
                                items.forEach(function (item) {
                                    if (item.shouldSelectByDefault) {
                                        defaultSelectedServiceItems.push({
                                            code: service.code,
                                            rfisc: item.rfisc,
                                            passenger_id: orderInfo.passengers[passengerNum].id,
                                            segment_id: orderInfo.plainFlights[segmentNum].id,
                                            subgroup: service.subgroups[subgroupNum]
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        return defaultSelectedServiceItems;
    }

    function modifyExtraService(params, preventUpdate) {
        extraServiceListeners.forEach(function (cb) {
            cb(false);
        });

        return $q(function (resolve, reject) {
            fetchJSON('json/extra-services-modify', 'POST', params, { keyEvent: 'extra-services-modify' }).then(function (resp) {
                if (preventUpdate) {
                    resolve();
                } else {
                    updateOrderServices().then(resolve, reject);
                }
                if (resp.priceChanges && resp.priceChanges.length) {
                    servicesPriceChangesHandler(resp.priceChanges);
                }

                extraServiceListeners.forEach(function (cb) {
                    cb(true);
                });
            }, function (resp) {
                if (preventUpdate) {
                    reject(resp);
                } else {
                    updateOrderServices().then(function () {
                        reject(resp);
                    }, function () {
                        reject(resp);
                    });
                }

                extraServiceErrorListeners.forEach(function (cb) {
                    cb(resp, params);
                });
            });
        });
    }

    function removeExtraService(params, preventUpdateOrderServices, preventUpdateServices) {
        extraServiceListeners.forEach(function (cb) {
            cb(false);
        });

        return $q(function (resolve, reject) {
            fetchJSON('json/extra-services-remove', 'POST', params, { keyEvent: 'extra-services-remove' }).then(function (resp) {
                if (preventUpdateOrderServices) {
                    resolve();
                } else if (preventUpdateServices) {
                    updateOrderInfo().then(resolve, reject);
                } else {
                    updateOrderServices().then(resolve, reject);
                }
                if (resp.priceChanges && resp.priceChanges.length) {
                    servicesPriceChangesHandler(resp.priceChanges);
                }

                extraServiceListeners.forEach(function (cb) {
                    cb(true);
                });
            }, function (resp) {
                if (preventUpdateOrderServices) {
                    reject(resp);
                } else if (preventUpdateServices) {
                    updateOrderInfo().then(resolve, reject);
                } else {
                    updateOrderServices().then(function () {
                        reject(resp);
                    }, function () {
                        reject(resp);
                    });
                }

                extraServiceErrorListeners.forEach(function (cb) {
                    cb(resp, params);
                });
            });
        });
    }

    function setServicesPriceChangesHandler(cb) {
        servicesPriceChangesHandler = cb;
    }

    function addExtraServiceListener(cb) {
        extraServiceListeners.push(cb);
    }

    function addExtraServiceErrorListener(cb) {
        extraServiceErrorListeners.push(cb);
    }

    function aeroexpressSchedule(params) {
        return fetchJSON('json/aeroexpress-schedule', 'POST', params);
    }

    function seatMap(passenger_id, segment_id, imgPath) {
        var deckByCode = {
            U: 'UPPER',
            L: 'LOWER',
            M: 'COMMON'
        };
        var selectedSeats = [];
        if (orderInfo.allExtraServicesHeap) {
            orderInfo.allExtraServicesHeap.forEach(function (item) {
                if (item.groupCode === 'seat' && item.value && (item.mainSegmentId === segment_id || item.segmentId === segment_id)) {
                    selectedSeats.push(item.value);
                }
            });
        }
        return $q(function (resolve, reject) {
            fetchJSON('json/seat-map', 'POST', {
                passenger_id: passenger_id,
                segment_id: segment_id
            }, { keyEvent: 'seat-map' }).then(function (resp) {
                if (resp.template && getParam('extraServices.useSvgAircraftScheme')) {
                    $q.all(resp.decks.map(function (deck) {
                        return $http.get(imgPath + '/' + resp.template + '/' + deckByCode[deck.code] + '.svg?buildNumber=' + o2context.buildNumber);
                    })).then(function (respSvg) {
                        resolve(utils.reformatSeatMapWithImages(resp, respSvg, selectedSeats));
                    }, function () {
                        resolve(utils.reformatSeatMap(resp, getParam('extraServices.seatMapGridSplitByCabin'), selectedSeats));
                    });
                } else {
                    resolve(utils.reformatSeatMap(resp, getParam('extraServices.seatMapGridSplitByCabin'), selectedSeats));
                }
            }, reject);
        });
    }

    function getSvcs(departureCity, arrivalCity, departureDate) {
        return $q(function (resolve, reject) {
            fetchJSON('json/rossiya-widget-svcs', 'POST', { departureCity: departureCity, arrivalCity: arrivalCity, departureDate: departureDate }, { keyEvent: 'rossiya-widget-svcs' }).then(function (resp) {
                resolve(utils.reformatSvcs(resp));
            }, reject);
        });
    }

    function flownStatus(mode) {
        var params = { url: getCurrentLocation() };

        if (mode) {
            params.mode = mode;
        }

        return $q(function (resolve, reject) {
            fetchJSON('json/flown-status', 'POST', params, { keyEvent: 'flown-status' }).then(function (resp) {
                resolve(reformatFlownStatus(resp, orderInfo, getParam('site.refundManual')));
            }, reject);
        });
    }

    function calcRefund(passengers) {
        return fetchJSON('json/calc-refund', 'POST', { passengers: JSON.stringify(passengers) }, { keyEvent: 'calc-refund' });
    }

    function manualRefund(params) {
        return fetchJSON('json/manual-refund', 'POST', {
            eMail: params.eMail,
            phone: params.phone,
            passengers: JSON.stringify(params.passengers)
        }, { keyEvent: 'manual-refund' });
    }

    function confirmRefund(orgTotalSummRefund, passengers) {
        return checkOrderEmail(function () {
            return fetchJSON('json/refund', 'POST', {
                orgTotalSummRefund: orgTotalSummRefund,
                passengers: JSON.stringify(passengers)
            }, { keyEvent: 'confirm-refund' });
        });
    }

    function cancelOrder() {
        return fetchJSON('json/cancel-order', 'POST', {}, { keyEvent: 'cancel-order' });
    }

    function addFfpCards(passengers) {
        return fetchJSON('json/add-ffp-cards', 'POST', {
            passengers: JSON.stringify(passengers)
        });
    }

    function modifyParent(params) {
        return fetchJSON('json/modify-parent', 'POST', params);
    }

    function exchangeVariants(selectedState) {

        var params = getParam('site.exchangeConnectingFlightsMode') === 'SEGMENTS_CHAIN' ? { selectedPassengerSegmentChains: JSON.stringify(selectedState) } : { selectedPassengerSegments: JSON.stringify(selectedState) };

        return $q(function (resolve, reject) {
            fetchJSON('json/exchange-variants', 'POST', params, { keyEvent: 'exchange-variants' }).then(function (resp) {
                if (resp.segments) {
                    var _loop = function _loop(segNum) {
                        var chainIds = _.keys(resp.segments[segNum].newSegmentChains);
                        var hasAvailableChain = false;

                        if (resp.segments[segNum].newSegmentChains) {

                            chainIds.forEach(function (chainId) {
                                if (resp.segments[segNum].newSegmentChains[chainId].available) {
                                    hasAvailableChain = true;
                                } else {
                                    delete resp.segments[segNum].newSegmentChains[chainId];
                                }
                            });

                            if (!hasAvailableChain) {
                                reject({ error: 'web.messages.emptyExchangeVariantsList' });
                                return {
                                    v: void 0
                                };
                            }
                        }
                    };

                    for (var segNum = 0; segNum < resp.segments.length; segNum++) {
                        var _ret = _loop(segNum);

                        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
                    }
                    resolve(resp);
                }
            }, reject);
        });
    }

    function exchangeSelect(chains, brand) {
        var params = { ids: JSON.stringify(chains) };
        if (brand) {
            params.brand = brand;
        }
        return fetchJSON('json/exchange-select', 'POST', params, { keyEvent: 'exchange-select' });
    }

    function exchangeConfirm(params) {
        return checkOrderEmail(function () {
            return fetchJSON('json/exchange-confirm', 'POST', params, { keyEvent: 'exchange-confirm' });
        });
    }

    function sunInfo(origincity, departuredate, departuretime, destinationcity, arrivaldate, arrivaltime) {
        return $q(function (resolve, reject) {
            fetchJSON('json/sun-info', 'POST', {
                path: origincity + '/' + departuredate.split('.').reverse().join('-') + 'T' + departuretime + ':00' + ('/' + destinationcity + '/' + arrivaldate.split('.').reverse().join('-') + 'T' + arrivaltime + ':00')
            }).then(function (resp) {
                try {
                    resolve(resp.message);
                } catch (err) {
                    // eslint-disable-next-line
                    console.log('Invalid sun-info resp: ', err);

                    reject();
                }
            }, reject);
        });
    }

    function clearSession() {
        return fetchJSON('json/clear-session');
    }

    function clearOrderFromSession() {
        return fetchJSON('json/remove-order-from-session');
    }

    function getBookingLimits() {
        return {
            min: moment(service.sessionParams.todayDate, 'DD.MM.YYYY').add(service.getParam('search.minDayBooking'), 'days').toDate(),
            max: moment(service.sessionParams.todayDate, 'DD.MM.YYYY').add(service.getParam('search.maxDayBooking'), 'days').toDate()
        };
    }

    function getSoftBookingLimits() {
        return {
            min: moment.utc(o2context.serverDateTime).add(service.getParam('search.minDayBooking'), 'days'),
            max: moment.utc(o2context.serverDateTime).add(service.getParam('search.maxDayBooking'), 'days')
        };
    }

    function setSwitchCurrencyLanguageListener(cb) {
        switchCurrencyLanguageListener = cb;
    }

    function switchCurrencyLanguage(language, currency) {
        return $q(function (resolve, reject) {
            fetchJSON('json/modify-language-and-currency', 'POST', {
                lang: language,
                currency: currency
            }, { keyEvent: 'modify-language-and-currency' }).then(function (resp) {
                if (switchCurrencyLanguageListener) {
                    switchCurrencyLanguageListener(language, currency);
                }

                resolve(resp);
            }, reject);
        });
    }

    function switchCurrency(currency) {
        return $q(function (resolve, reject) {
            fetchJSON('json/modify-language-and-currency', 'POST', {
                currency: currency,
                isOrderBooked: orderInfo && orderInfo.header && orderInfo.header.regnum
            }, { keyEvent: 'modify-language-and-currency' }).then(function (resp) {
                if (switchCurrencyLanguageListener) {
                    switchCurrencyLanguageListener(false, currency);
                }

                resolve(resp);
            }, reject);
        });
    }

    function switchLanguage(language) {
        return $q(function (resolve, reject) {
            fetchJSON('json/modify-language-and-currency', 'POST', {
                lang: language
            }, { keyEvent: 'modify-language-and-currency' }).then(function (resp) {
                if (switchCurrencyLanguageListener) {
                    switchCurrencyLanguageListener(language, false);
                }

                resolve(resp);
            }, reject);
        });
    }

    function setCaptchaRequiredHandler(handler) {
        captchaRequiredHandler = handler;
    }

    function setOrderEmailRequiredHandler(handler) {
        orderEmailRequiredHandler = handler;
    }

    function sendErrorReport(type, message, details) {
        return fetchJSON('json/add-error', 'POST', {
            type: type,
            value: message,
            details: details,
            direct: 'yes'
        });
    }

    function sendReceipt(mailingList) {
        return fetchJSON('json/receipt-mail-send', 'POST', { emails: mailingList.join(',') }, { keyEvent: 'receipt-mail-send' });
    }

    function requestIssueTickets(mode) {
        return checkOrderEmail(function () {
            return fetchJSON('json/payment-' + mode);
        });
    }

    function confirmIssueTickets(mode, issueInfo) {
        return fetchJSON('json/payment-' + mode, 'POST', {
            confirm: '1',
            paymentForm: issueInfo.paymentForm || '',
            sum: issueInfo.sumOrg || '',
            num: issueInfo.num || '',
            tickets: issueInfo.ticketsOrg || '',
            aeroexpress: issueInfo.aeroexpressOrg || '',
            insurance: issueInfo.insuranceOrg || '',
            insuranceOnline: issueInfo.insuranceOnlineOrg || '',
            extraServices: JSON.stringify(issueInfo.extraServicesOrg) || '',
            currency: issueInfo.currencyOrg || ''
        });
    }

    function cancelIssueTickets(mode) {
        return fetchJSON('json/payment-' + mode, 'POST', {
            cancel: '1'
        });
    }

    function bindOrder(pnr, lastName) {
        return fetchJSON('json/bind-order', 'POST', {
            pnr: pnr,
            lastName: lastName
        });
    }

    function changePaymentForm(formPay) {
        return $q(function (resolve, reject) {
            fetchJSON('json/change-payment-form', 'POST', { formPay: formPay }, { keyEvent: 'change-payment-form' }).then(updateOrderInfo, reject);
        });
    }

    function aeroexpressRefund(id) {
        return fetchJSON('json/aeroexpress-refund', 'POST', { id: id }, { keyEvent: 'aeroexpress-refund' });
    }

    function checkServiceRemovalProhibited(code, passengerNum, flightNum) {
        var hasProhibition = false;

        if (orderInfo && orderInfo.groupedEditableExtraServices && orderInfo.groupedEditableExtraServices[code] && orderInfo.groupedEditableExtraServices[code].length) {
            if (passengerNum !== undefined && flightNum !== undefined) {
                if (orderInfo.groupedEditableExtraServices[code][passengerNum] && orderInfo.groupedEditableExtraServices[code][passengerNum][flightNum] && orderInfo.groupedEditableExtraServices[code][passengerNum][flightNum].length) {
                    orderInfo.groupedEditableExtraServices[code][passengerNum][flightNum].forEach(function (item) {
                        if (item.removalProhibited) {
                            hasProhibition = true;
                        }
                    });
                }
            } else {
                orderInfo.groupedEditableExtraServices[code].forEach(function (segments) {
                    if (segments && segments.length) {
                        segments.forEach(function (items) {
                            if (items && items.length) {
                                items.forEach(function (item) {
                                    if (item && item.removalProhibited) {
                                        hasProhibition = true;
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }

        return hasProhibition;
    }

    function unsubscribe(params) {
        return fetchJSON('json/unsubscribe', 'POST', params, { keyEvent: 'unsubscribe' });
    }

    function generateLegacyCityObject(geoPoint) {
        if (geoPoint) {
            var cityObject = {
                codeEn: geoPoint.cityCode
            };
            cityObject[service.sessionParams.localNamePropName] = geoPoint.cityName;
            cityObject[service.sessionParams.localCountryNamePropName] = geoPoint.countryName;
            if (geoPoint.portCode) {
                cityObject.airports = [{
                    codeEn: geoPoint.portCode,
                    selected: true
                }];
                cityObject.airports[0][service.sessionParams.localNamePropName] = geoPoint.portName;
            }
            return cityObject;
        }
    }

    function getGeoPointByLegacyCityObject(cityObject) {
        var result = void 0;
        if (cityObject) {
            result = {
                cityCode: cityObject.codeEn,
                cityName: cityObject[service.sessionParams.localNamePropName],
                countryName: cityObject[service.sessionParams.localCountryNamePropName]
            };
            if (cityObject.airports) {
                cityObject.airports.forEach(function (port) {
                    if (port.selected) {
                        result.portCode = port.codeEn;
                        result.portName = port[service.sessionParams.localNamePropName];
                    }
                });
            }
        }
        return result;
    }

    function generateInsuranceAgreeText(servicesHeap) {
        var result = [];
        if (servicesHeap) {
            servicesHeap.forEach(function (serviceItem) {
                if (serviceItem.groupCode === 'insurance') {
                    var aliasCode = serviceItem.productCode ? 'web.insurance.agreeText.' + serviceItem.ins + '.' + serviceItem.tins + '.' + serviceItem.productCode : 'web.insurance.agreeText.' + serviceItem.ins + '.' + serviceItem.tins;
                    if (!utils.hasInList(result, aliasCode)) {
                        if (hasAlias(aliasCode)) {
                            result.push(aliasCode);
                        } else {
                            // eslint-disable-next-line
                            console.log('Missed insurance agree alias: ', aliasCode);
                        }
                    }
                }
            });
        }
        if (result.length) {
            return result.map(getAliasDynamic).join('');
        } else {
            return false;
        }
    }

    // Private methods
    function initAliases(aliasesList) {
        aliasesList.forEach(function (alias) {
            aliasesIndex[alias.code] = alias.value;
        });

        initBrandConfig();
        initBannersConfig();
    }

    function initAliasesDeclaration(declarationList) {
        declarationList.forEach(function (alias) {
            declarationAliasesIndex[alias.code] = alias.value;
        });
    }

    function initAliasesPrefixDeclaration(list) {
        declarationAliasesPrefixList = list;
    }

    function initParams(paramsList) {
        paramsList.forEach(function (param) {
            paramsIndex[param.code] = param.value;
        });

        initTaxesGroupsList();
        initEnvironmentUrls();
        initPhoneCodesMask();
        initSpecialNeedSsrs();
        initFfpCompareConfig();
        initSearchGroupsConfig();
        initRefundConfig();
        initMonthSearchConfig();
        initFfpMemberTypesConfig();
        initPersonalWheelchairBatteryTypes();
    }

    function initSessionParams(data) {
        service.sessionParams = data;
        service.sessionParams.localNamePropName = 'name' + utils.capitalize(data.lang);
        service.sessionParams.localCountryNamePropName = 'countryName' + utils.capitalize(service.sessionParams.lang);

        if (service.sessionParams.maxInactiveInterval) {
            maxInactiveInterval = service.sessionParams.maxInactiveInterval;
        }

        if (service.sessionParams.alertInactiveTimeout) {
            alertInactiveTimeout = service.sessionParams.alertInactiveTimeout;
        }
    }

    function initApplicationConstants(data) {
        service.applicationConstants = data;
    }

    function initPlainCityDict(dict) {
        plainCityDict = dict;
        plainCityDict.forEach(function (city) {
            utils.getCodePropertiesList(city).forEach(function (codeName) {
                if (!citiesIndex[city[codeName]]) {
                    citiesIndex[city[codeName]] = city;
                }
            });

            if (city.airports) {
                city.airports.forEach(function (port) {
                    utils.getCodePropertiesList(port).forEach(function (codeName) {
                        if (!airportsIndex[port[codeName]]) {
                            airportsIndex[port[codeName]] = port;
                            airportsIndex[port[codeName]].cityCodeEn = city.codeEn;
                        }
                    });
                });
            }
        });
    }

    function initDependenceCityDict(dict) {
        dependenceCityDict = dict;
    }

    function initCountriesDict(dict) {
        var countriesBlackList = [];

        if (getParam('site.countriesBlackList')) {
            countriesBlackList = getParam('site.countriesBlackList').split(',').map(function (code) {
                return code.trim();
            });
        }

        countriesDict = dict.filter(function (country) {
            return !utils.hasInList(countriesBlackList, country.code);
        });
    }

    function reformatRouteAvailabilityParams(params, invert) {
        var apiParams = {
            'origin-city-code': invert ? params.cityB : params.cityA,
            'destination-city-code': invert ? params.cityA : params.cityB
        };

        if (params.portA) {
            apiParams[invert ? 'destination-port-code' : 'origin-port-code'] = params.portA;
        }

        if (params.portB) {
            apiParams[invert ? 'origin-port-code' : 'destination-port-code'] = params.portB;
        }

        return apiParams;
    }

    function reformatSearchVariantsResult(resp) {
        var plainVariants = [];

        if (resp.prices) {
            resp.prices.forEach(function (priceVariant) {
                priceVariant.flight_variants.forEach(function (flightVariant) {
                    plainVariants.push({
                        company: priceVariant.company,
                        currency: priceVariant.currency,
                        price: priceVariant.price,
                        clientId: priceVariant.clientId,
                        brand: priceVariant.brand,
                        segments: flightVariant.direction.map(function (segment) {
                            return getSegmentFlightsByChainId(resp.flights, segment.chainId);
                        })
                    });
                });
            });
        }

        plainVariants.sort(function (priceA, priceB) {
            return Big(priceA.price).minus(priceB.price);
        });

        return plainVariants;
    }

    function getSegmentFlightsByChainId(list, chainId) {
        for (var i = 0; i < list.length; i++) {
            if (list[i].chainId === chainId) {
                if (!list[i].flightTime) {
                    list[i].flightTime = list[i].flights[0].flighttime;
                }

                list[i].companies = getUniqueCompaniesByFlights(list[i].flights);

                return list[i];
            }
        }
    }

    function getUniqueCompaniesByFlights(flights) {
        var companies = [];

        for (var i = 0; i < flights.length; i++) {
            if (!_.findWhere(companies, flights[i].company)) {
                companies.push(flights[i].company);
            }
        }

        return companies;
    }

    function reformatPricingVariantParams(selectedVariants, mode) {
        var apiParams = { mode: mode };

        if (mode === 'monoBrandCartesian') {
            selectedVariants.forEach(function (segment, segmentNumber) {
                apiParams['flightchain-id[' + segmentNumber + ']'] = segment.chainId;
                apiParams['price[' + segmentNumber + ']'] = segment.price;
                apiParams['brand[' + segmentNumber + ']'] = segment.brand;
                apiParams['requestedBrands[' + segmentNumber + ']'] = segment.requestedBrands;
            });
        } else if (mode === 'pricingRouteAndMonoBrand') {
            selectedVariants.forEach(function (segment, segmentNumber) {
                apiParams['flightchain-id[' + segmentNumber + ']'] = segment.chainId;
                apiParams['brand[' + segmentNumber + ']'] = segment.brand;
            });
        } else if (mode === 'ffp') {
            selectedVariants.forEach(function (segment, segmentNumber) {
                apiParams['flightchain-id[' + segmentNumber + ']'] = segment.chainId;
                apiParams['fareId[' + segmentNumber + ']'] = segment.fareGroup;
                apiParams['requestedBrands[' + segmentNumber + ']'] = segment.requestedBrands;
            });
        } else if (mode === 'standard') {
            selectedVariants.forEach(function (segment, segmentNumber) {
                apiParams['flightchain-id[' + segmentNumber + ']'] = segment.chainId;
            });

            apiParams.priceId = selectedVariants[0].priceId;
        }

        return apiParams;
    }

    function reformatAgencyPricingVariantParams(selectedVariant, mode) {
        var apiParams = { mode: mode };

        if (mode === 'standard' || mode === 'monoBrand') {
            selectedVariant.segments.forEach(function (segment, segmentNumber) {
                apiParams['flightchain-id[' + segmentNumber + ']'] = segment.chainId;
            });

            if (mode === 'monoBrand') {
                apiParams.brand = selectedVariant.brand;
                apiParams.requestedBrands = selectedVariant.requestedBrands;
            }
        }

        return apiParams;
    }

    function reformatPassengersAddList(list) {
        var apiParams = {};

        list.forEach(function (item, i) {
            var num = i + 1;

            apiParams['categoryId[' + num + ']'] = item.categoryId;
            apiParams['firstName[' + num + ']'] = item.firstName;
            apiParams['lastName[' + num + ']'] = item.lastName;
            apiParams['gender[' + num + ']'] = item.gender;
            apiParams['dateOfBirth[' + num + ']'] = item.dateOfBirth;
            apiParams['nationality[' + num + ']'] = item.nationality;
            apiParams['documentType[' + num + ']'] = item.documentType;
            apiParams['documentNumber[' + num + ']'] = item.documentNumber;
            apiParams['additionalDocumentType[' + num + ']'] = item.additionalDocumentType;
            apiParams['additionalDocumentNumber[' + num + ']'] = item.additionalDocumentNumber;
            apiParams['ffpPromoCodeMode[' + num + ']'] = item.ffpPromoCodeMode || 'DISCOUNT';

            if (item.documentDate) {
                apiParams['documentDate[' + num + ']'] = item.documentDate;
            }

            if (item.phone) {
                apiParams['phone[' + num + ']'] = item.phone;
            }

            if (item.email) {
                apiParams['email[' + num + ']'] = item.email;
            }

            if (item.bonusCard) {
                apiParams['bonusCard[' + num + ']'] = item.bonusCard;
            }

            if (item.ynaoAgreementClicked) {
                apiParams['ynaoAgreementClicked[' + num + ']'] = item.ynaoAgreementClicked;
            }

            if (item.promoCode) {
                apiParams['promoCode[' + num + ']'] = item.promoCode;
            }

            if (item.specialNeedSsrs) {
                apiParams['specialNeedSsrs[' + num + ']'] = _.keys(item.specialNeedSsrs).filter(function (ssr) {
                    return item.specialNeedSsrs[ssr];
                }).join(',');
            }

            if (item.personalWheelchairSsrText) {
                apiParams['personalWheelchairSsrText[' + num + ']'] = item.personalWheelchairSsrText;
            }

            if (item.parentIndex !== undefined) {
                apiParams['parentIndex[' + num + ']'] = item.parentIndex + 1;
            }
        });

        return apiParams;
    }

    function reformatPrivatePassengersSaveList(list) {
        var apiParams = {};

        list.forEach(function (item, num) {
            apiParams['firstName[' + num + ']'] = item.firstName;
            apiParams['firstNameEn[' + num + ']'] = item.firstNameEn;
            apiParams['lastName[' + num + ']'] = item.lastName;
            apiParams['lastNameEn[' + num + ']'] = item.lastNameEn;
            apiParams['gender[' + num + ']'] = item.gender;
            apiParams['dateOfBirth[' + num + ']'] = item.dateOfBirth;

            if (item.nationality) {
                apiParams['nationality[' + num + ']'] = item.nationality.code ? item.nationality.code : item.nationality;
            }

            if (item.documents) {
                apiParams['documents[' + num + ']'] = serializePrivatePassengersDocuments(item.documents);
            }

            if (item.phone) {
                apiParams['phone[' + num + ']'] = item.phone;
            }

            if (item.email) {
                apiParams['email[' + num + ']'] = item.email;
            }
        });

        apiParams.passengersCount = list.length;

        return apiParams;
    }

    function reformatRegistrationParams(params) {
        var apiParams = angular.copy(params);
        apiParams['password[]'] = apiParams.password;
        apiParams.url = getCurrentLocation();

        delete apiParams.password;
        delete apiParams.passwordRepeat;

        return apiParams;
    }

    function getCurrentLocation() {
        return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : "") + location.pathname;
    }

    function serializePrivatePassengersDocuments(documents) {
        var result = '';

        documents.forEach(function (doc, docNum) {
            if (docNum) {
                result += ',';
            }

            result += doc.documentType + '___';
            result += doc.documentNumber;

            if (doc.documentDate) {
                result += '___' + doc.documentDate;
            }
        });

        return result;
    }

    function reformatPriceVariant(data) {
        return data.map(function (item) {
            if (getParam('payment.ignoreDefaultSelectedPaymentForm') && item.selected) {
                delete item.selected;
            }

            item.conflicts_with_aeroexpress = item.conflicts_with_aeroexpress === 'true';
            item.conflicts_with_insurance = item.conflicts_with_insurance === 'true';
            item.conflicts_with_timelimit = item.conflicts_with_timelimit === 'true';

            return item;
        });
    }

    function reformatPaymentVariants(data) {
        var paymentVariants = [];
        data.forEach(function (paymentFormItem) {
            var paymentForm = paymentFormItem.code;
            var conflicts_with_aeroexpress = paymentFormItem.conflicts_with_aeroexpress === 'true';
            var conflicts_with_insurance = paymentFormItem.conflicts_with_insurance === 'true';
            var conflicts_with_timelimit = paymentFormItem.conflicts_with_timelimit === 'true';
            var price = paymentFormItem.price;
            var currency = paymentFormItem.currency;
            var defaultSelected = (!getParam('payment.ignoreDefaultSelectedPaymentForm') || price === '0.00') && (paymentFormItem.selected === 'true' || paymentFormItem.selected === true);
            if (paymentFormItem.paymentTypes.length) {
                paymentFormItem.paymentTypes.forEach(function (paymentType) {
                    paymentVariants.push({
                        paymentForm: paymentForm,
                        paymentType: paymentType.code,
                        price: price,
                        currency: currency,
                        defaultSelected: defaultSelected,
                        conflicts_with_aeroexpress: conflicts_with_aeroexpress,
                        conflicts_with_insurance: conflicts_with_insurance,
                        conflicts_with_timelimit: conflicts_with_timelimit
                    });
                });
            } else {
                var cards = paymentForm === 'plastic_card' && service.sessionParams.authoriseCustomer && service.sessionParams.authoriseCustomer.cards;
                if (cards) {
                    cards.forEach(function (card, cardNum) {
                        paymentVariants.push({
                            paymentForm: paymentForm,
                            paymentType: paymentForm,
                            price: price,
                            currency: currency,
                            defaultSelected: defaultSelected && !cardNum,
                            savedCard: card,
                            conflicts_with_aeroexpress: conflicts_with_aeroexpress,
                            conflicts_with_insurance: conflicts_with_insurance,
                            conflicts_with_timelimit: conflicts_with_timelimit
                        });
                    });
                }
                paymentVariants.push({
                    paymentForm: paymentForm,
                    paymentType: paymentForm,
                    price: price,
                    currency: currency,
                    defaultSelected: defaultSelected && !cards,
                    conflicts_with_aeroexpress: conflicts_with_aeroexpress,
                    conflicts_with_insurance: conflicts_with_insurance,
                    conflicts_with_timelimit: conflicts_with_timelimit
                });
            }
        });
        return paymentVariants;
    }

    function reformatOrderInfo(data) {
        var hasBonusCard = false;

        if (data.passengers) {
            data.passengers.forEach(function (passenger) {
                if (!hasBonusCard && passenger.bonusCard) {
                    hasBonusCard = true;
                }
                if (passenger.specialNeeds) {
                    passenger.specialNeedSsrs = {};
                    passenger.specialNeedSsrsList = [];
                    passenger.hasSpecialNeed = true;
                    passenger.specialNeeds.forEach(function (item) {
                        passenger.specialNeedSsrs[item.ssr] = true;
                        if (!utils.hasInList(passenger.specialNeedSsrsList, item.ssr)) {
                            passenger.specialNeedSsrsList.push(item.ssr);
                        }
                    });
                }
                if (passenger.parentId !== undefined) {
                    passenger.parentIndex = _.findIndex(data.passengers, function (pax) {
                        return pax.id === passenger.parentId;
                    });
                }
                if (passenger.phone) {
                    passenger.oldPhone = passenger.phone;
                }
                if (passenger.parentId && !passenger.hasSeats) {
                    var parent = _.findWhere(data.passengers, { id: passenger.parentId });
                    parent.child = passenger;
                }
            });
            if (data.passengers[0] && data.header) {
                data.header.lastName = data.passengers[0].lastName;
            }
        }

        data.extraPassengers = getExtraPassengersList(data);

        data.hasBonusCard = hasBonusCard;

        if (data.flights) {
            data.orderCountries = [];
            data.plainFlights = [];
            data.flights.forEach(function (segment) {

                segment.flightsInfo = utils.getFlightsInfo(segment, getAlias('web.connectionsMessage.transfer'), getAlias('web.connectionsMessage.noTransfer'));

                segment.flights.forEach(function (flight) {
                    var origincity = void 0,
                        destinationcity = void 0;

                    if (flight.origincity) {
                        origincity = getCityByCode(flight.origincity);

                        if (origincity && origincity.countryEn && !utils.hasInList(data.orderCountries, origincity.countryEn)) {
                            data.orderCountries.push(origincity.countryEn);
                        }
                    }

                    if (flight.destinationcity) {
                        destinationcity = getCityByCode(flight.destinationcity);

                        if (destinationcity && destinationcity.countryEn && !utils.hasInList(data.orderCountries, destinationcity.countryEn)) {
                            data.orderCountries.push(destinationcity.countryEn);
                        }
                    }

                    if (flight.brand) {
                        flight.brandName = getBrandName(flight.brand);
                        flight.brandAvailableProps = getBrandProps(flight.brand, 'yes');
                        flight.brandUnavailableProps = getBrandProps(flight.brand, 'no');
                        flight.brandPaidProps = getBrandProps(flight.brand, 'paid');
                    }

                    flight.flightsInfo = utils.getFlightsInfo({ flights: [flight] }, getAlias('web.connectionsMessage.transfer'), getAlias('web.connectionsMessage.noTransfer'));

                    data.plainFlights.push(flight);
                });

                if (!segment.flightTime && segment.flights.length === 1) {
                    segment.flightTime = segment.flights[0].flighttime;
                }
            });
        }

        data.descPassCountStr = getDescPassCountStr(data.passengers);

        if (data.passengers && data.plainFlights) {
            if (data.editable_extra_services) {
                data.editable_extra_services = data.editable_extra_services.map(utils.markInsuranceOnline);

                data.editableExtraServicesByPassengers = getExtraServicesByPassengers(data.passengers, data.plainFlights, data.editable_extra_services);

                data.editableExtraServicesByExtraPassengers = getExtraServicesByPassengers(data.extraPassengers, data.plainFlights, data.editable_extra_services);

                data.editableExtraServicesForAllPassengers = getExtraServicesForAllPassengers(data.editable_extra_services);

                data.groupedEditableExtraServices = groupExtraServices(data.passengers, data.plainFlights, data.editable_extra_services);

                data.groupedEditableExtraServicesCount = getGroupedExtraServicesCount(data.groupedEditableExtraServices);

                data.editableExtraServicesHeap = generateServicesHeap(data.editable_extra_services);
            }

            if (data.all_extra_services) {
                data.all_extra_services = data.all_extra_services.map(utils.markInsuranceOnline);

                data.allExtraServicesByPassengers = getExtraServicesByPassengers(data.passengers, data.plainFlights, data.all_extra_services);

                data.allExtraServicesByExtraPassengers = getExtraServicesByPassengers(data.extraPassengers, data.plainFlights, data.all_extra_services);

                data.allExtraServicesForAllPassengers = getExtraServicesForAllPassengers(data.all_extra_services);

                data.removedExtraServicesBySegments = getRemovedExtraServicesBySegments(data.passengers, data.plainFlights, data.all_extra_services);

                data.groupedAllExtraServices = groupExtraServices(data.passengers, data.plainFlights, data.all_extra_services);

                data.allExtraServicesHeap = generateServicesHeap(data.all_extra_services);
            }

            if (data.issued_extra_services) {
                data.issued_extra_services = data.issued_extra_services.map(utils.markInsuranceOnline);

                data.groupedIssuedExtraServices = groupExtraServices(data.passengers, data.plainFlights, data.issued_extra_services);
            }
        }

        if (data.prices) {
            if (data.prices.totalFare && data.prices.totalTax) {
                data.prices.totalTicket = Big(data.prices.totalFare).plus(data.prices.totalTax).toFixed(2);
            }

            data.prices.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.prices.totalExtraServiceByGroup);

            data.prices.totalCommonServicesList = getCommonServicesList(data.prices.totalExtraServiceByGroup);
            if (data.prices.pricesByPassengerSegments && data.prices.pricesByPassengerSegments.length) {
                data.hasItFare = data.prices.pricesByPassengerSegments.some(function (passengerSegmentPrice) {
                    return passengerSegmentPrice.isItFare;
                });
            }
            setupOrderPriceGroupedTaxes(data.prices);
        }

        if (data.pricesWithoutDiscount) {
            if (data.pricesWithoutDiscount.totalFare && data.pricesWithoutDiscount.totalTax) {
                data.pricesWithoutDiscount.totalTicket = Big(data.pricesWithoutDiscount.totalFare).plus(data.pricesWithoutDiscount.totalTax).toFixed(2);
            }
        }

        if (data.pricesIssued) {
            if (data.pricesIssued.totalFare && data.pricesIssued.totalTax) {
                data.pricesIssued.totalTicket = Big(data.pricesIssued.totalFare).plus(data.pricesIssued.totalTax).toFixed(2);
            }

            data.pricesIssued.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.pricesIssued.totalExtraServiceByGroup);

            data.pricesIssued.totalCommonServicesList = getCommonServicesList(data.pricesIssued.totalExtraServiceByGroup);

            setupOrderPriceGroupedTaxes(data.pricesIssued);
        }

        if (data.pricesNotIssued) {
            if (data.pricesNotIssued.totalFare && data.pricesNotIssued.totalTax) {
                data.pricesNotIssued.totalTicket = Big(data.pricesNotIssued.totalFare).plus(data.pricesNotIssued.totalTax).toFixed(2);
            }

            data.pricesNotIssued.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.pricesNotIssued.totalExtraServiceByGroup);

            data.pricesNotIssued.totalCommonServicesList = getCommonServicesList(data.pricesNotIssued.totalExtraServiceByGroup);

            setupOrderPriceGroupedTaxes(data.pricesNotIssued);
        }

        if (data.pricesEditable) {
            if (data.pricesEditable.totalFare && data.pricesEditable.totalTax) {
                data.pricesEditable.totalTicket = Big(data.pricesEditable.totalFare).plus(data.pricesEditable.totalTax).toFixed(2);
            }

            data.pricesEditable.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.pricesEditable.totalExtraServiceByGroup);

            data.pricesEditable.totalCommonServicesList = getCommonServicesList(data.pricesEditable.totalExtraServiceByGroup);

            if (data.pricesEditable.totalExtraServices) {
                data.hasSelectedExtraServices = true;
            }

            setupOrderPriceGroupedTaxes(data.pricesEditable);
        }

        if (data.possiblePaymentForms) {
            data.possiblePaymentVariants = reformatPaymentVariants(data.possiblePaymentForms);
        }

        data.paymentConfirmationAllowed = data.paymentConfirmationAllowed && service.sessionParams.authoriseCustomer && (service.sessionParams.authoriseCustomer.role === 'siteOper' || service.sessionParams.authoriseCustomer.role === 'sysAdmin' || service.sessionParams.authoriseCustomer.role === 'siteAdmin');

        data.bindAlowed = !data.isBound && service.sessionParams.authoriseCustomer && service.sessionParams.authoriseCustomer.role === 'physic';

        data.hasFailedServices = data.allExtraServicesHeap && data.allExtraServicesHeap.some(function (item) {
            return item.status === 'REMOVED';
        });

        if (data.passengers && data.ticketPrices && data.ticketPrices.ticketPrices) {
            data.ticketPrices.ticketPricesByPassengers = utils.getTicketPricesByPassengers(data.ticketPrices.ticketPrices, data.passengers);
            data.ticketPrices.ticketPricesByPassengerTypes = utils.getTicketPricesByPassengerTypes(data.ticketPrices.ticketPrices, taxesGroupsList);
        }

        return data;
    }

    function checkOrderEvents(events) {
        events.forEach(function (event) {
            if (!event.processedByJS) {
                watchman.notifyOrderEvent({
                    date: event.date,
                    id: event.id,
                    type: event.type,
                    extraInformation: event.extraInformation || false
                }, getOrderInfo());
                markTrackingEventProcessed(event.id);
            }
        });
    }

    function getExtraPassengersList(orderInfo) {
        var orderAeroexpressService = _.findWhere(orderInfo.all_extra_services, { code: 'aeroexpress' });
        var list = [];

        if (orderAeroexpressService && orderAeroexpressService.items && orderAeroexpressService.items.length) {
            orderAeroexpressService.items.forEach(function (item) {
                if (!_.findWhere(orderInfo.passengers, {
                    firstName: item.firstName,
                    lastName: item.lastName
                }) && !_.findWhere(list, {
                    firstName: item.firstName,
                    lastName: item.lastName
                })) {
                    list.push({
                        firstName: item.firstName,
                        lastName: item.lastName,
                        dateOfBirth: item.dateOfBirth,
                        aeroexpressDocumentType: item.documentType,
                        aeroexpressDocumentNumber: item.documentNumber
                    });
                }
            });
        }

        return list;
    }

    function setupOrderPriceGroupedTaxes(prices) {
        if (taxesGroupsList && taxesGroupsList.length && prices.taxes && prices.taxes.length) {
            prices.groupedTaxes = taxesGroupsList.map(function (taxesGroupItem) {
                return {
                    groups: taxesGroupItem.groups,
                    code: taxesGroupItem.code,
                    value: '0'
                };
            });

            prices.otherTaxes = '0';

            prices.taxes.forEach(function (taxItem) {
                var hasInAnyGroup = false;

                prices.groupedTaxes.forEach(function (taxGroupItem) {
                    if (utils.hasInList(taxGroupItem.groups, taxItem.code)) {
                        taxGroupItem.value = Big(taxGroupItem.value).plus(taxItem.value).toFixed(2);

                        hasInAnyGroup = true;
                    }
                });

                if (!hasInAnyGroup) {
                    prices.otherTaxes = Big(prices.otherTaxes).plus(taxItem.value).toFixed(2);
                }
            });
        }
    }

    function fixPassengerDocumentInterval(intervals, rangeBirthFrom, rangeBirthTo) {
        return intervals.map(function (interval) {
            var docInterval = interval.split('-');
            var from = docInterval[0];
            var to = docInterval[1];
            if (utils.compareStringDate(from, rangeBirthFrom) === -1) {
                from = rangeBirthFrom;
            }
            if (utils.compareStringDate(to, rangeBirthTo) === 1) {
                to = rangeBirthTo;
            }
            return from + '-' + to;
        });
    }

    function reformatPassengersCheck(passengersCheck) {
        passengersCheck.passengerFirstNameRegexp = new RegExp(passengersCheck.passengerFirstNameRegexp);
        passengersCheck.passengerLastNameRegexp = new RegExp(passengersCheck.passengerLastNameRegexp);
        passengersCheck.phoneRegex = new RegExp(passengersCheck.phoneRegex);
        passengersCheck.emailRegex = new RegExp(passengersCheck.emailRegex);
        passengersCheck.passengers = passengersCheck.passengers.map(function (passenger) {
            var rangeBirthFrom = passenger.rangeBirthFrom || utils.getMinDateFromList([passenger.rangeBirthFromMale, passenger.rangeBirthFromFemale]);
            var rangeBirthTo = passenger.rangeBirthTo || utils.getMaxDateFromList([passenger.rangeBirthToMale, passenger.rangeBirthToFemale]);
            return (0, _extends3.default)({}, passenger, {
                rangeBirthFrom: rangeBirthFrom,
                rangeBirthTo: rangeBirthTo,
                documents: passenger.documents.map(function (passengerDocument) {
                    return (0, _extends3.default)({}, passengerDocument, {
                        intervals: fixPassengerDocumentInterval(passengerDocument.intervals, rangeBirthFrom, rangeBirthTo)
                    });
                })
            });
        });
        return passengersCheck;
    }

    function reformatPrivatePassengersList(resp) {
        var respFormated = angular.copy(resp);
        if (respFormated.passengers) {
            respFormated.passengers.forEach(function (pax) {
                if (!pax.firstName && !pax.firstNameEn && !pax.lastNameEn) {
                    pax.firstName = pax.name;
                    pax.firstNameEn = pax.nameLatin;
                    pax.lastNameEn = pax.lastNameLatin;
                    delete pax.name;
                    delete pax.nameLatin;
                    delete pax.lastNameLatin;
                }
            });
        }
        return respFormated;
    }

    function reformatPrivatePassengerSaveItem(params) {
        var paramsFormated = angular.copy(params);
        paramsFormated.name = params.firstName;
        paramsFormated.nameLatin = params.firstNameEn;
        paramsFormated.lastNameLatin = params.lastNameEn;
        paramsFormated.birthDate = params.dateOfBirth;
        delete paramsFormated.firstName;
        delete paramsFormated.firstNameEn;
        delete paramsFormated.lastNameEn;
        delete paramsFormated.dateOfBirth;
        paramsFormated.documents = paramsFormated.documents.map(function (doc) {
            var newDoc = {
                code: doc.documentType,
                number: doc.documentNumber,
                expirationDate: doc.documentDate
            };
            if (doc.id) {
                newDoc.id = doc.id;
            }
            return newDoc;
        });
        return paramsFormated;
    }

    function reformatExtraServiceByGroupPrices(totalExtraServiceByGroup) {
        if (totalExtraServiceByGroup) {
            totalExtraServiceByGroup = _.mapObject(_.indexBy(totalExtraServiceByGroup.map(utils.markInsuranceOnline), 'code'), function (item) {
                return item.price;
            });
        } else {
            totalExtraServiceByGroup = {};
        }

        return totalExtraServiceByGroup;
    }

    function getCommonServicesList(totalExtraServiceByGroup) {
        return _.keys(totalExtraServiceByGroup || {}).filter(utils.isCommonServiceCode).map(function (code) {
            return {
                code: code,
                value: totalExtraServiceByGroup[code]
            };
        });
    }

    function groupExtraServices(passengers, plainFlights, servicesList) {
        var result = {};

        servicesList.forEach(function (editableService) {
            if (editableService.code === 'insurance') {
                result[editableService.code] = getPasSegItemsByInsuranceService(passengers, plainFlights, editableService);
            } else if (editableService.code === 'aeroexpress') {
                result[editableService.code] = getPasSegItemsByAeroexpressService(editableService);
            } else {
                result[editableService.code] = getPasSegItemsByService(passengers, plainFlights, editableService);
            }
        });
        return result;
    }

    function getPasSegItemsByService(passengers, plainFlights, editableService) {
        if (!editableService || !editableService.selectedSvcs) {
            return false;
        }

        return passengers.map(function (orderPassenger) {

            if (!_.findWhere(editableService.selectedSvcs, { passengerId: orderPassenger.id })) {
                return false;
            }

            return plainFlights.map(function (orderSegment) {
                var selectedExtraServices = editableService.selectedSvcs.filter(function (item) {
                    return item.passengerId === orderPassenger.id && item.segmentId === orderSegment.id;
                });
                if (!selectedExtraServices.length) {
                    return false;
                }
                if (editableService.code === 'meal' && $window.o2context.oxyTheme === 'fv') {
                    return splitSelectedExtraServices(selectedExtraServices);
                }
                return selectedExtraServices;
            });
        });
    }

    function splitSelectedExtraServices(selectedExtraServices) {
        var newSplitList = [];
        if (selectedExtraServices && selectedExtraServices.length) {
            selectedExtraServices.forEach(function (selectedMealItem) {
                var tmpItem = void 0;
                if (selectedMealItem && selectedMealItem.amount) {
                    tmpItem = angular.copy(selectedMealItem);
                    tmpItem.amount = 1;
                    tmpItem.realAmount = selectedMealItem.amount;
                    if (selectedMealItem.totalPrice && selectedMealItem.amount) {
                        tmpItem.totalPrice = Big(selectedMealItem.totalPrice).div(selectedMealItem.amount).toFixed(2);
                    } else {
                        tmpItem.totalPrice = selectedMealItem.totalPrice;
                    }
                    for (var i = 0; i < selectedMealItem.amount; i++) {
                        newSplitList.push(tmpItem);
                    }
                }
            });
        }
        return newSplitList;
    }

    function getPasSegItemsByInsuranceService(passengers, plainFlights, editableService) {
        if (!editableService || !editableService.items) {
            return false;
        }
        return passengers.map(function (orderPassenger) {
            var paxServiceItem = _.findWhere(editableService.items, {
                passengerId: orderPassenger.id
            });
            if (paxServiceItem) {
                return plainFlights.map(function (flight) {
                    if (!paxServiceItem.segmentId) {
                        return [paxServiceItem];
                    } else {
                        var paxFlightServiceItems = _.where(editableService.items, {
                            segmentId: flight.id,
                            passengerId: orderPassenger.id
                        });
                        if (paxFlightServiceItems.length) {
                            return paxFlightServiceItems;
                        } else {
                            return false;
                        }
                    }
                });
            } else {
                return false;
            }
        });
    }

    function getPasSegItemsByAeroexpressService(editableService) {
        var indexByPassengers = _.groupBy(editableService.items, function (item) {
            return item.lastName + ' ' + item.firstName;
        });
        return _.keys(indexByPassengers).map(function (keyPax) {
            var indexByRoutes = _.groupBy(indexByPassengers[keyPax], function (item) {
                return item.departure_code + ' ' + item.arrival_code;
            });
            return _.keys(indexByRoutes).map(function (keyRoute) {
                return indexByRoutes[keyRoute];
            });
        });
    }

    /**
    * Calc count by extra services groups
    * @param {object} groupedExtraServices - Extra services groups data
    * getGroupedExtraServicesCount({
        priorityCheckIn: [
            [
                [ { amount: 1 } ],
                [ { amount: 1 } ]
            ],
            [
                [ { amount: 1 }],
                [ { amount: 1 } ]
            ]
        ],
        meal: [
            [
                [ { amount: 1 }, { amount: 1 } ],
                false
            ],
            [
                false,
                false
            ]
        ],
        seat: [
            [
                [ { amount: 1 } ],
                false
            ],
            [
                [ { amount: 1 } ],
                false
            ]
        ]
    })
    > { priorityCheckIn: 4, meal: 2, seat: 2 }
    */
    function getGroupedExtraServicesCount(groupedExtraServices) {
        return _.mapObject(groupedExtraServices, function (servicePasSegItems) {
            var count = 0;

            if (servicePasSegItems) {
                servicePasSegItems.forEach(function (serviceSegItems) {
                    if (serviceSegItems) {
                        serviceSegItems.forEach(function (serviceItems) {
                            if (serviceItems) {
                                serviceItems.forEach(function (serviceItem) {
                                    if (serviceItem && serviceItem.amount) {
                                        count += serviceItem.amount;
                                    }
                                });
                            }
                        });
                    }
                });
            }

            return count;
        });
    }

    function processPassengerSegmentService(servicesList, code, segmentId, passengerId, callback) {
        var targetService = _.findWhere(servicesList, { code: code });
        if (targetService) {

            var serviceItems = void 0;

            if (targetService.selectedSvcs) {
                serviceItems = targetService.selectedSvcs;
            } else if (targetService.items) {
                serviceItems = targetService.items;
            }

            if (serviceItems && serviceItems.length) {
                var targetCondition = { passengerId: passengerId };
                if (serviceItems[0].segmentId) {
                    targetCondition.segmentId = segmentId;
                }
                var targetItems = _.where(serviceItems, targetCondition);
                if (targetItems.length) {
                    callback(targetItems);
                }
            }
        }
    }

    function getExtraServicesByPassengers(passengers, plainFlights, servicesList) {
        var insuranceService = _.findWhere(servicesList, { code: 'insurance' });
        var aeroexpressService = _.findWhere(servicesList, { code: 'aeroexpress' });

        return passengers.map(function (passenger) {

            var hasPassengerSegmentServices = false,
                passengerServices = [],
                passengerSegmentServices = plainFlights.map(function (segment) {

                var passengerSegmentServicesList = [];

                var passengerSegmentServicesCodes = ['meal', 'baggage', 'seat', 'insurance', 'smsNotifications'];

                passengerSegmentServicesCodes.forEach(function (code) {
                    processPassengerSegmentService(servicesList, code, segment.id, passenger.id, function (serviceItems) {
                        passengerSegmentServicesList.push({
                            code: code,
                            serviceItems: serviceItems,
                            serviceItem: serviceItems[0]
                        });
                    });
                });

                servicesList.forEach(function (service) {
                    if (utils.isCommonServiceCode(service.code)) {
                        processPassengerSegmentService(servicesList, service.code, segment.id, passenger.id, function (serviceItems) {
                            passengerSegmentServicesList.push({
                                code: service.code,
                                serviceItem: serviceItems[0]
                            });
                        });
                    }
                });

                if (!passengerSegmentServicesList.length) {
                    return false;
                }

                return passengerSegmentServicesList;
            });

            if (insuranceService && insuranceService.items) {
                insuranceService.items.forEach(function (item) {
                    if (passenger.id === item.passengerId) {
                        passengerServices.push({
                            code: 'insurance',
                            serviceItem: item
                        });
                    }
                });
            }

            if (aeroexpressService && aeroexpressService.items) {
                aeroexpressService.items.forEach(function (item) {
                    if (item.firstName === passenger.firstName && item.lastName === passenger.lastName) {
                        passengerServices.push({
                            code: 'aeroexpress',
                            serviceItem: item
                        });
                    }
                });
            }

            passengerSegmentServices.forEach(function (passengerSegmentServicesList) {
                if (passengerSegmentServicesList) {
                    hasPassengerSegmentServices = true;
                }
            });

            if (!passengerServices.length) {
                passengerServices = false;
            }

            if (!hasPassengerSegmentServices) {
                passengerSegmentServices = false;
            }

            if (!passengerServices && !passengerSegmentServices) {
                return false;
            } else {
                return {
                    passengerSegmentServices: passengerSegmentServices,
                    passengerServices: passengerServices
                };
            }
        });
    }

    function generateServicesHeap(servicesList) {
        var heap = [];

        if (servicesList && servicesList.length) {
            servicesList.forEach(function (servicesByType) {
                if (servicesByType.selectedSvcs && servicesByType.selectedSvcs.length) {
                    servicesByType.selectedSvcs.forEach(function (itemSource) {
                        var item = angular.copy(itemSource);
                        item.groupCode = servicesByType.code;
                        heap.push(item);
                    });
                } else if (servicesByType.code === 'aeroexpress' && servicesByType.items) {
                    servicesByType.items.forEach(function (aeItem) {
                        var item = angular.copy(aeItem);
                        item.groupCode = servicesByType.code;
                        heap.push(item);
                    });
                } else if (servicesByType.code === 'insurance') {
                    servicesByType.items.forEach(function (insItem) {
                        var item = angular.copy(insItem);
                        item.groupCode = servicesByType.code;
                        heap.push(item);
                    });
                }
            });
        }

        return heap;
    }

    function getExtraServicesForAllPassengers(servicesList) {
        var result = [];
        servicesList.forEach(function (service) {
            var hasInsuranceItemsWithoutPassengerId = service.items && !service.items.some(function (item) {
                return item.passengerId !== undefined;
            });
            if (service.code === 'insurance' && hasInsuranceItemsWithoutPassengerId) {
                result.push(service);
            } else if (service.selectedSvcs) {
                service.selectedSvcs.forEach(function (selectedSvc) {
                    if (selectedSvc.passengerId === undefined || selectedSvc.passengerId === null) {
                        result.push(selectedSvc);
                    }
                });
            }
        });
        return result;
    }

    function getRemovedExtraServicesBySegments(passengers, plainFlights, servicesList) {
        var hasRemovedServices = false;
        var removedExtraServicesBySegments = plainFlights.map(function (segment) {
            var hasSegmentRemovedServices = false;
            var passengerSegmentRemovedServices = passengers.map(function (passenger) {
                var passengerSegmentRemovedServicesList = [];
                servicesList.forEach(function (service) {
                    var servicePassengerSegment = void 0;

                    var servicePassenger = _.findWhere(service.passengers, { id: passenger.id });

                    if (servicePassenger) {
                        servicePassengerSegment = _.findWhere(servicePassenger.segments, {
                            id: segment.id
                        });

                        if (servicePassengerSegment && servicePassengerSegment.selectedExtraServices) {
                            servicePassengerSegment.selectedExtraServices.forEach(function (item) {
                                if (item && item.removed) {
                                    passengerSegmentRemovedServicesList.push({
                                        code: service.code,
                                        serviceItem: item
                                    });
                                }
                            });
                        }
                    }
                });
                if (!passengerSegmentRemovedServicesList.length) {
                    passengerSegmentRemovedServicesList = false;
                }

                return passengerSegmentRemovedServicesList;
            });

            passengerSegmentRemovedServices.forEach(function (passengerSegmentRemovedServicesList) {
                if (passengerSegmentRemovedServicesList) {
                    hasSegmentRemovedServices = true;
                }
            });

            if (!hasSegmentRemovedServices) {
                return false;
            } else {
                hasRemovedServices = true;
                return {
                    passengerSegmentRemovedServices: passengerSegmentRemovedServices
                };
            }
        });

        if (!hasRemovedServices) {
            removedExtraServicesBySegments = false;
        }

        return removedExtraServicesBySegments;
    }

    function getAvailabilityInfoBySegmentChain(passengerSegments, passengerId, flightIds) {
        var targetPassengerSegments = passengerSegments.filter(function (passengerSegment) {
            return passengerSegment.passengerId === passengerId && flightIds.includes(passengerSegment.segmentId);
        });
        if (!targetPassengerSegments.length) {
            return 'UNAVAILABLE_STATUS_GENERAL';
        }
        for (var i = 0; i < targetPassengerSegments.length; i++) {
            if (targetPassengerSegments[i].availabilityInfo !== 'AVAILABLE') {
                return targetPassengerSegments[i].availabilityInfo;
            }
        }
        return 'AVAILABLE';
    }

    function reformatFlownStatus(data, orderInfo, refundManual) {
        var passengerIds = [];

        if (data.passengerSegments) {
            data.passengerSegments.forEach(function (passengerSegment) {
                var orderPax = _.findWhere(orderInfo.passengers, { id: passengerSegment.passengerId });
                var orderFlight = _.findWhere(orderInfo.plainFlights, { id: passengerSegment.segmentId });

                passengerSegment.passenger = {
                    name: orderPax.firstName,
                    lastName: orderPax.lastName,
                    birthDate: orderPax.dateOfBirth
                };

                passengerSegment.segment = {
                    date: orderFlight.date,
                    origincityName: orderFlight.origincityName,
                    destinationcityName: orderFlight.destinationcityName,
                    racenumber: orderFlight.racenumber,
                    carrier: orderFlight.carrier
                };

                if (!utils.hasInList(passengerIds, passengerSegment.passengerId)) {
                    passengerIds.push(passengerSegment.passengerId);
                }

                data.passengers = passengerIds.map(function (passengerId) {
                    var available = true;

                    var reasons = [];
                    var notes = [];
                    var orderPax = _.findWhere(orderInfo.passengers, { id: passengerId });

                    data.passengerSegments.forEach(function (passengerSegment) {
                        if (passengerSegment.passengerId === passengerId && !refundManual) {
                            if (passengerSegment.availabilityInfo === 'AVAILABLE_INVOLUNTARY') {
                                notes.push(passengerSegment.availabilityInfo);
                            } else if (passengerSegment.availabilityInfo !== 'AVAILABLE') {
                                available = false;
                                reasons.push(passengerSegment.availabilityInfo);
                            }
                        }
                    });

                    return {
                        id: passengerId,
                        available: available,
                        reasons: _.uniq(reasons),
                        notes: _.uniq(notes),
                        name: orderPax.firstName,
                        categoryType: orderPax.categoryType,
                        lastName: orderPax.lastName,
                        birthDate: orderPax.dateOfBirth,
                        tickets: orderPax.tickets
                    };
                });
            });
            data.hasPassengersForExchange = !!_.findWhere(data.passengerSegments, { availabilityInfo: 'AVAILABLE' });
            if (orderInfo.flights && orderInfo.flights.length && orderInfo.passengers && orderInfo.passengers.length) {
                data.passengerSegmentChains = [];
                orderInfo.flights.forEach(function (orderSegmentChain) {
                    orderInfo.passengers.forEach(function (orderPassenger) {
                        data.passengerSegmentChains.push({
                            passengerId: orderPassenger.id,
                            chainId: orderSegmentChain.chainId,
                            availabilityInfo: getAvailabilityInfoBySegmentChain(data.passengerSegments, orderPassenger.id, orderSegmentChain.flights.map(function (flight) {
                                return flight.id;
                            }))
                        });
                    });
                });
            }
        }

        return data;
    }

    function getDescPassCountStr(passengers) {
        if (passengers.some(function (pax) {
            return !!pax.categoryCode;
        })) {
            return getDescPassCountStrByCategories(passengers);
        } else {
            return getDescPassCountStrByTypes(passengers);
        }
    }

    function getDescPassCountStrByTypes(passengers) {
        var adultAlias = getAliasWithPrefix('web.passengerTypes.', 'ADULT'),
            childAlias = getAliasWithPrefix('web.passengerTypes.', 'CHILD'),
            infantAlias = getAliasWithPrefix('web.passengerTypes.', 'INFANT'),
            countAdult = _.where(passengers, { type: 'ADULT' }).length,
            countChild = _.where(passengers, { type: 'CHILD' }).length,
            countInfant = _.where(passengers, { type: 'INFANT' }).length;

        var result = utils.suffixCount(countAdult || 0, adultAlias);

        if (countChild) {
            result += ', ' + utils.suffixCount(countChild, childAlias);
        }
        if (countInfant) {
            result += ', ' + utils.suffixCount(countInfant, infantAlias);
        }

        return result;
    }

    function getDescPassCountStrByCategories(passengers) {
        var categories = ['AAA', 'MLA', 'CPA', 'RBG', 'RMG', 'RVG'];
        return categories.map(function (categoryCode) {
            return {
                count: _.where(passengers, { categoryCode: categoryCode }).length,
                alias: getAliasWithPrefix('web.passengerCategories.', categoryCode)
            };
        }).filter(function (category) {
            return category.count;
        }).map(function (category) {
            return utils.suffixCount(category.count, category.alias);
        }).join(', ');
    }

    function initBrandConfig() {
        if (hasAlias('web.brandConfig')) {
            try {
                brandsList = reformatBrandsList(JSON.parse(getAlias('web.brandConfig')));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Invalid web.brandConfig: ', err);

                sendErrorReport('CONFIG_ERROR', 'Invalid web.brandConfig', err.message);
            }
        }
    }

    function initBannersConfig() {
        if (hasAlias('web.bannersConfig')) {
            try {
                bannersList = JSON.parse(getAlias('web.bannersConfig'));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Invalid web.bannersConfig: ', err);

                sendErrorReport('CONFIG_ERROR', 'Invalid web.bannersConfig', err.message);
            }
        }
    }

    function initFfpCompareConfig() {
        try {
            ffpCompareConfig = JSON.parse(getParam('site.ffpCompareConfig'));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid site.ffpCompareConfig: ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid site.ffpCompareConfig', err.message);
        }
    }

    function initRefundConfig() {
        try {
            refundConfig = JSON.parse(getParam('site.refundConfig'));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid site.refundConfig: ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid site.refundConfig', err.message);
        }
    }

    function initMonthSearchConfig() {
        try {
            monthSearchConfig = JSON.parse(getParam('site.monthSearchConfig'));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid site.monthSearchConfig: ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid site.monthSearchConfig', err.message);
        }
    }

    function initSearchGroupsConfig() {
        try {
            searchGroupsConfig = reformatSearchGroupsConfig(JSON.parse(getParam('search.searchCategoriesConfig')), JSON.parse(getParam('site.scannedDocsConfig')));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid search.searchCategoriesConfig or site.scannedDocsConfig : ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid search.searchCategoriesConfig or site.scannedDocsConfig ', err.message);
        }
    }

    function initTaxesGroupsList() {
        try {
            taxesGroupsList = JSON.parse(getParam('pricing.taxesGroupsList'));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid pricing.taxesGroupsList: ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid pricing.taxesGroupsList', err.message);
        }
    }

    function initEnvironmentUrls() {
        try {
            environmentUrls = JSON.parse(getParam('site.environmentUrls'));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid site.environmentUrls: ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid site.environmentUrls', err.message);
        }
    }

    function initSpecialNeedSsrs() {
        try {
            specialNeedSsrs = JSON.parse(getParam('extraServices.specialNeedSsrs')).items;
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid extraServices.specialNeedSsrs: ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid extraServices.specialNeedSsrs', err.message);
        }
    }

    function initFfpMemberTypesConfig() {
        try {
            ffpMemberTypesConfig = JSON.parse(getParam('ffp.memberTypesConfig'));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid ffp.memberTypesConfig: ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid ffp.memberTypesConfig', err.message);
        }
    }

    function initPersonalWheelchairBatteryTypes() {
        try {
            personalWheelchairBatteryTypes = JSON.parse(getParam('extraServices.personalWheelchairBatteryTypes'));
        } catch (err) {
            // eslint-disable-next-line
            console.log('Invalid extraServices.personalWheelchairBatteryTypes: ', err);

            sendErrorReport('CONFIG_ERROR', 'Invalid extraServices.personalWheelchairBatteryTypes', err.message);
        }
    }

    function getSpecialNeedSsrs() {
        return specialNeedSsrs;
    }

    function getFfpMemberTypesConfig() {
        return ffpMemberTypesConfig;
    }

    function getPersonalWheelchairBatteryTypes() {
        return personalWheelchairBatteryTypes;
    }

    function getGroupedSpecialNeedSsrs() {
        var groupIndex = _.groupBy(specialNeedSsrs, 'group');
        return _.keys(groupIndex).map(function (key) {
            return {
                group: key,
                ssrs: groupIndex[key].map(function (item) {
                    return item.ssr;
                })
            };
        });
    }

    function initPhoneCodesMask() {
        if ($window.jQuery && $window.jQuery.masksSort && getParam('site.phoneCodesMask')) {
            try {
                phoneCodesMask = $window.jQuery.masksSort(JSON.parse(getParam('site.phoneCodesMask')), ['#'], /[0-9]|#/, 'mask');
            } catch (err) {
                // eslint-disable-next-line
                console.log('Invalid site.phoneCodesMask: ', err);

                sendErrorReport('CONFIG_ERROR', 'Invalid site.phoneCodesMask', err.message);
            }
        }
    }

    function reformatBrandsList(brandsList) {
        brandsList.forEach(function (brandItem) {
            if (!brandItem.compatible) {
                if (brandItem.compatibleExcludes) {
                    brandItem.compatible = brandsList.map(function (compatBrandItem) {
                        return !utils.hasInList(brandItem.compatibleExcludes, compatBrandItem.code);
                    });
                } else if (brandItem.compatibleIncludes) {
                    brandItem.compatible = brandsList.map(function (compatBrandItem) {
                        return utils.hasInList(brandItem.compatibleIncludes, compatBrandItem.code);
                    });
                } else {
                    brandItem.compatible = brandsList.map(function () {
                        return true;
                    });
                }
            }
        });

        return brandsList;
    }

    function reformatSearchGroupsConfig(searchCategoriesConfig, scannedDocsConfig) {

        var generateCountRangeByStringNotation = function generateCountRangeByStringNotation(text) {
            var min = 0;
            var max = 0;
            if (typeof text === 'string') {
                var textParts = text.split('-');
                if (textParts.length === 1) {
                    min = Number(textParts[0]);
                    max = Number(textParts[0]);
                } else if (textParts.length === 2) {
                    min = Number(textParts[0]);
                    max = Number(textParts[1]);
                }
            }
            return { min: min, max: max };
        };

        var reformatSearchGroupCondition = function reformatSearchGroupCondition(conditionRaw) {
            var condition = {};
            if (conditionRaw.total) {
                condition.total = generateCountRangeByStringNotation(conditionRaw.total);
            }
            if (conditionRaw.adultsTotal) {
                condition.adultsTotal = generateCountRangeByStringNotation(conditionRaw.adultsTotal);
            }
            if (conditionRaw.childrenTotal) {
                condition.childrenTotal = generateCountRangeByStringNotation(conditionRaw.childrenTotal);
            }
            if (conditionRaw.childrenAndInfantsTotal) {
                condition.childrenAndInfantsTotal = generateCountRangeByStringNotation(conditionRaw.childrenAndInfantsTotal);
            }
            return condition;
        };

        var reformatSearchCategory = function reformatSearchCategory(category) {
            return {
                id: category.id,
                frontEndType: category.frontEndType,
                total: generateCountRangeByStringNotation(category.total)
            };
        };

        return searchCategoriesConfig.searchGroups.filter(function (searchGroup) {
            return searchGroup.enabled;
        }).map(function (searchGroup) {
            var result = {
                id: searchGroup.id,
                conditions: searchGroup.conditions.map(reformatSearchGroupCondition),
                categories: searchGroup.categories.filter(function (category) {
                    return category.enabled;
                }).map(reformatSearchCategory)
            };

            if (scannedDocsConfig && scannedDocsConfig.searchGroups) {
                var scannedDocsSearchGroup = _.findWhere(scannedDocsConfig.searchGroups, { id: searchGroup.id });
                if (scannedDocsSearchGroup) {
                    result.verificationMode = scannedDocsSearchGroup.verificationMode;
                    result.allowedBrands = scannedDocsSearchGroup.allowedBrands;
                    result.scannedDocsCategories = scannedDocsSearchGroup.categories;
                }
            }

            return result;
        });
    }

    function reformatNearestDates(nearestDates, params) {
        return nearestDates.filter(function (date) {
            return !date.matching && date.segId !== undefined && (date.earlierMatching || date.laterMatching);
        }).map(function (date) {
            date.segment = params.segments[date.segId];

            return date;
        });
    }

    function checkTabIdParam() {
        var tabIdParam = utils.getParamFromLocation('tabId');
        return !tabIdParam || tabIdParam === uniqueTabIdGenerator();
    }

    function fetchJSON(url, method, data, settings) {
        //console.log('url: ', url);
        if (sessionTimer) {
            $timeout.cancel(sessionTimer);
        }

        if (maxInactiveInterval && sessionInactiveHandler && useSessionTimer && getParam('site.checkSessionInactive')) {
            sessionTimer = $timeout(sessionInactiveHandler, maxInactiveInterval * 1000 - alertInactiveTimeout * 1000);
        }

        if (o2context.jsonMocks && o2context.jsonMocks[url]) {
            url = o2context.jsonMocks[url];
        }

        var requestPromise = $q(function (resolve, reject) {
            var requestProperties = {
                method: method || 'GET',
                url: url,
                headers: {
                    'Unique-Tab-Id': uniqueTabIdGenerator()
                },
                timeout: settings && settings.timeout
            };

            if (o2context.recaptchaToken) {
                data = data || {};
                data.recaptchaToken = o2context.recaptchaToken;
            }

            if (data) {
                if (requestProperties.method === 'POST') {
                    requestProperties.data = data;
                } else if (requestProperties.method === 'GET') {
                    requestProperties.params = data;
                }
            }

            $http(requestProperties).then(function (resp) {
                if (resp.data) {
                    resp.data = utils.deepDecodeQuot(resp.data);

                    if (resp.data.error) {
                        if ((resp.data.error === 'web.captchaRequired' || resp.data.error === 'web.privateoffice.forgetPassword.captchaError') && captchaRequiredHandler && (!settings || !settings.ignoreCaptchaRequired)) {
                            var captchaError = resp.data.error === 'web.privateoffice.forgetPassword.captchaError';
                            captchaRequiredHandler(function (captchaText) {
                                data = data || {};
                                data.captcha = captchaText;

                                fetchJSON(url, method, data, settings).then(function (secondResp) {
                                    delete data.captcha;

                                    resolve(secondResp);
                                }, function (secondResp) {
                                    delete data.captcha;

                                    reject(secondResp);
                                });
                            }, function () {
                                reject(resp.data);
                            }, captchaError);
                        } else {
                            reject(resp.data);
                        }
                    } else if (resp.data.cancelSession || resp.data.cancelParallelSession) {
                        reject({ error: 'cancelSession' });

                        clearSession().then(function () {
                            if (cancelSessionHandler) {
                                cancelSessionHandler(!!resp.data.cancelParallelSession);
                            }
                        });
                    } else {
                        resolve(resp.data);
                    }
                } else {
                    reject({ error: 'web.messages.defaultError' });
                }
            }, function (resp) {
                var errCode = 'web.messages.defaultError';

                if (resp.status === -1) {
                    errCode = 'web.messages.httpAbort';
                }

                reject({ error: errCode });
            });
        });

        if (settings && settings.keyEvent) {
            watchman.notify({
                name: settings.keyEvent,
                type: 'request',
                data: data
            });

            requestPromise.then(overlooker, overlooker);
        }

        return requestPromise;

        function overlooker(resp) {
            watchman.notify({
                name: settings.keyEvent,
                type: 'response',
                data: resp
            });

            return resp;
        }
    }

    function checkOrderEmail(cb) {
        // Если в заказе нет почты и есть возможность её спросить - спрашиваем
        if (orderInfo && !orderInfo.email && orderEmailRequiredHandler) {

            return $q(function (resolve, reject) {
                orderEmailRequiredHandler(function (newEmail) {
                    orderInfo.email = newEmail;
                    fetchJSON('json/set-order-email', 'POST', { email: newEmail }, { keyEvent: 'set-order-email' }).then(resolve, reject);
                }, function () {
                    reject({ error: 'web.messages.checkOrderEmailFail' });
                });
            }).then(cb);
        } else {
            return cb();
        }
    }

    function getCountryByIp() {
        return fetchJSON('json/get-country-by-ip');
    }

    /**
     *
     * @param isoCode {string}
     * @param detectedAutomatically {boolean}
     * @param userAgreed {boolean}
     */
    function confirmCountryDetection() {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            isoCode = _ref4.isoCode,
            detectedAutomatically = _ref4.detectedAutomatically,
            userAgreed = _ref4.userAgreed;

        return fetchJSON('json/confirm-country-detection', 'POST', {
            country: isoCode,
            'detected_automatically': detectedAutomatically,
            'user_agreed': userAgreed
        });
    }

    function reformatExtraServicesPayment(resp) {

        var esp = resp.extraServicesPayment;

        return {
            lastName: resp.lastName,
            pnr: resp.pnr,
            priceChanges: resp.priceChanges,
            extraServicesPayment: esp ? {
                servicesToPayFor: [].concat((0, _toConsumableArray3.default)(setGroupCode(esp.allAeroexpressToPayFor, 'aeroexpress')), (0, _toConsumableArray3.default)(setGroupCode(esp.allRegularInsuranceToPayFor, 'insurance')), (0, _toConsumableArray3.default)(setGroupCode(esp.allOnlineInsuranceToPayFor, 'insurance')), (0, _toConsumableArray3.default)(esp.svcsToPayFor)),
                servicesToRemove: [].concat((0, _toConsumableArray3.default)(setGroupCode(esp.allAeroexpressToRemove, 'aeroexpress')), (0, _toConsumableArray3.default)(setGroupCode(esp.allRegularInsuranceToRemove, 'insurance')), (0, _toConsumableArray3.default)(setGroupCode(esp.allOnlineInsuranceToRemove, 'insurance')), (0, _toConsumableArray3.default)(esp.svcsToRemove)),
                servicesToRemoveIdWithReasons: [].concat((0, _toConsumableArray3.default)(setGroupCode(esp.aeroexpressToRemoveIdWithReasons, 'aeroexpress')), (0, _toConsumableArray3.default)(setGroupCode(esp.regularInsuranceToRemoveIdWithReasons, 'insurance')), (0, _toConsumableArray3.default)(setGroupCode(esp.onlineInsuranceToRemoveIdWithReasons, 'insurance')), (0, _toConsumableArray3.default)(esp.svcToRemoveIdWithReasons)),
                priceToPay: esp.priceToPay,
                priceToPayCurrency: esp.priceToPayCurrency,
                priceForServicesToRemove: esp.priceForServicesToRemove,
                priceForServicesToRemoveCurrency: esp.priceForServicesToRemoveCurrency
            } : false,
            extraServicesToRemoveIds: esp ? {
                aeroexpressToRemoveIds: getIds(esp.allAeroexpressToRemove),
                regularInsuranceToRemoveIds: getIds(esp.allRegularInsuranceToRemove),
                onlineInsuranceToRemoveIds: getIds(esp.allOnlineInsuranceToRemove),
                svcToRemoveIds: getIds(esp.svcsToRemove)
            } : false
        };

        function setGroupCode(list, groupCode) {
            return list.map(function (item) {
                item.groupCode = groupCode;
                return item;
            });
        }

        function getIds(list) {
            return list.map(function (item) {
                return item.id;
            });
        }
    }
}]);

},{"babel-runtime/helpers/extends":9,"babel-runtime/helpers/toConsumableArray":11,"babel-runtime/helpers/typeof":12}],148:[function(require,module,exports){
"use strict";

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('ox').factory('geo', ['$rootScope', 'backend', '$cookies', function ($rootScope, backend, $cookies) {
    var userCountry = void 0;
    var userCountryIsoCode = void 0;
    var countriesList = void 0;
    return function () {
        var init = function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var countryByIp;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(typeof $cookies.get('COUNTRY_BY_IP') !== 'undefined')) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return', Promise.resolve(new Error('COUNTRY_BY_IP cookie is already exist!')));

                            case 2:
                                countryByIp = void 0;
                                _context.prev = 3;
                                _context.next = 6;
                                return backend.getCountryByIp();

                            case 6:
                                countryByIp = _context.sent;
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](3);
                                return _context.abrupt('return', Promise.reject(_context.t0));

                            case 12:
                                _context.next = 14;
                                return backend.getCountriesList().filter(function (item) {
                                    return item.iso;
                                });

                            case 14:
                                countriesList = _context.sent;


                                userCountryIsoCode = countryByIp.isoCode;
                                userCountry = countriesList.filter(function (item) {
                                    return item.iso === userCountryIsoCode;
                                })[0];

                                $rootScope.$broadcast('countriesListChange', countriesList);
                                $rootScope.$broadcast('userCountryByAutoDetectChange', {
                                    userCountry: userCountry,
                                    userCountryIsoCode: userCountryIsoCode
                                });

                                return _context.abrupt('return', Promise.resolve({
                                    countriesList: countriesList,
                                    userCountry: userCountry,
                                    userCountryIsoCode: userCountryIsoCode
                                }));

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 9]]);
            }));

            return function init() {
                return _ref.apply(this, arguments);
            };
        }();

        function getUserCountry() {
            return userCountry;
        }

        function getUserCountryIsoCode() {
            return userCountryIsoCode;
        }

        function getCountriesList() {
            return countriesList;
        }

        /**
         *
         * @param iso {string}
         * @param detectedAutomatically {boolean}
         * @param userAgreed {boolean}
         * @param putCookies {boolean}
         */
        function confirmCountryDetection() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                isoCode = _ref2.isoCode,
                detectedAutomatically = _ref2.detectedAutomatically,
                userAgreed = _ref2.userAgreed,
                _ref2$putCookies = _ref2.putCookies,
                putCookies = _ref2$putCookies === undefined ? true : _ref2$putCookies;

            return backend.confirmCountryDetection({
                isoCode: isoCode,
                detectedAutomatically: detectedAutomatically,
                userAgreed: userAgreed
            }).then(function (data) {
                if (data.isoCode) {
                    var now = new Date();
                    var exp = new Date(now.getFullYear() + 10, now.getMonth(), now.getDate());

                    if (putCookies === true) {
                        $cookies.put('COUNTRY_BY_IP', data.isoCode, exp);
                    }
                }
            });
        }

        return {
            init: init,
            confirmCountryDetection: confirmCountryDetection,
            getUserCountry: getUserCountry,
            getUserCountryIsoCode: getUserCountryIsoCode,
            getCountriesList: getCountriesList
        };
    };
}]);

},{"babel-runtime/helpers/asyncToGenerator":8,"babel-runtime/regenerator":13}],149:[function(require,module,exports){
"use strict";

angular.module('ox').factory('iinUtils', [function () {

    var saveIinHandlers = [];

    return {
        getIinStart: getIinStart,
        getIinCenturyGenderCode: getIinCenturyGenderCode,
        getCenturyByYear: getCenturyByYear,
        getIinCheckSumm: getIinCheckSumm,
        isValidIin: isValidIin,
        isValidIinForPax: isValidIinForPax,
        addSaveIinHander: addSaveIinHander,
        getSaveIinHanders: getSaveIinHanders
    };

    function getIinStart(dateOfBirth, gender) {
        var dateOfBirthMoment = moment(dateOfBirth, 'DD.MM.YYYY');
        return dateOfBirthMoment.format('YYMMDD') + getIinCenturyGenderCode(dateOfBirthMoment, gender);
    }

    function getIinCenturyGenderCode(dateOfBirthMoment, gender) {
        var century = getCenturyByYear(dateOfBirthMoment.year());
        if (gender === 'male') {
            if (century === 19) return '1';else if (century === 20) return '3';else if (century === 21) return '5';
        } else if (gender === 'female') {
            if (century === 19) return '2';else if (century === 20) return '4';else if (century === 21) return '6';
        }
        return '';
    }

    function getCenturyByYear(year) {
        return Math.floor(year / 100) + 1;
    }

    function getIinCheckSumm(iinStr) {
        var a = void 0,
            b = void 0,
            summ = void 0;
        if (iinStr && iinStr.length === 11) {
            a = iinStr.split('');
            b = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            summ = scal(a, b) % 11;
            if (summ === 10) {
                b = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
                summ = scal(a, b) % 11;
            }
            if (summ >= 0 && summ <= 9) {
                return summ;
            }
        }
        return -1;
    }

    function isValidIin(iinStr) {
        if (iinStr && iinStr.length === 12) {
            if (moment(iinStr.substr(0, 6), 'YYMMDD').isValid() && getIinCheckSumm(iinStr.substr(0, 11)) == iinStr[11]) {
                return true;
            }
        }
        return false;
    }

    function isValidIinForPax(iinStr, gender, dateOfBirth) {
        return iinStr.substr(0, 7) === getIinStart(dateOfBirth, gender) && isValidIin(iinStr);
    }

    function scal(A, B) {
        var result = 0;
        if (A && B && A.length === B.length) {
            for (var i = 0; i < A.length; i++) {
                result += A[i] * B[i];
            }
            return result;
        }
    }

    function addSaveIinHander(cb, num) {
        saveIinHandlers[num] = cb;
    }

    function getSaveIinHanders() {
        return saveIinHandlers;
    }
}]);

},{}],150:[function(require,module,exports){
"use strict";

require('./utils');
require('./backend');
require('./watchman');
require('./uniqueTabIdGenerator');
require('./geo');
require('./iinUtils');

},{"./backend":147,"./geo":148,"./iinUtils":149,"./uniqueTabIdGenerator":151,"./utils":152,"./watchman":153}],151:[function(require,module,exports){
"use strict";

angular.module('ox').factory('uniqueTabIdGenerator', ['$window', function ($window) {

    var ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
        TAB_ID_LENGTH = 32;

    return getTabId;

    function getTabId() {
        try {
            return $window.sessionStorage.UNIQUE_TAB_ID || generateNewId();
        } catch (err) {
            return 'NONE';
        }
    }

    function generateNewId() {
        var timestamp = new Date().getTime().toString(),
            randomString = randomBase64(TAB_ID_LENGTH - timestamp.length),
            tabId = timestamp + randomString;
        $window.sessionStorage.UNIQUE_TAB_ID = tabId;
        return tabId;
    }

    function randomBase64(length) {
        var str = '',
            rand = void 0;
        for (var i = 0; i < length; ++i) {
            rand = Math.floor(Math.random() * ALPHABET.length);
            str += ALPHABET.substring(rand, rand + 1);
        }
        return str;
    }
}]);

},{}],152:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('ox').factory('utils', ['$window', function ($window) {
    var service = {
        checkCityEntry: checkCityEntry,
        hasInList: hasInList,
        concatLists: concatLists,
        isDateInPeriod: isDateInPeriod,
        getMinDateFromList: getMinDateFromList,
        getMaxDateFromList: getMaxDateFromList,
        compareStringTime: compareStringTime,
        compareStringDate: compareStringDate,
        compareStringDateTime: compareStringDateTime,
        calcIntervalsIntersection: calcIntervalsIntersection,
        sumStringTime: sumStringTime,
        suffixCount: suffixCount,
        capitalize: capitalize,
        capitalizeFirstLetter: capitalizeFirstLetter,
        getPropSorter: getPropSorter,
        copyPropList: copyPropList,
        getDocumentsNumberRegex: getDocumentsNumberRegex,
        deepDecodeQuot: deepDecodeQuot,
        getInternetExplorerVersion: getInternetExplorerVersion,
        isKonqueror: isKonqueror,
        isSafari: isSafari,
        isPresto: isPresto,
        isKitKat: isKitKat,
        getFlightsInfo: getFlightsInfo,
        getParamFromLocation: getParamFromLocation,
        getFirstNotEmptySubListItem: getFirstNotEmptySubListItem,
        getFirstNotEmptyListItem: getFirstNotEmptyListItem,
        cleanSpaces: cleanSpaces,
        reformatAvailableExtraServices: reformatAvailableExtraServices,
        reformatAvailableExtraServicesByCards: reformatAvailableExtraServicesByCards,
        groupSvcsByFlightPassenger: groupSvcsByFlightPassenger,
        groupSvcsByPassenger: groupSvcsByPassenger,
        groupInsuranceItemsPassengers: groupInsuranceItemsPassengers,
        groupInsuranceItemsFlightPassengers: groupInsuranceItemsFlightPassengers,
        getFirstAvailableSvcsFlight: getFirstAvailableSvcsFlight,
        getFirstAvailableSvcsPassenger: getFirstAvailableSvcsPassenger,
        markInsuranceOnline: markInsuranceOnline,
        getAvailableExtraServicesList: getAvailableExtraServicesList,
        getAvailableExtraServicesesPagesCount: getAvailableExtraServicesesPagesCount,
        isCommonServiceCode: isCommonServiceCode,
        formatDocumentNumber: formatDocumentNumber,
        createOptionsForUiSelect: createOptionsForUiSelect,
        reformatSeatMap: reformatSeatMap,
        reformatSeatMapWithImages: reformatSeatMapWithImages,
        reformatSvcs: reformatSvcs,
        getOrderUniqueEmails: getOrderUniqueEmails,
        isAdvancedRoute: isAdvancedRoute,
        getUnicodeCurrencySign: getUnicodeCurrencySign,
        formatPrice: formatPrice,
        filterCitiesList: filterCitiesList,
        getTimeStepsByRange: getTimeStepsByRange,
        getDateTimeStepsByRange: getDateTimeStepsByRange,
        getSeatCssPropertiesClasses: getSeatCssPropertiesClasses,
        getRowSeatsUniqueCssPropertiesClasses: getRowSeatsUniqueCssPropertiesClasses,
        addToTaxList: addToTaxList,
        isFreePaymentVariants: isFreePaymentVariants,
        getAvailablePassengersCount: getAvailablePassengersCount,
        clearFirstZeroInStringTime: clearFirstZeroInStringTime,
        getCodePropertiesList: getCodePropertiesList,
        reformatSearchParams: reformatSearchParams,
        reformatPureSearchParams: reformatPureSearchParams,
        minTimeFromList: minTimeFromList,
        minPriceFromVariants: minPriceFromVariants,
        getTimeDiff: getTimeDiff,
        getTicketPricesByPassengers: getTicketPricesByPassengers,
        getTicketPricesByPassengerTypes: getTicketPricesByPassengerTypes,
        getViewedServices: getViewedServices,
        getViewedServicesItems: getViewedServicesItems,
        getRemovedServices: getRemovedServices,
        addViewedService: addViewedService,
        addViewedServiceItem: addViewedServiceItem,
        addRemovedService: addRemovedService,
        clearServicesStatistics: clearServicesStatistics,
        getPricesByOrderFlights: getPricesByOrderFlights,
        getSirenaPassengerNameTransliteration: getSirenaPassengerNameTransliteration,
        checkSirenaPassengerFullName: checkSirenaPassengerFullName,
        checkSirenaPassengerFullNameLength: checkSirenaPassengerFullNameLength,
        generateIndexByRfisc: generateIndexByRfisc,
        checkIsPassengerChildForBonusCard: checkIsPassengerChildForBonusCard
    },
        decCache = [],
        decCases = [2, 0, 1, 1, 1, 2];

    return service;

    function getSeatCssPropertiesClasses(seat, prefix) {
        var str = '';

        if (seat.properties) {
            seat.properties.forEach(function (prop) {
                str += prefix + prop;
            });
        }

        return str;
    }

    function getRowSeatsUniqueCssPropertiesClasses(seats, prefix) {
        var props = [];
        var str = '';

        seats.forEach(function (seat) {
            if (seat.properties) {
                seat.properties.forEach(function (prop) {
                    if (!hasInList(props, prop)) {
                        props.push(prop);
                    }
                });
            }
        });

        props.forEach(function (prop) {
            str += prefix + prop;
        });

        return str;
    }

    function checkCityEntry(cityItem, subStr, lang) {
        var relevant = 0;

        var subStrConverted = keyboardConvert(subStr.toUpperCase()),
            shortSubStr = subStr.length < 3,
            cityName = cityItem['name' + capitalize(lang)],
            cityCode = cityItem['code' + capitalize(lang)],
            cityCodeEn = cityItem.codeEn,
            cityNameEn = cityItem.nameEn;

        subStr = subStr.toUpperCase();

        if (cityCodeEn && cityCodeEn.toUpperCase().indexOf(subStr) === 0) {
            relevant += 4;
        }

        if (cityCode && cityCode.toUpperCase().indexOf(subStr) === 0) {
            relevant += 2;
        }

        if (shortSubStr) {
            if (cityName && cityName.toUpperCase().indexOf(subStr) === 0) {
                relevant += 3;
            }

            if (cityNameEn && cityNameEn.toUpperCase().indexOf(subStr) === 0) {
                relevant += 3;
            }

            if (cityName && cityName.toUpperCase().indexOf(subStrConverted) === 0) {
                relevant += 2;
            }

            if (cityNameEn && cityNameEn.toUpperCase().indexOf(subStrConverted) === 0) {
                relevant += 2;
            }
        } else {
            if (cityName && cityName.toUpperCase().indexOf(subStr) === 0) {
                relevant += 3;
            }

            if (cityNameEn && cityNameEn.toUpperCase().indexOf(subStr) === 0) {
                relevant += 3;
            }

            if (cityName && cityName.toUpperCase().indexOf(subStrConverted) === 0) {
                relevant += 2;
            }

            if (cityNameEn && cityNameEn.toUpperCase().indexOf(subStrConverted) === 0) {
                relevant += 2;
            }

            if (cityName && cityName.toUpperCase().indexOf(subStr) !== -1) {
                relevant += 2;
            }

            if (cityNameEn && cityNameEn.toUpperCase().indexOf(subStr) !== -1) {
                relevant += 2;
            }

            if (cityName && cityName.toUpperCase().indexOf(subStrConverted) !== -1) {
                relevant += 1;
            }

            if (cityNameEn && cityNameEn.toUpperCase().indexOf(subStrConverted) !== -1) {
                relevant += 1;
            }
        }

        if (cityItem.popular && relevant) {
            relevant += 1;
        }

        return relevant || false;
    }

    function hasInList(list, item) {
        var i = void 0;

        if (list && item !== undefined) {
            for (i = 0; i < list.length; i++) {
                if (list[i] === item) {
                    return true;
                }
            }
        }

        return false;
    }

    function concatLists(listOfLists) {
        var result = [];

        if (listOfLists && listOfLists.length) {
            for (var i = 0; i < listOfLists.length; i++) {
                for (var j = 0; j < listOfLists[i].length; j++) {
                    result.push(listOfLists[i][j]);
                }
            }
        }

        return result;
    }

    function isDateInPeriod(date, beginDate, endDate) {
        return compareStringDate(date, beginDate) !== -1 && compareStringDate(endDate, date) !== -1;
    }

    function getMinDateFromList(list) {
        var minDate = void 0;

        list.forEach(function (date) {
            if (!minDate || compareStringDate(minDate, date) === 1) {
                minDate = date;
            }
        });

        return minDate;
    }

    function getMaxDateFromList(list) {
        var maxDate = void 0;

        list.forEach(function (date) {
            if (!maxDate || compareStringDate(maxDate, date) === -1) {
                maxDate = date;
            }
        });

        return maxDate;
    }

    function compareStringTime(a, b) {
        a = a.split(':');
        b = b.split(':');

        if (parseInt(a[0], 10) > parseInt(b[0], 10)) {
            return 1;
        } else if (parseInt(a[0], 10) < parseInt(b[0], 10)) {
            return -1;
        } else {
            if (parseInt(a[1], 10) > parseInt(b[1], 10)) {
                return 1;
            } else if (parseInt(a[1], 10) < parseInt(b[1], 10)) {
                return -1;
            } else {
                return 0;
            }
        }
    }

    function compareStringDate(a, b) {

        if (!a && !!b) {
            return -1;
        }
        if (!!a && !b) {
            return 1;
        }
        if (!a && !b) {
            return 0;
        }
        a = a.split('.');
        b = b.split('.');

        if (parseInt(a[2], 10) > parseInt(b[2], 10)) {
            return 1;
        } else if (parseInt(a[2], 10) < parseInt(b[2], 10)) {
            return -1;
        } else {
            if (parseInt(a[1], 10) > parseInt(b[1], 10)) {
                return 1;
            } else if (parseInt(a[1], 10) < parseInt(b[1], 10)) {
                return -1;
            } else {
                if (parseInt(a[0], 10) > parseInt(b[0], 10)) {
                    return 1;
                } else if (parseInt(a[0], 10) < parseInt(b[0], 10)) {
                    return -1;
                } else {
                    return 0;
                }
            }
        }
    }

    function sumStringTime(a, b) {
        var sumTime = [],
            arrA = a.split(':'),
            arrB = b.split(':'),
            hours = +arrA[0] + +arrB[0],
            minutes = +arrA[1] + +arrB[1];

        if (minutes < 60) {
            sumTime.push(hours);
            sumTime.push(minutes);

            return sumTime.join(':');
        } else if (minutes === 60) {
            sumTime.push(hours + 1);
            sumTime.push('00');

            return sumTime.join(':');
        } else {
            sumTime.push(hours + 1);
            sumTime.push(minutes - 60);

            return sumTime.join(':');
        }
    }

    function compareStringDateTime(aStr, bStr) {
        var aSplit = aStr.split(' '),
            bSplit = bStr.split(' ');

        var result = compareStringDate(aSplit[0], bSplit[0]);

        if (result === 0) {
            result = compareStringTime(aSplit[1], bSplit[1]);
        }

        return result;
    }

    function calcIntervalsIntersection(intervals) {
        var datesFrom = [];
        var datesTo = [];
        intervals.forEach(function (interval) {
            var _interval$split = interval.split('-'),
                _interval$split2 = (0, _slicedToArray3.default)(_interval$split, 2),
                from = _interval$split2[0],
                to = _interval$split2[1];

            datesFrom.push(from);
            datesTo.push(to);
        });
        var maxFrom = getMaxDateFromList(datesFrom);
        var minTo = getMinDateFromList(datesTo);
        return {
            from: maxFrom,
            to: minTo
        };
    }

    function suffixCount(count, alias) {
        var aliasParts = String(alias).split(',');

        return count + ' ' + decOfNum(count, aliasParts);
    }

    function decOfNum(number, titles) {
        if (!decCache[number]) {
            decCache[number] = number % 100 > 4 && number % 100 < 20 ? 2 : decCases[Math.min(number % 10, 5)];
        }

        return titles[decCache[number]];
    }

    function capitalize(string) {
        string = String(string).toLowerCase();

        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function capitalizeFirstLetter(string) {
        return String(string).charAt(0).toUpperCase() + string.slice(1);
    }

    function getPropSorter(prop) {
        return function (a, b) {
            a = a[prop];
            b = b[prop];

            if (a > b) {
                return 1;
            } else if (a < b) {
                return -1;
            } else {
                return 0;
            }
        };
    }

    function copyPropList(oldObj, newObj, propList) {
        propList.forEach(function (prop) {
            oldObj[prop] = newObj[prop];
        });
    }

    function getDocumentsNumberRegex() {
        return {
            PS: '[0-9]{10}',
            PSP: '[0-9]{9}'
        };
    }

    function deepDecodeQuot(data) {
        var key = void 0;

        if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
            for (key in data) {
                if (data.hasOwnProperty(key)) {
                    data[key] = deepDecodeQuot(data[key]);
                }
            }

            return data;
        } else if (typeof data === 'string') {
            return data.replace(/&quot;/g, '"');
        } else {
            return data;
        }
    }

    function getInternetExplorerVersion() {
        var ua = $window.navigator.userAgent;

        var rv = -1,
            re = void 0;

        if ($window.navigator.appName === 'Microsoft Internet Explorer') {
            re = new RegExp("MSIE ([0-9]+[0-9]*)");

            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        } else if ($window.navigator.appName === 'Netscape') {
            re = new RegExp("Trident/.*rv:([0-9]+[0-9]*)");

            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        }

        if ($window.navigator.userAgent.indexOf('Edge') > -1) {
            rv = 'Edge';
        }

        return rv;
    }

    function getAndroidVersion() {
        var ua = $window.navigator.userAgent.toLowerCase(),
            match = ua.match(/android\s([0-9]*)/);

        return match ? match[1] : false;
    }

    function isSafari() {
        var ua = $window.navigator.userAgent.toLowerCase();

        return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
    }

    function isKonqueror() {
        var ua = $window.navigator.userAgent.toLowerCase();

        return ua.indexOf('konqueror') !== -1;
    }

    function isPresto() {
        var ua = $window.navigator.userAgent.toLowerCase();

        return ua.indexOf('presto') !== -1;
    }

    function isKitKat() {
        var version = getAndroidVersion(),
            baseVersion = version && version.substr(0, 1);

        return baseVersion === '4';
    }

    function getFlightsInfo(chain, transferMessage, noTransferMessage) {
        var arrName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'flights';

        var departuretime = chain[arrName][0].departuretime,
            departuredate = chain[arrName][0].departuredate,
            brand = chain[arrName][0].brand,
            origincityName = chain[arrName][0].origincityName,
            origincity = chain[arrName][0].origincity,
            originportName = chain[arrName][0].originportName,
            originport = chain[arrName][0].originport,
            arrivaltime = chain[arrName][chain[arrName].length - 1].arrivaltime,
            arrivaldate = chain[arrName][chain[arrName].length - 1].arrivaldate,
            destinationcityName = chain[arrName][chain[arrName].length - 1].destinationcityName,
            destinationcity = chain[arrName][chain[arrName].length - 1].destinationcity,
            destinationportName = chain[arrName][chain[arrName].length - 1].destinationportName,
            destinationport = chain[arrName][chain[arrName].length - 1].destinationport,
            flighttime = chain.flightTime || chain[arrName][0].flighttime || chain[arrName][0].flightTime,
            connections = chain.connections,
            landings = [];

        var connectionsMessage = noTransferMessage;

        chain[arrName].forEach(function (flight) {
            if (flight.landings) {
                flight.landings.forEach(function (landing) {
                    landings.push(landing);
                });
            }
        });

        if (connections && connections.length && transferMessage) {
            connectionsMessage = connections.length + ' ';
            connectionsMessage += transferMessage.split(',')[connections.length === 1 ? 0 : 1];
        }

        return {
            brand: brand,
            origincityName: origincityName,
            origincity: origincity,
            originportName: originportName,
            originport: originport,
            destinationcityName: destinationcityName,
            destinationcity: destinationcity,
            destinationportName: destinationportName,
            destinationport: destinationport,
            departuretime: departuretime,
            departuredate: departuredate,
            departuredayshift: chain[arrName][0].departuredayshift || 0,
            arrivaltime: arrivaltime,
            arrivaldate: arrivaldate,
            arrivaldayshift: chain[arrName][chain[arrName].length - 1].arrivaldayshift || 0,
            flighttime: flighttime,
            landings: landings,
            connections: connections,
            connectionsMessage: connectionsMessage
        };
    }

    function getParamFromLocation(name) {
        var re = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)'),
            matches = re.exec($window.location.search);
        if (matches && matches[1]) {
            return tryDecodeURIComponent(matches[1]);
        }
    }

    function tryDecodeURIComponent(str) {
        try {
            str = decodeURIComponent(str);
        } catch (e) {
            // eslint-disable-next-line
            console.error('tryDecodeURIComponent:', e);
        }

        return str;
    }

    function getFirstNotEmptySubListItem(list) {
        var resultItem = void 0;

        list.forEach(function (subList) {
            if (subList.length && !resultItem) {
                subList.forEach(function (item) {
                    if (item && !resultItem) {
                        resultItem = item;
                    }
                });
            }
        });

        return resultItem;
    }

    function getFirstNotEmptyListItem(list) {
        var resultItem = void 0;

        list.forEach(function (item) {
            if (item && !resultItem) {
                resultItem = item;
            }
        });

        return resultItem;
    }

    function cleanSpaces(str) {
        if (str) {
            str = str.replace(/\s/g, '');
        }

        return str;
    }

    function reformatAvailableExtraServices(availableExtraServices, orderInfo, oldES) {
        var es = {},
            hasIssuedSeats = orderInfo && orderInfo.pricesIssued && orderInfo.pricesIssued.totalExtraServiceByGroup.seat;

        var hasAvailableSeatSegment = false;

        if (!availableExtraServices) {
            availableExtraServices = [];
        }

        // OS-1058 Показывать оплаченные места независимо от доступности
        if (hasIssuedSeats && !_.findWhere(availableExtraServices, { code: 'seat' }) && $window.o2context.oxyTheme === 'websky') {
            availableExtraServices.push({
                code: 'seat',
                svcs: []
            });
        }

        if (!availableExtraServices.length) {
            return false;
        }

        if (orderInfo.prices) {
            availableExtraServices.map(markInsuranceOnline).forEach(function (service) {
                var editablePrice = orderInfo.pricesEditable && orderInfo.pricesEditable.totalExtraServiceByGroup[service.code] ? {
                    price: orderInfo.pricesEditable.totalExtraServiceByGroup[service.code],
                    currency: orderInfo.pricesEditable.currency
                } : false;

                if (service.code === 'insurance') {
                    if (service.items && service.items.length) {
                        var items = service.items.map(function (item) {
                            item.marker = reformatServiceMarker(item.marker);
                            return item;
                        });
                        if (service.autoExpand && service.items.length === 1) {
                            service.autoExpand = false;
                            // eslint-disable-next-line
                            console.log('Auto expand blocked for single insurance');
                        }
                        es.insurance = {
                            code: 'insurance',
                            active: !!(editablePrice || service.autoExpand || oldES && oldES.insurance && oldES.insurance.active),
                            dropOpened: !!(service.autoExpand || oldES && oldES.insurance && oldES.insurance.active),
                            editablePrice: editablePrice,
                            items: items,
                            itemsByPassengers: getInsuranceItemsByPassengers(angular.copy(items), orderInfo.passengers),
                            itemsBySegmentsPassengers: getInsuranceItemsBySegmentsPassengers(angular.copy(items), orderInfo.passengers, orderInfo.plainFlights),
                            fullPrice: getInsuranceFullPrice(service, orderInfo.passengers.length),
                            minPrice: getInsuranceMinPrice(service),
                            onlineMode: service.onlineMode || false,
                            marker: reformatServiceMarker(service.marker)
                        };

                        if (es.insurance.itemsBySegmentsPassengers) {
                            setActiveInsuranceItemsStateBySegmentsPassengers(es.insurance.itemsBySegmentsPassengers, orderInfo, service.onlineMode);
                        }
                        if (es.insurance.itemsByPassengers) {
                            setActiveInsuranceItemsStateByPassengers(es.insurance.itemsByPassengers, orderInfo, service.onlineMode);
                        }
                        if (es.insurance.items) {
                            setActiveInsuranceItems(es.insurance.items, orderInfo, service.onlineMode);
                        }
                    }
                } else if (service.code === 'aeroexpress') {

                    es.aeroexpress = {
                        code: 'aeroexpress',
                        active: !!(editablePrice || service.autoExpand || oldES && oldES.aeroexpress && oldES.aeroexpress.active),
                        dropOpened: !!(service.autoExpand || oldES && oldES.aeroexpress && oldES.aeroexpress.active),
                        editablePrice: editablePrice,
                        items: service.items,
                        documents: service.documents,
                        passengerFirstNameRegexp: service.passengerFirstNameRegexp,
                        passengerLastNameRegexp: service.passengerLastNameRegexp,
                        optimal: reformatAeroexpressOptimal(service.optimal),
                        faresList: getAeroexpressFaresList(service.items),
                        minPrice: getAeroexpressServiceMinPrice(service),
                        marker: reformatServiceMarker(service.marker)
                    };

                    es.aeroexpress.routes = getAeroexpressRoutes(service);
                    es.aeroexpress.routesList = _.keys(es.aeroexpress.routes);
                } else if (service.code === 'meal') {
                    es.meal = {
                        code: 'meal',
                        active: !!(editablePrice || service.autoExpand || oldES && oldES.meal && oldES.meal.active),
                        dropOpened: !!(service.autoExpand || oldES && oldES.meal && oldES.meal.active),
                        defaultSelected: service.defaultSelected || false,
                        editablePrice: editablePrice,
                        itemsByPassengerSegments: getItemsByPassengerSegments(orderInfo, service),
                        availableByPassengerSegments: getAvailableByPassengerSegments(orderInfo, service),
                        subgroups: service.structure.subgroups.map(function (subgroup) {
                            return subgroup.code;
                        }),
                        minPrice: getServiceMinPrice(service),
                        pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(orderInfo, 'meal'),
                        marker: reformatServiceMarker(service.marker)
                    };

                    es.meal.availableBySegments = getAvailableBySegments(es.meal.availableByPassengerSegments);
                    es.meal.pricesBySegments = getPricesBySegments(es.meal.pricesByPassengerSegments);

                    setActiveMealItemsState(es.meal.itemsByPassengerSegments, orderInfo);
                } else if (service.code === 'seat') {
                    es.seat = {
                        code: 'seat',
                        active: !!(editablePrice || service.autoExpand || oldES && oldES.seat && oldES.seat.active),
                        dropOpened: !!(service.autoExpand || oldES && oldES.seat && oldES.seat.active),
                        editablePrice: editablePrice,
                        itemsByPassengerSegments: getItemsByPassengerSegments(orderInfo, service),
                        availableByPassengerSegments: getAvailableByPassengerSegments(orderInfo, service),
                        minPrice: getServiceMinPrice(service),
                        commonSubgroup: getServiceCommonSubgroup(service),
                        selectedSeatsByPassengerSegments: getSeatsByPassengerSegments(orderInfo, 'editable'),
                        issuedSeatsByPassengerSegments: getSeatsByPassengerSegments(orderInfo, 'issued'),
                        pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(orderInfo, 'seat'),
                        unavailableBecauseOfCheckInBySegments: service.unavailableBecauseOfCheckInBySegments,
                        marker: reformatServiceMarker(service.marker),
                        markerByRfisc: generateMarkerByRfisc(service.passengers)
                    };

                    es.seat.availableBySegments = getAvailableBySegments(es.seat.availableByPassengerSegments);
                    es.seat.hasIssuedSeatsBySegments = getHasIssuedBySegments(es.seat.issuedSeatsByPassengerSegments);

                    es.seat.availableBySegments.forEach(function (hasSeg) {
                        if (!hasAvailableSeatSegment && hasSeg) {
                            hasAvailableSeatSegment = true;
                        }
                    });

                    es.seat.pricesBySegments = getPricesBySegments(es.seat.pricesByPassengerSegments);

                    if (!hasAvailableSeatSegment && !hasIssuedSeats && !service.unavailableBecauseOfCheckInBySegments) {
                        delete es.seat;
                    }
                } else if (service.code === 'baggage') {
                    es.baggage = {
                        code: 'baggage',
                        active: !!(editablePrice || service.autoExpand || oldES && oldES.baggage && oldES.baggage.active),
                        dropOpened: !!(service.autoExpand || oldES && oldES.baggage && oldES.baggage.active),
                        editablePrice: editablePrice,
                        availableByPassengerSegments: getAvailableByPassengerSegments(orderInfo, service),
                        itemsByPassengerSegments: getItemsByPassengerSegments(orderInfo, service),
                        pricesByPassengers: getBaggagePricesByPassengers(orderInfo),
                        pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(orderInfo, 'baggage'),
                        minPrice: getServiceMinPrice(service),
                        subgroups: service.structure.subgroups,
                        marker: reformatServiceMarker(service.marker)
                    };

                    es.baggage.availableBySegments = getAvailableBySegments(es.baggage.availableByPassengerSegments);
                    es.baggage.pricesBySegments = getPricesBySegments(es.baggage.pricesByPassengerSegments);

                    if (!es.baggage.availableByPassengerSegments) {
                        delete es.baggage;
                    }
                } else if (service.code === 'smsNotifications') {
                    es.smsNotifications = {
                        code: 'smsNotifications',
                        active: !!(editablePrice || service.autoExpand || oldES && oldES.smsNotifications && oldES.smsNotifications.active),
                        dropOpened: !!(service.autoExpand || oldES && oldES.smsNotifications && oldES.smsNotifications.active),
                        editablePrice: editablePrice,
                        itemsByPassengers: getItemsByPassengers(orderInfo, service),
                        minPrice: getServiceMinPrice(service),
                        subgroups: service.structure.subgroups,
                        commonSubgroup: getServiceCommonSubgroup(service),
                        marker: reformatServiceMarker(service.marker)
                    };
                } else {
                    es[service.code] = getCommonServiceInfo(orderInfo, oldES, service);
                }
            });
        }

        return es;
    }

    function reformatAvailableExtraServicesByCards(availableExtraServices, orderInfo, oldES) {
        var es = {};
        if (orderInfo.prices) {
            availableExtraServices.map(markInsuranceOnline).forEach(function (availableExtraService) {
                var svcs = availableExtraService.svcs,
                    autoExpand = availableExtraService.autoExpand,
                    code = availableExtraService.code;

                var editablePrice = false;
                if (orderInfo.pricesEditable && orderInfo.pricesEditable.totalExtraServiceByGroup[code]) {
                    editablePrice = {
                        price: orderInfo.pricesEditable.totalExtraServiceByGroup[code],
                        currency: orderInfo.pricesEditable.currency
                    };
                }
                if (svcs) {
                    var uniqueServices = [].concat((0, _toConsumableArray3.default)(new Set(svcs.map(function (svc) {
                        return svc.rfisc;
                    }))));
                    svcs.forEach(function (availableSvc) {
                        var selectedSvc = availableSvc.groupCode === 'smsNotifications' ? _.findWhere(orderInfo.allExtraServicesHeap, {
                            groupCode: availableSvc.groupCode,
                            passengerId: availableSvc.passengerId,
                            rfisc: availableSvc.rfisc
                        }) : _.findWhere(orderInfo.editableExtraServicesHeap, {
                            groupCode: availableSvc.groupCode,
                            passengerId: availableSvc.passengerId,
                            segmentId: availableSvc.segmentId,
                            rfisc: availableSvc.rfisc
                        });
                        if (selectedSvc) {
                            if (selectedSvc.amount) {
                                availableSvc.alreadySelectedCount = selectedSvc.amount;
                            }
                            if (selectedSvc.extraProperties) {
                                availableSvc.extraProperties = selectedSvc.extraProperties;
                            }
                            if (selectedSvc.totalPrice) {
                                availableSvc.alreadySelectedPrice = selectedSvc.totalPrice;
                            }
                            if (selectedSvc.value) {
                                availableSvc.alreadySelectedValue = selectedSvc.value;
                            }
                            if (selectedSvc.currency) {
                                availableSvc.currency = selectedSvc.currency;
                            }
                            if (selectedSvc.status === 'ISSUED_WITH_EMD') {
                                availableSvc.paid = true;
                            }
                        }
                    });
                    es[availableExtraService.code] = (0, _extends3.default)({}, availableExtraService, {
                        active: autoExpand || oldES && oldES[code] && oldES[code].active,
                        editablePrice: editablePrice,
                        minPrice: !!availableExtraService.showMinPrice && getServiceMinPrice(availableExtraService),
                        cards: uniqueServices.map(function (rfisc) {
                            var rfiscSvcs = svcs.filter(function (svc) {
                                return svc.rfisc === rfisc;
                            });
                            return {
                                rfisc: rfisc,
                                svcs: rfiscSvcs,
                                alreadySelectedPrice: calcAlreadySelectedPriceBySvcs(rfiscSvcs),
                                alreadySelectedByValue: calcAlreadySelectedByValueBySvcs(rfiscSvcs),
                                alreadySelectedCount: calcAlreadySelectedCountBySvcs(rfiscSvcs)
                            };
                        })
                    });
                    es[availableExtraService.code].alreadySelectedCount = calcAlreadySelectedCountByCards(es[availableExtraService.code].cards);
                } else if (availableExtraService.code === 'insurance') {
                    es.insurance = (0, _extends3.default)({}, availableExtraService, {
                        active: autoExpand || oldES && oldES[code] && oldES[code].active,
                        editablePrice: editablePrice,
                        minPrice: getInsuranceMinPrice(availableExtraService),
                        fullPrice: getInsuranceFullPrice(availableExtraService, orderInfo.passengers.length),
                        onlineMode: availableExtraService.onlineMode || false,
                        marker: reformatServiceMarker(availableExtraService.marker),
                        cards: []
                    });
                    if (es.insurance.items) {
                        setActiveInsuranceCardItems(es.insurance.items, orderInfo, availableExtraService.onlineMode);
                        es.insurance.items.forEach(function (item) {
                            var itemCard = _.findWhere(es.insurance.cards, {
                                ins: item.ins,
                                tins: item.tins,
                                productCode: item.productCode
                            });
                            if (itemCard) {
                                itemCard.items.push(item);
                                itemCard.alreadySelectedPrice = calcAlreadySelectedPriceByInsuranceItems(itemCard.items, orderInfo.passengers.length);
                            } else {
                                var insTinsProductCode = [item.ins, item.tins, item.productCode];
                                var itemId = insTinsProductCode.join('.');
                                var imageName = insTinsProductCode.join('_');
                                var productType = item.productCode ? 'insuranceOnline' : 'insurance';
                                var nameAlias = 'web.' + productType + '.' + itemId;
                                var descAlias = 'web.' + productType + '.currentRules.' + itemId;
                                var shortDescAlias = 'web.' + productType + '.shortCurrentRules.' + itemId;
                                var vendorImage = 'insurance-vendors/' + imageName + '.svg';
                                var promoImage = 'insurance-products/' + imageName + '.jpeg';
                                var promoLogo = 'insurance-logos/' + imageName + '.svg';
                                es.insurance.cards.push({
                                    ins: item.ins,
                                    tins: item.tins,
                                    productCode: item.productCode,
                                    nameAlias: nameAlias,
                                    descAlias: descAlias,
                                    shortDescAlias: shortDescAlias,
                                    vendorImage: vendorImage,
                                    promoImage: promoImage,
                                    promoLogo: promoLogo,
                                    items: [item],
                                    alreadySelectedPrice: calcAlreadySelectedPriceByInsuranceItems([item], orderInfo.passengers.length)
                                });
                            }
                        });
                    }
                } else if (availableExtraService.code === 'aeroexpress') {
                    es.aeroexpress = (0, _extends3.default)({}, availableExtraService, {
                        active: autoExpand || oldES && oldES[code] && oldES[code].active,
                        editablePrice: editablePrice,
                        optimal: reformatAeroexpressOptimal(availableExtraService.optimal),
                        faresList: getAeroexpressFaresList(availableExtraService.items),
                        minPrice: !!availableExtraService.showMinPrice && getAeroexpressServiceMinPrice(availableExtraService),
                        marker: reformatServiceMarker(availableExtraService.marker)
                    });
                    es.aeroexpress.routes = getAeroexpressRoutes(availableExtraService);
                    es.aeroexpress.routesList = _.keys(es.aeroexpress.routes);
                }
            });
        }
        return es;
    }

    function calcAlreadySelectedPriceBySvcs(svcs) {
        var alreadySelectedPrice = Big('0.00').toFixed(2);
        svcs.forEach(function (svc) {
            if (svc.alreadySelectedPrice) {
                alreadySelectedPrice = Big(alreadySelectedPrice).plus(svc.alreadySelectedPrice).toFixed(2);
            }
        });
        if (alreadySelectedPrice === '0.00') {
            return false;
        }
        return alreadySelectedPrice;
    }

    function calcAlreadySelectedByValueBySvcs(svcs) {
        var alreadySelectedByValue = {};
        svcs.forEach(function (svc) {
            if (svc.alreadySelectedValue) {
                alreadySelectedByValue[svc.alreadySelectedValue] = true;
            }
        });
        return alreadySelectedByValue;
    }

    function calcAlreadySelectedCountByCards(cards) {
        var alreadySelectedCount = 0;
        cards.forEach(function (card) {
            if (card.alreadySelectedCount) {
                alreadySelectedCount += card.alreadySelectedCount;
            }
        });
        return alreadySelectedCount;
    }

    function calcAlreadySelectedCountBySvcs(svcs) {
        var alreadySelectedCount = 0;
        svcs.forEach(function (svc) {
            if (svc.alreadySelectedCount) {
                alreadySelectedCount += svc.alreadySelectedCount;
            }
        });
        return alreadySelectedCount;
    }

    function calcAlreadySelectedPriceByInsuranceItems(items, paxCount) {
        var alreadySelectedPrice = Big('0.00').toFixed(2);
        items.forEach(function (item) {
            if (item.selected) {
                if (item.price) {
                    alreadySelectedPrice = Big(alreadySelectedPrice).plus(item.price).toFixed(2);
                }
                if (item.insurance_premium || item.luggage_premium) {
                    alreadySelectedPrice = Big(alreadySelectedPrice).plus(Big(item.insurance_premium || 0).plus(item.luggage_premium || 0).times(paxCount)).toFixed(2);
                }
            }
        });
        if (alreadySelectedPrice === '0.00') {
            return false;
        }
        return alreadySelectedPrice;
    }

    function markInsuranceOnline(service) {
        if (service.code === 'insuranceOnline') {
            service.code = 'insurance';
            service.onlineMode = true;
        }

        return service;
    }

    function getAvailableExtraServicesList(availableExtraServices, es, esCurrentPage) {
        return availableExtraServices.filter(function (service) {
            return (!service.page || !esCurrentPage || service.page <= esCurrentPage) && !!es[service.code];
        }).map(function (service) {
            return service.code;
        });
    }

    function getAvailableExtraServicesesPagesCount(availableExtraServices) {
        var maxPage = 1;
        availableExtraServices.forEach(function (service) {
            if (service.page && service.page > maxPage) {
                maxPage = service.page;
            }
        });
        return maxPage;
    }

    function isCommonServiceCode(code) {
        return code !== 'seat' && code !== 'baggage' && code !== 'meal' && code !== 'gateMeal' && code !== 'smsNotifications' && code !== 'insurance' && code !== 'insuranceOnline' && code !== 'ruleBusters' && code !== 'aeroexpress';
    }

    function formatDocumentNumber(value) {
        // общее ограничение на номера документов в Сирене
        // только цифры или буквы русского (без Ё и Ъ) и латинского алфавита, не более 17 символов
        var allowedChars = '0123456789АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЫЭЮЯABCDEFGHIJKLMNOPQRSTUVWXYZ';

        if (value) {
            value = value.toUpperCase();
            value = value.split('').filter(function (letter, i) {
                return i < 17 && allowedChars.indexOf(letter) !== -1;
            }).join('');
        }

        return value;
    }

    function getCodePropertiesList(obj) {
        return _.keys(obj).filter(function (key) {
            return key.indexOf('code') === 0;
        });
    }

    function reformatPureSearchParams(pureSearchParams) {
        var apiParams = {};
        _.keys(pureSearchParams).forEach(function (paramName) {
            if (pureSearchParams[paramName] !== '') {
                apiParams[paramName] = pureSearchParams[paramName];
            }
        });
        return apiParams;
    }

    function reformatSearchParams(searchParams) {
        var apiParams = {
            'searchGroupId': searchParams.searchGroupId,
            'segmentsCount': searchParams.segments.length
        };

        searchParams.segments.forEach(function (segment, i) {
            apiParams['date[' + i + ']'] = segment.date;
            apiParams['origin-city-code[' + i + ']'] = segment.origin.codeEn;
            apiParams['destination-city-code[' + i + ']'] = segment.destination.codeEn;

            if (segment.origin.airports) {
                segment.origin.airports.forEach(function (airport) {
                    if (airport.selected) {
                        apiParams['origin-port-code[' + i + ']'] = airport.codeEn;
                    }
                });
            }

            if (segment.destination.airports) {
                segment.destination.airports.forEach(function (airport) {
                    if (airport.selected) {
                        apiParams['destination-port-code[' + i + ']'] = airport.codeEn;
                    }
                });
            }
        });

        searchParams.passengers.forEach(function (passengerCategory) {
            apiParams[passengerCategory.id + 'Count'] = passengerCategory.count;
        });

        if (searchParams.promoCode) {
            apiParams.promo_code = searchParams.promoCode;
        }

        if (searchParams.business) {
            apiParams.business = 'true';
        }

        if (o2context.externalSearchParams) {
            if (o2context.externalSearchParams['search-engine']) {
                apiParams['search-engine'] = o2context.externalSearchParams['search-engine'];
            }
            if (o2context.externalSearchParams['redirect-id']) {
                apiParams['redirect-id'] = o2context.externalSearchParams['redirect-id'];
            }
            if (o2context.externalSearchParams.currency) {
                apiParams.currency = o2context.externalSearchParams.currency;
                if (service.sessionParams) {
                    service.sessionParams.currency = o2context.externalSearchParams.currency;
                }
            }
        }

        return apiParams;
    }

    // Private methods
    function keyboardConvert(str) {
        var ruKb = 'ЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ',
            enKb = 'QWERTYUIOP[]ASDFGHJKL;\'ZXCVBNM,.';

        var newStr = '';

        str.split('').forEach(function (c) {
            var indexRu = ruKb.indexOf(c),
                indexEn = enKb.indexOf(c);

            if (indexRu !== -1) {
                newStr += enKb[indexRu];
            }

            if (indexEn !== -1) {
                newStr += ruKb[indexEn];
            }
        });

        return newStr || str;
    }

    function getServiceCommonSubgroup(service) {
        var commonSubgroup = 'common';

        if (service.structure && service.structure.subgroups) {
            if (service.structure.subgroups[0] && service.structure.subgroups[0].code) {
                commonSubgroup = service.structure.subgroups[0].code;
            }
        }

        return commonSubgroup;
    }

    function getSeatsByPassengerSegments(orderInfo, mode) {
        var orderSeatService = _.findWhere(orderInfo[mode + '_extra_services'], { code: 'seat' });
        if (orderInfo.passengers) {
            return orderInfo.passengers.map(function (passenger) {
                return orderInfo.plainFlights.map(function (flight) {
                    if (orderSeatService && orderSeatService.selectedSvcs) {
                        var selectedSvcsByPaxFlight = orderSeatService.selectedSvcs.filter(function (svc) {
                            return svc.passengerId === passenger.id && svc.segmentId === flight.id;
                        });
                        return selectedSvcsByPaxFlight[0] || false;
                    } else {
                        return false;
                    }
                });
            });
        }
    }

    function getCommonServiceInfo(orderInfo, oldES, service) {
        var hasAvailable = false;

        var editablePrice = orderInfo.pricesEditable && orderInfo.pricesEditable.totalExtraServiceByGroup[service.code],
            info = {
            code: service.code,
            active: !!(editablePrice || service.autoExpand || oldES && oldES[service.code] && oldES[service.code].active),
            dropOpened: !!(service.autoExpand || oldES && oldES[service.code] && oldES[service.code].active),
            iconCode: service.iconCode || 'none',
            defaultSelected: service.defaultSelected || false,
            showMinPrice: service.showMinPrice || false,
            bulkAdd: service.bulkAdd,
            availableByPassengerSegments: getAvailableByPassengerSegments(orderInfo, service),
            itemsByPassengerSegments: getItemsByPassengerSegments(orderInfo, service),
            pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(orderInfo, service.code),
            fullPrice: getCommonServiceFullPrice(service),
            minPrice: getServiceMinPrice(service),
            editablePrice: editablePrice ? {
                price: editablePrice,
                currency: orderInfo.pricesEditable.currency
            } : false,
            commonSubgroup: getServiceCommonSubgroup(service),
            marker: reformatServiceMarker(service.marker)
        };

        info.availableBySegments = getAvailableBySegments(info.availableByPassengerSegments);
        info.pricesBySegments = getPricesBySegments(info.pricesByPassengerSegments);

        info.availableBySegments.forEach(function (hasSeg) {
            if (!hasAvailable && hasSeg) {
                hasAvailable = true;
            }
        });

        if (!hasAvailable) {
            return null;
        } else {
            return info;
        }
    }

    function getCommonServiceFullPrice(service) {
        var fullPrice = Big('0.00').toFixed(2),
            currency = void 0;

        if (service.passengers) {
            service.passengers.forEach(function (pass) {
                pass.segments.forEach(function (passSeg) {
                    var item = getFirstNotEmptySubListItem(passSeg.availableExtraServices);

                    if (item) {
                        if (item.price) {
                            fullPrice = Big(fullPrice).plus(item.price).toFixed(2);
                        }

                        if (item.currency && !currency) {
                            currency = item.currency;
                        }
                    }
                });
            });
        }

        return {
            price: fullPrice,
            currency: currency
        };
    }

    function getCommonServicePricesByPassengerSegments(orderInfo, serviceCode) {
        return orderInfo.passengers.map(function (passenger, passengerNum) {
            return orderInfo.plainFlights.map(function (segment, segmentNum) {
                var summByPassengerSegment = Big(0);

                if (orderInfo.groupedEditableExtraServices && orderInfo.groupedEditableExtraServices[serviceCode] && orderInfo.groupedEditableExtraServices[serviceCode][passengerNum] && orderInfo.groupedEditableExtraServices[serviceCode][passengerNum][segmentNum]) {
                    orderInfo.groupedEditableExtraServices[serviceCode][passengerNum][segmentNum].forEach(function (item) {
                        if (item.totalPrice) {
                            summByPassengerSegment = summByPassengerSegment.plus(item.totalPrice);
                        }
                    });
                }

                if (summByPassengerSegment.eq(0)) {
                    return false;
                } else {
                    return summByPassengerSegment.toFixed(2);
                }
            });
        });
    }

    function getBaggagePricesByPassengers(orderInfo) {
        if (orderInfo.editableExtraServicesByPassengers) {
            return orderInfo.editableExtraServicesByPassengers.map(function (item) {
                var passengerPrice = false;

                if (item && item.passengerSegmentServices) {
                    item.passengerSegmentServices.forEach(function (segment) {
                        if (segment) {
                            segment.forEach(function (service) {
                                if (service.code === 'baggage' && service.items) {
                                    service.items.forEach(function (item) {
                                        if (item.totalPrice) {
                                            passengerPrice = Big(passengerPrice || '0.00').plus(item.totalPrice).toFixed(2);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }

                return passengerPrice;
            });
        } else {
            return orderInfo.passengers.map(function () {
                return false;
            });
        }
    }

    function setActiveInsuranceCardItems(items, orderInfo, onlineMode) {
        var editableInsuranceService = void 0,
            editableInsuranceServiceItems = void 0;

        if (orderInfo.editable_extra_services) {
            editableInsuranceService = _.findWhere(orderInfo.editable_extra_services, { code: 'insurance' });
            if (editableInsuranceService && editableInsuranceService.items && editableInsuranceService.items[0] && (editableInsuranceService.items[0][0] || onlineMode)) {
                editableInsuranceServiceItems = onlineMode ? editableInsuranceService.items : editableInsuranceService.items[0];

                editableInsuranceServiceItems.forEach(function (editableInsuranceServiceItem) {
                    items.forEach(function (item) {
                        if (item.ins === editableInsuranceServiceItem.ins && item.tins === editableInsuranceServiceItem.tins && (!item.passengerId || item.passengerId === editableInsuranceServiceItem.passengerId) && (!item.segmentId || item.segmentId === editableInsuranceServiceItem.segmentId) && (!onlineMode || item.productCode === editableInsuranceServiceItem.productCode)) {
                            item.selected = true;
                        }
                    });
                });
            }
        }
    }

    function setActiveInsuranceItems(items, orderInfo, onlineMode) {
        var editableInsuranceService = void 0,
            editableInsuranceServiceItems = void 0;

        if (orderInfo.editable_extra_services) {
            editableInsuranceService = _.findWhere(orderInfo.editable_extra_services, { code: 'insurance' });
            if (editableInsuranceService && editableInsuranceService.items && editableInsuranceService.items[0] && (editableInsuranceService.items[0][0] || onlineMode)) {
                editableInsuranceServiceItems = onlineMode ? editableInsuranceService.items : editableInsuranceService.items[0];

                editableInsuranceServiceItems.forEach(function (editableInsuranceServiceItem) {
                    items.forEach(function (item) {
                        if (item.ins === editableInsuranceServiceItem.ins && item.tins === editableInsuranceServiceItem.tins && (!onlineMode || item.productCode === editableInsuranceServiceItem.productCode)) {
                            item.selected = true;
                        }
                    });
                });
            }
        }
    }

    function setActiveInsuranceItemsStateByPassengers(itemsByPassengers, orderInfo, onlineMode) {
        var editableInsuranceService = void 0,
            editableInsuranceServiceItems = void 0;

        if (orderInfo.editable_extra_services) {
            editableInsuranceService = _.findWhere(orderInfo.editable_extra_services, { code: 'insurance' });
            if (editableInsuranceService && editableInsuranceService.items && editableInsuranceService.items[0] && (editableInsuranceService.items[0][0] || onlineMode)) {
                editableInsuranceServiceItems = onlineMode ? editableInsuranceService.items : editableInsuranceService.items[0];

                editableInsuranceServiceItems.forEach(function (editableInsuranceServiceItem) {
                    orderInfo.passengers.forEach(function (passenger, passengerNum) {
                        itemsByPassengers[passengerNum].forEach(function (item) {
                            if (item.ins === editableInsuranceServiceItem.ins && item.tins === editableInsuranceServiceItem.tins && item.passengerId === editableInsuranceServiceItem.passengerId && (!onlineMode || item.productCode === editableInsuranceServiceItem.productCode)) {
                                item.selected = true;
                            }
                        });
                    });
                });
            }
        }
    }

    function setActiveInsuranceItemsStateBySegmentsPassengers(itemsBySegmentsPassengers, orderInfo, onlineMode) {
        var editableInsuranceService = void 0,
            editableInsuranceServiceItems = void 0;

        if (orderInfo.editable_extra_services) {
            editableInsuranceService = _.findWhere(orderInfo.editable_extra_services, { code: 'insurance' });
            if (editableInsuranceService && editableInsuranceService.items && editableInsuranceService.items[0] && (editableInsuranceService.items[0][0] || onlineMode)) {
                editableInsuranceServiceItems = onlineMode ? editableInsuranceService.items : editableInsuranceService.items[0];

                editableInsuranceServiceItems.forEach(function (editableInsuranceServiceItem) {
                    orderInfo.plainFlights.forEach(function (segment, segmentNum) {
                        orderInfo.passengers.forEach(function (passenger, passengerNum) {
                            itemsBySegmentsPassengers[segmentNum][passengerNum].forEach(function (item) {
                                if (item.ins === editableInsuranceServiceItem.ins && item.tins === editableInsuranceServiceItem.tins && item.passengerId === editableInsuranceServiceItem.passengerId && item.segmentId === editableInsuranceServiceItem.segmentId && (!onlineMode || item.productCode === editableInsuranceServiceItem.productCode)) {
                                    item.selected = true;
                                }
                            });
                        });
                    });
                });
            }
        }
    }

    function setActiveMealItemsState(itemsByPassengerSegments, orderInfo) {
        if (orderInfo.editableExtraServicesByPassengers) {
            itemsByPassengerSegments.forEach(function (passenger, passengerNumber) {
                if (orderInfo.editableExtraServicesByPassengers[passengerNumber] && passenger) {
                    passenger.forEach(function (availableExtraServices, segmentNumber) {
                        var passengerSegmentServices = orderInfo.editableExtraServicesByPassengers[passengerNumber].passengerSegmentServices[segmentNumber];

                        var passengerSegmentMeal = void 0,
                            rfisc = void 0,
                            price = void 0,
                            currency = void 0;

                        if (passengerSegmentServices) {
                            passengerSegmentMeal = _.findWhere(passengerSegmentServices, { code: 'meal' });

                            if (passengerSegmentMeal) {
                                rfisc = passengerSegmentMeal.serviceItem.rfisc;
                                price = passengerSegmentMeal.serviceItem.totalPrice;
                                currency = passengerSegmentMeal.serviceItem.currency;
                            }
                        }

                        if (availableExtraServices) {
                            availableExtraServices.forEach(function (subgroup) {
                                subgroup.forEach(function (mealItem) {
                                    mealItem.active = rfisc && mealItem.rfisc === rfisc;
                                    if (mealItem.active && price && !mealItem.price) {
                                        mealItem.price = price;
                                        mealItem.currency = currency;
                                    }
                                });
                            });
                        }
                    });
                }
            });
        } else {
            itemsByPassengerSegments.forEach(function (passenger) {
                if (passenger) {
                    passenger.forEach(function (availableExtraServices) {
                        if (availableExtraServices) {
                            availableExtraServices.forEach(function (subgroup) {
                                subgroup.forEach(function (mealItem) {
                                    mealItem.active = false;
                                });
                            });
                        }
                    });
                }
            });
        }
    }

    function generateMarkerByRfisc(paxList) {
        var result = {};
        if (paxList && paxList.length) {
            paxList.forEach(function (pax) {
                if (pax.segments && pax.segments.length) {
                    pax.segments.forEach(function (segment) {
                        if (segment.availableExtraServices && segment.availableExtraServices.length) {
                            segment.availableExtraServices.forEach(function (subGroup) {
                                if (subGroup && subGroup.length) {
                                    subGroup.forEach(function (item) {
                                        if (item && item.marker && item.rfisc) {
                                            result[item.rfisc] = reformatServiceMarker(item.marker);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }
        return result;
    }

    function deepCollapseEmptyItems(list) {
        if (list.some(function (item) {
            return !!item;
        })) {
            return list.map(function (item) {
                return item.length ? deepCollapseEmptyItems(item) : item;
            });
        } else {
            return false;
        }
    }

    function getAvailableByPassengerSegments(orderInfo, service) {
        return deepCollapseEmptyItems(orderInfo.passengers.map(function (orderPassenger) {
            return orderInfo.plainFlights.map(function (orderSegment) {
                return service.svcs.some(function (svc) {
                    return svc.passengerId === orderPassenger.id && svc.segmentId === orderSegment.id;
                });
            });
        }));
    }

    function groupSvcsByFlightPassenger(svcs, orderInfo) {
        return deepCollapseEmptyItems(orderInfo.plainFlights.map(function (flight) {
            return orderInfo.passengers.map(function (passenger) {
                var flightPassengerSvcs = svcs.filter(function (svc) {
                    return svc.segmentId === flight.id && svc.passengerId === passenger.id;
                });
                return flightPassengerSvcs[0] || false;
            });
        }));
    }

    function groupSvcsByPassenger(svcs, orderInfo) {
        return deepCollapseEmptyItems(orderInfo.passengers.map(function (passenger) {
            var passengerSvcs = (svcs || []).filter(function (svc) {
                return svc.passengerId === passenger.id;
            });
            return passengerSvcs[0] || false;
        }));
    }

    function groupInsuranceItemsPassengers(items, orderInfo) {
        return deepCollapseEmptyItems(orderInfo.passengers.map(function (passenger) {
            var passengerItems = (items || []).filter(function (item) {
                return item.passengerId === passenger.id;
            });
            if (passengerItems[0]) {
                return (0, _extends3.default)({}, passengerItems[0], {
                    limit: 1,
                    alreadySelectedCount: passengerItems[0].selected ? 1 : 0
                });
            } else {
                return false;
            }
        }));
    }

    function groupInsuranceItemsFlightPassengers(items, orderInfo) {
        return deepCollapseEmptyItems(orderInfo.plainFlights.map(function (flight) {
            return orderInfo.passengers.map(function (passenger) {
                var passengerFlightItems = (items || []).filter(function (item) {
                    return item.passengerId === passenger.id && item.segmentId === flight.id;
                });
                if (passengerFlightItems[0]) {
                    return (0, _extends3.default)({}, passengerFlightItems[0], {
                        limit: 1,
                        alreadySelectedCount: passengerFlightItems[0].selected ? 1 : 0
                    });
                } else {
                    return false;
                }
            });
        }));
    }

    function getFirstAvailableSvcsFlight(svcs, orderInfo) {
        var _loop = function _loop(i) {
            if (svcs.some(function (svc) {
                return svc.segmentId === orderInfo.plainFlights[i].id;
            })) {
                return {
                    v: i
                };
            }
        };

        for (var i = 0; i < orderInfo.plainFlights.length; i++) {
            var _ret = _loop(i);

            if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
        }
        return -1;
    }

    function getFirstAvailableSvcsPassenger(svcs, orderInfo, flightIndex) {
        var _loop2 = function _loop2(i) {
            if (svcs.some(function (svc) {
                return svc.segmentId === orderInfo.plainFlights[flightIndex].id && svc.passengerId === orderInfo.passengers[i].id;
            })) {
                return {
                    v: i
                };
            }
        };

        for (var i = 0; i < orderInfo.passengers.length; i++) {
            var _ret2 = _loop2(i);

            if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
        }
        return -1;
    }

    function getItemsByPassengers(orderInfo, service) {
        return deepCollapseEmptyItems(orderInfo.passengers.map(function (orderPassenger) {
            var availablePassengerItems = service.svcs.filter(function (svc) {
                return svc.passengerId === orderPassenger.id;
            });
            if (availablePassengerItems.length) {
                return availablePassengerItems.map(function (availablePassengerItem) {
                    var selectedItem = _.findWhere(orderInfo.allExtraServicesHeap, {
                        groupCode: availablePassengerItem.groupCode,
                        passengerId: availablePassengerItem.passengerId,
                        rfisc: availablePassengerItem.rfisc
                    });
                    if (selectedItem) {
                        if (selectedItem.amount) {
                            availablePassengerItem.alreadySelectedCount = selectedItem.amount;
                        }
                        if (selectedItem.extraProperties) {
                            availablePassengerItem.extraProperties = selectedItem.extraProperties;
                        }
                        if (selectedItem.totalPrice) {
                            availablePassengerItem.alreadySelectedPrice = selectedItem.totalPrice;
                        }
                        if (selectedItem.currency) {
                            availablePassengerItem.currency = selectedItem.currency;
                        }
                    }
                    availablePassengerItem.marker = reformatServiceMarker(availablePassengerItem.marker);
                    return availablePassengerItem;
                });
            } else {
                return false;
            }
        }));
    }

    function getItemsByPassengerSegments(orderInfo, service) {
        return deepCollapseEmptyItems(orderInfo.passengers.map(function (orderPassenger) {
            return orderInfo.plainFlights.map(function (orderSegment) {
                var availablePassengerSegmentItems = service.svcs.filter(function (svc) {
                    return svc.passengerId === orderPassenger.id && svc.segmentId === orderSegment.id;
                });
                if (availablePassengerSegmentItems.length) {
                    return service.structure.subgroups.map(function (subgroup) {
                        return availablePassengerSegmentItems.filter(function (availablePassengerSegmentItem) {
                            return availablePassengerSegmentItem.subgroupCode === subgroup.code;
                        }).map(function (availablePassengerSegmentItem) {
                            var selectedItem = _.findWhere(orderInfo.allExtraServicesHeap, {
                                groupCode: availablePassengerSegmentItem.groupCode,
                                passengerId: availablePassengerSegmentItem.passengerId,
                                segmentId: availablePassengerSegmentItem.segmentId,
                                rfisc: availablePassengerSegmentItem.rfisc
                            });
                            if (selectedItem) {
                                if (selectedItem.amount) {
                                    availablePassengerSegmentItem.alreadySelectedCount = selectedItem.amount;
                                }
                                if (selectedItem.extraProperties) {
                                    availablePassengerSegmentItem.extraProperties = selectedItem.extraProperties;
                                }
                                if (selectedItem.totalPrice) {
                                    availablePassengerSegmentItem.alreadySelectedPrice = selectedItem.totalPrice;
                                }
                                if (selectedItem.currency) {
                                    availablePassengerSegmentItem.currency = selectedItem.currency;
                                }
                            }
                            availablePassengerSegmentItem.marker = reformatServiceMarker(availablePassengerSegmentItem.marker);
                            return availablePassengerSegmentItem;
                        });
                    });
                } else {
                    return false;
                }
            });
        }));
    }

    function getHasIssuedBySegments(hasIssuedByPassengerSegments) {
        var hasIssuedBySegments = [];

        if (!hasIssuedByPassengerSegments) {
            return hasIssuedBySegments;
        }

        hasIssuedByPassengerSegments.forEach(function (segmentsList, passengerNum) {
            if (segmentsList) {
                segmentsList.forEach(function (segmentHasIssued, segmentNum) {
                    if (!passengerNum) {
                        hasIssuedBySegments.push(!!segmentHasIssued);
                    } else {
                        if (!hasIssuedBySegments[segmentNum] && segmentHasIssued) {
                            hasIssuedBySegments[segmentNum] = true;
                        }
                    }
                });
            }
        });

        return hasIssuedBySegments;
    }

    function getAvailableBySegments(availableByPassengerSegments) {
        var availableBySegments = [];

        if (!availableByPassengerSegments) {
            return availableBySegments;
        }

        availableByPassengerSegments.forEach(function (segmentsList, passengerNum) {
            if (segmentsList) {
                segmentsList.forEach(function (segmentAvailable, segmentNum) {
                    if (!passengerNum) {
                        availableBySegments.push(segmentAvailable);
                    } else {
                        if (!availableBySegments[segmentNum] && segmentAvailable) {
                            availableBySegments[segmentNum] = true;
                        }
                    }
                });
            }
        });

        return availableBySegments;
    }

    function getPricesBySegments(pricesByPassengerSegments) {
        var pricesBySegments = [];

        if (!pricesByPassengerSegments) {
            return pricesBySegments;
        }

        pricesByPassengerSegments.forEach(function (segmentsList) {
            if (segmentsList) {
                segmentsList.forEach(function (segmentPrice, segmentNum) {
                    if (segmentPrice) {
                        if (!pricesBySegments[segmentNum]) {
                            pricesBySegments[segmentNum] = segmentPrice;
                        } else {
                            pricesBySegments[segmentNum] = Big(pricesBySegments[segmentNum]).plus(segmentPrice).toFixed(2);
                        }
                    }
                });
            }
        });

        return pricesBySegments;
    }

    function getServiceMinPrice(service) {
        var currency = void 0;
        var prices = [];

        if (service.svcs) {
            service.svcs.forEach(function (serviceItem) {
                if (!currency && serviceItem.currency) {
                    currency = serviceItem.currency;
                }
                if (serviceItem.price) {
                    prices.push(serviceItem.price);
                }
            });
        }

        if (!prices.length || !currency) {
            return false;
        }

        return {
            price: getMinPrice(prices),
            currency: currency
        };
    }

    function getAeroexpressServiceMinPrice(service) {
        if (!service.items.length) {
            return false;
        }
        return {
            price: getMinPrice(service.items.map(function (serviceItem) {
                return serviceItem.cost;
            })),
            currency: service.items[0].currency
        };
    }

    function getAeroexpressFaresList(items) {
        var fareCodes = {};
        var faresList = [];
        items.forEach(function (item) {
            if (!fareCodes[item.fare]) {
                fareCodes[item.fare] = true;
                faresList.push({
                    code: item.fare,
                    type: item.fare_type,
                    description: item.description,
                    cost: item.cost,
                    currency: item.currency
                });
            }
        });
        return faresList;
    }

    function getAeroexpressRoutes(service) {
        var routes = {};
        service.items.forEach(function (item) {
            var routeCode = item.departure_code + item.arrival_code;
            if (!routes[routeCode]) {
                routes[routeCode] = {
                    departure_code: item.departure_code,
                    arrival_code: item.arrival_code,
                    departure_name: item.departure_name,
                    arrival_name: item.arrival_name,
                    dateVariants: {},
                    dateVariantsList: []
                };
            }
            if (!routes[routeCode].dateVariants[item.date]) {
                routes[routeCode].dateVariants[item.date] = {
                    preferredDate: item.preferredDate,
                    fares: [],
                    freeRideRange: getFreeAeroexpressRideRange(service.economyFreeRidesInfo || service.freeRideInfos, item.date)
                };
                routes[routeCode].dateVariantsList.push(item.date);
            }
            routes[routeCode].dateVariants[item.date].fares.push({
                description: item.description,
                fare: item.fare,
                fare_type: item.fare_type,
                marker: reformatServiceMarker(item.marker),
                cost: item.cost,
                currency: item.currency,
                birthdayRange: item.birthdayRange
            });
        });
        return routes;
    }

    function getFreeAeroexpressRideRange(freeRideInfos, date) {
        for (var i = 0; i < freeRideInfos.length; i++) {
            if (freeRideInfos[i].departure === date) {
                return freeRideInfos[i].birthdayRange;
            }
        }
    }

    function reformatAeroexpressOptimal(optimal) {
        if (optimal && optimal.dates) {
            optimal.dateVariants = optimal.dates.map(function (date) {
                return date.date;
            });
        }
        return optimal;
    }

    function reformatServiceMarker(marker) {
        if (marker) {
            marker.style = {
                'background-color': marker.backgroundColor,
                'color': marker.textColor,
                'border-color': marker.borderColor
            };
        }
        return marker;
    }

    function getInsuranceFullPrice(service, count) {
        var i = 0,
            min = void 0,
            minCurrency = void 0,
            currentItemPrice = void 0;

        if (!service.items || !service.items[0]) {
            return;
        }

        while (i < service.items.length) {
            currentItemPrice = service.items[i].price || Big(service.items[i].insurance_premium || 0).plus(service.items[i].luggage_premium || 0).times(count).toFixed(2);

            if (!min || min.gt(currentItemPrice)) {
                min = Big(currentItemPrice);
                minCurrency = service.items[i].currency;
            }

            i++;
        }

        return {
            price: min.toFixed(2),
            currency: minCurrency
        };
    }

    function getInsuranceMinPrice(service) {
        var i = 0,
            min = void 0,
            minCurrency = void 0;
        if (!service.items || !service.items.length) {
            return;
        }
        while (i < service.items.length) {
            if (!min || min.gt(service.items[i].price)) {
                min = Big(service.items[i].price);
                minCurrency = service.items[i].currency;
            }
            i++;
        }
        return {
            price: min.toFixed(2),
            currency: minCurrency
        };
    }

    function getInsuranceItemsByPassengers(items, passengers) {
        if (items.some(function (item) {
            return item.passengerId !== undefined;
        })) {
            return passengers.map(function (passenger) {
                return items.filter(function (item) {
                    return item.passengerId === passenger.id;
                });
            });
        } else {
            return false;
        }
    }

    function getInsuranceItemsBySegmentsPassengers(items, passengers, flights) {
        if (items.some(function (item) {
            return item.passengerId !== undefined;
        }) && items.some(function (item) {
            return item.segmentId !== undefined;
        })) {
            return flights.map(function (flight) {
                var itemsByPassengerSegment = passengers.map(function (passenger) {
                    return items.filter(function (item) {
                        return item.passengerId === passenger.id && item.segmentId === flight.id;
                    });
                });
                return itemsByPassengerSegment.length ? itemsByPassengerSegment : false;
            });
        } else {
            return false;
        }
    }

    function getMinPrice(prices) {
        var i = 0,
            min = void 0;

        while (i < prices.length) {
            if (!min || min.gt(prices[i])) {
                min = Big(prices[i]);
            }

            i++;
        }

        if (!min) {
            return false;
        }

        return min.toFixed(2);
    }

    /**
     * Дополняем модель еще одним значением для передачи в ui-select
     * @param {array} list
     * @param {string, object} defaultValue
     * @returns {array}
     */
    function createOptionsForUiSelect(list, defaultValue) {
        return Array.isArray(list) ? createOptions(list, defaultValue) : notArray();

        function createOptions(list, defaultValue) {
            defaultValue = defaultValue === undefined ? [] : [checkTypeValue(defaultValue, false)];

            return defaultValue.concat(list.map(function (item, i) {
                return checkTypeValue(item, i);
            }));
        }

        function notArray() {
            throw new Error('In function createOptionsForUiSelect first argument should be array!');
        }

        function checkTypeValue(value, index) {
            switch (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) {
                case 'string':
                    value = createOptionFromString(value, index);
                    break;
                case 'object':
                    value = createOptionsFromObject(value, index);
                    break;
                default:
                    throw new Error('Invalid type of default value. It\'s should be string or object');
            }

            return value;
        }

        function createOptionFromString(value, index) {
            return { value: value, index: index };
        }

        function createOptionsFromObject(value, index) {
            var option = angular.copy(value);
            option.index = index;
            return option;
        }
    }

    function reformatSvcs(data) {
        if (data.result === 'ok' && data.allPossibleRfiscs) {
            data.rfiscsPrices = {};
            if (!data.svcs || !data.svcs.length) {
                data.allPossibleRfiscs.forEach(function (rfisc) {
                    data.rfiscsPrices[rfisc] = {};
                });
            } else {
                data.svcs.forEach(function (svc) {
                    data.rfiscsPrices[svc.rfisc] = {
                        rfisc: svc.rfisc,
                        available: svc.available,
                        unavailabilityReason: svc.unavailabilityReason,
                        price: svc.price,
                        currency: svc.currency,
                        canAtAgency: svc.canPurchaseAtTicketAgency,
                        canOnline: svc.canPurchaseOnline,
                        canWhenCheckIn: svc.canPurchaseWhenCheckingIn,
                        purchaseInAdvanceInfo: svc.purchaseInAdvanceInfo

                    };
                });
            }
            return data;
        }
    }

    function reformatSeatMapWithImages(data, images, selectedSeats) {
        data.images = images.map(function (image) {
            return image.data;
        });
        data.decks.forEach(function (deck) {
            deck.cabins.forEach(function (cabin) {
                cabin.rows.forEach(function (row) {
                    row.chairs.forEach(function (chair) {
                        if (chair.number && hasInList(selectedSeats, row.number + chair.number)) {
                            chair.selected = true;
                        }
                        if (chair.rfisc && data.svcs) {
                            data.svcs.forEach(function (svc) {
                                if (chair.rfisc === svc.rfisc && chair.seatCharacteristics === svc.seatCharacteristics) {
                                    chair.cost = svc.cost;
                                    chair.currency = svc.currency;
                                    svc.hasChairs = true;
                                    if (chair.available) {
                                        svc.hasAvailableChairs = true;
                                    }
                                }
                            });
                        }
                    });
                });
            });
        });
        return data;
    }

    function reformatSeatMap(data, splitByCabin, selectedSeats) {
        data.decks.forEach(function (deck) {
            deck.cabins.forEach(function (cabin) {

                cabin.colNames = deck.grid.split('').map(function (letter) {
                    if (letter === '/') {
                        return ' ';
                    } else {
                        return letter;
                    }
                }).filter(function (letter) {
                    return !splitByCabin || letter === ' ' || hasColInCabin(cabin, letter);
                });

                if (splitByCabin) {
                    cabin.colNames = cabin.colNames.join('').trim().split('');
                }

                cabin.rows.forEach(function (row, rowNum) {
                    if (hasInList(row.chairs[0].properties, 'wing')) {
                        if (cabin.rows[rowNum - 1] && !cabin.rows[rowNum - 1].atWing) {
                            cabin.rows[rowNum - 1].wingsStart = true;
                        }
                        row.atWing = true;
                    } else if (cabin.rows[rowNum - 1] && cabin.rows[rowNum - 1].atWing) {
                        cabin.rows[rowNum].wingsEnd = true;
                    }

                    row.chairs.forEach(function (chair) {
                        if (chair.autoAssigned) {
                            data.hasAutoAssignedSeat = true;
                        }
                        if (chair.properties && chair.properties.length && hasInList(chair.properties, 'E')) {
                            data.hasEmergencyExit = true;
                        }
                        if (chair.freeAndAutoAssigned) {
                            data.hasFreeAndAutoAssignedSeat = true;
                        }
                        if (chair.rfisc && !chair.freeAndAutoAssigned && data.svcs) {
                            data.svcs.forEach(function (svc, num) {
                                if (chair.rfisc === svc.rfisc && (chair.seatCharacteristics === svc.seatCharacteristics || !chair.seatCharacteristics && !svc.seatCharacteristics)) {
                                    chair.cost = svc.cost;
                                    chair.currency = svc.currency;
                                    chair.rfiscIndex = num;
                                    svc.hasChairs = true;
                                    if (chair.available) {
                                        svc.hasAvailableChairs = true;
                                    }
                                }
                            });
                        }
                        if (chair.number && hasInList(selectedSeats, row.number + chair.number)) {
                            chair.selected = true;
                        }
                    });

                    row.items = cabin.colNames.map(function (colName) {
                        var colChair = void 0;

                        if (colName === ' ') {
                            return { type: 'aisle' };
                        } else {
                            colChair = _.findWhere(row.chairs, { number: colName });
                            if (colChair) {
                                return colChair;
                            } else {
                                return { type: 'aisle' };
                            }
                        }
                    });
                });
            });
        });
        return data;
    }

    function getUnicodeCurrencySign(currencyCode) {
        var signs = {
            'RUB': '&#8381;',
            'THB': '&#3647;',
            'CRC': '&#8353;',
            'GHC': '&#8373;',
            'VND': '&#8363;',
            'EUR': '&#8364;',
            'GBP': '&#163;',
            'TRY': '&#8356;',
            'TRL': '&#8356;',
            'PYG': '&#8370;',
            'LAK': '&#8365;',
            'NGN': '&#8358;',
            'ARS': '&#8369;',
            'CLP': '&#8369;',
            'COP': '&#8369;',
            'CUP': '&#8369;',
            'PHP': '&#8369;',
            'UYU': '&#8369;',
            'CUC': '&#8369;',
            'ARA': '&#8369;',
            'MXN': '&#8369;',
            'USD': '&#36;',
            'MNT': '&#8366;',
            'KRW': '&#8361;',
            'KPW': '&#8361;',
            'JPY': '&#165;',
            'UAH': '&#8372;',
            'KZT': '&#8376;',
            'KHR': '&#6107;',
            'YER': '&#65020;',
            'IRR': '&#65020;',
            'OMR': '&#65020;',
            'QAR': '&#65020;',
            'INR': '&#8377;',
            'GEL': '&#8382;',
            'BYN': '&#66;&#114;',
            'TJS': 'C.'
        };

        return signs[currencyCode] || '';
    }

    function formatPrice(input) {
        var currency = input.currency || 'RUB';

        var value = input.value,
            unicodeCurrencySign = getUnicodeCurrencySign(currency);

        if (unicodeCurrencySign !== '') {
            currency = '<span class="currency_sign">' + unicodeCurrencySign + '</span>';
        }

        if (!value) {
            if (input.ignoreEmptyValue) {
                return currency;
            } else {
                return '';
            }
        } else {
            return formatPriceNum(value) + currency;
        }
    }

    function formatPriceNum(num) {
        var str = Big(num).toFixed(2),
            resultStr = '',
            from = void 0,
            to = void 0;

        var paths = str.split('.');

        str = paths[0];

        for (var i = str.length; i > 0; i -= 3) {
            from = i - 3;
            to = 3;

            if (from < 0) {
                to = from + 3;
                from = 0;
            }

            resultStr = str.substr(from, to) + ' ' + resultStr;
        }

        if (paths[1] && paths[1] !== "0" && paths[1] !== "00") {
            if (paths[1].length === 1) {
                paths[1] = paths[1] + '0';
            }

            resultStr = resultStr.trim() + '.' + paths[1] + ' ';
        }

        resultStr = resultStr.replace(/\s/g, "&nbsp;");

        return resultStr;
    }

    function filterCitiesList(list, substr, lang, localNamePropName, excludeCityCode, limit) {
        var newList = [];

        var localNameSorter = getPropSorter(localNamePropName);

        if (list) {
            if (!substr) {
                newList = list;
                newList.sort(function (a, b) {
                    if (a.popular && !b.popular) {
                        return -1;
                    } else if (!a.popular && b.popular) {
                        return 1;
                    } else {
                        return localNameSorter(a, b);
                    }
                });
            } else {
                list.forEach(function (item) {
                    var relevant = checkCityEntry(item, substr, lang),
                        tmpRelevant = void 0;

                    if (relevant) {
                        item.relevant = relevant;
                        newList.push(item);
                    } else if (item.airports) {
                        for (var j = 0; j < item.airports.length; j++) {
                            tmpRelevant = checkCityEntry(item.airports[j], substr, lang);
                            if (tmpRelevant) {
                                item.airports[j].relevant = tmpRelevant;
                            }
                            if (tmpRelevant > relevant) {
                                relevant = tmpRelevant;
                            }
                        }

                        if (relevant) {
                            item.relevant = relevant;
                            item.hasRelevantAirportOnly = true;
                            newList.push(item);
                        }
                    }
                });

                newList.sort(function (a, b) {
                    return b.relevant - a.relevant;
                });
            }
        }

        if (excludeCityCode) {
            newList = newList.filter(function (item) {
                return excludeCityCode !== item.codeEn;
            });
        }

        if (limit) {
            newList = newList.slice(0, limit);
        }

        return newList;
    }

    function getOrderUniqueEmails(orderInfo) {
        var list = [];

        if (orderInfo) {
            if (orderInfo.email) {
                list.push(orderInfo.email);
            }

            if (orderInfo.passengers && orderInfo.passengers.length) {
                orderInfo.passengers.forEach(function (pax) {
                    if (pax.email && !hasInList(list, pax.email)) {
                        list.push(pax.email);
                    }
                });
            }
        }

        return list;
    }

    function getTimeStepsByRange(min, max) {
        var tmpStep = void 0;

        var steps = [];

        min = reformatStringTime(min);
        max = reformatStringTime(max);

        for (var i = min.hours; i <= max.hours; i++) {
            if (i === min.hours && i === max.hours) {
                steps.push(i + ':' + formatMinutesString(min.minutes));

                for (var j = Math.ceil(min.minutes / 5); j < Math.ceil(max.minutes / 5); j++) {
                    tmpStep = i + ':' + formatMinutesString(j * 5);
                    if (!hasInList(steps, tmpStep)) {
                        steps.push(tmpStep);
                    }
                }

                tmpStep = i + ':' + formatMinutesString(max.minutes);

                if (!hasInList(steps, tmpStep)) {
                    steps.push(tmpStep);
                }
            } else if (i === min.hours) {
                steps.push(i + ':' + formatMinutesString(min.minutes));

                for (var _j = Math.ceil(min.minutes / 5); _j < 60 / 5; _j++) {
                    tmpStep = i + ':' + formatMinutesString(_j * 5);
                    if (!hasInList(steps, tmpStep)) {
                        steps.push(tmpStep);
                    }
                }
            } else if (i === max.hours) {
                for (var _j2 = 0; _j2 < Math.ceil(max.minutes / 5); _j2++) {
                    tmpStep = i + ':' + formatMinutesString(_j2 * 5);
                    steps.push(tmpStep);
                }

                tmpStep = i + ':' + formatMinutesString(max.minutes);

                if (!hasInList(steps, tmpStep)) {
                    steps.push(tmpStep);
                }
            } else {
                for (var _j3 = 0; _j3 < 60 / 5; _j3++) {
                    tmpStep = i + ':' + formatMinutesString(_j3 * 5);
                    steps.push(tmpStep);
                }
            }
        }

        return steps;
    }

    function getDateTimeStepsByRange(min, max) {
        var minArr = min.split(' '),
            maxArr = max.split(' '),
            tmpDay = moment(minArr[0], 'DD.MM.YYYY');

        if (compareStringDateTime(min, max) === 1) {
            return;
        }

        var steps = getTimeStepsByRange(minArr[1], '23:55').map(function (time) {
            return minArr[0] + ' ' + time;
        });

        function addDate(time) {
            return tmpDay.format('DD.MM.YYYY') + ' ' + time;
        }

        while (tmpDay.format('DD.MM.YYYY') !== maxArr[0]) {
            tmpDay.add(1, 'd');

            steps = _.union(steps, getTimeStepsByRange('00:00', tmpDay.format('DD.MM.YYYY') === maxArr[0] ? maxArr[1] : '23:55').map(addDate));
        }

        return steps;
    }

    function addToTaxList(listA, listB) {
        var index = {},
            newList = [];

        var code = void 0;

        for (var i = 0; i < listA.length; i++) {
            if (!index[listA[i].code]) {
                index[listA[i].code] = _.extend({}, listA[i]);
            } else {
                index[listA[i].code].value = Big(index[listA[i].code].value).plus(listA[i].value).toFixed(2);
            }
        }

        for (var j = 0; j < listB.length; j++) {
            if (!index[listB[j].code]) {
                index[listB[j].code] = _.extend({}, listB[j]);
            } else {
                index[listB[j].code].value = Big(index[listB[j].code].value).plus(listB[j].value).toFixed(2);
            }
        }

        for (code in index) {
            newList.push(index[code]);
        }

        return newList;
    }

    function isFreePaymentVariants(list) {
        var isFree = true;

        if (list && list.length) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].price !== '0.00') {
                    return false;
                }
            }
        }

        return isFree;
    }

    function getAvailablePassengersCount(availableByPassengerSegments) {
        var count = 0;

        if (availableByPassengerSegments) {
            availableByPassengerSegments.forEach(function (segList) {
                if (segList !== false) {
                    count++;
                }
            });
        }

        return count;
    }

    function reformatStringTime(time) {
        var timeArr = time.split(':').map(function (s) {
            return parseInt(s, 10);
        });

        return {
            hours: timeArr[0],
            minutes: timeArr[1]
        };
    }

    function clearFirstZeroInStringTime(time) {
        var timeObj = reformatStringTime(time);

        return timeObj.hours + ':' + formatMinutesString(timeObj.minutes);
    }

    function formatMinutesString(num) {
        return num > 9 ? '' + num : '0' + num;
    }

    function isAdvancedRoute(segments) {
        for (var i = 0; i < segments.length; i++) {
            if (i && segments[i].flights[0].origincity !== segments[i - 1].flights[segments[i - 1].flights.length - 1].destinationcity) {

                return true;
            }

            for (var j = 0; j < segments[i].flights.length; j++) {
                if (segments[i].flights[j].status !== segments[0].flights[0].status) {
                    return true;
                }
            }
        }

        return false;
    }

    function hasColInCabin(cabin, letter) {
        if (cabin && cabin.rows) {
            for (var rowNum = 0; rowNum < cabin.rows.length; rowNum++) {
                if (cabin.rows[rowNum] && cabin.rows[rowNum].chairs) {
                    for (var chairNum = 0; chairNum < cabin.rows[rowNum].chairs.length; chairNum++) {
                        if (cabin.rows[rowNum].chairs[chairNum] && cabin.rows[rowNum].chairs[chairNum].number === letter) {

                            return true;
                        }
                    }
                }
            }
        }

        return false;
    }

    /**
     *
     * @param arr[] {string}
     */
    function minTimeFromList(arr) {
        if (arr.length < 1) {
            return;
        }

        return arr.reduce(function (timePrev, timeCur) {
            if (compareStringTime(timePrev, timeCur) === -1) {
                return timePrev;
            }

            return timeCur;
        });
    }

    /**
     *
     * @param variantsArr[] {object}
     */
    function minPriceFromVariants(variantsArr) {
        if (variantsArr.length < 1) {
            return;
        }

        return variantsArr.reduce(function (variantPrev, variantCur) {
            if (Big(variantCur.price).lt(Big(variantPrev.price))) {
                return variantCur;
            }

            return variantPrev;
        }).price;
    }

    /**
     *
     * @param from {date}
     * @param to {date}
     * @param format {string}
     */
    function getTimeDiff(from, to, format) {
        from = moment.isMoment(from) === false ? moment(from, 'DD.MM.YYYY') : from;
        to = moment.isMoment(to) === false ? moment(to, 'DD.MM.YYYY') : to;

        return moment.duration(moment(to).diff(from)).get(format);
    }

    function getTicketPricesByPassengers(ticketPrices, passengers) {
        var ticketPricesByPassengers = [];
        passengers.forEach(function (pax) {
            var fare = Big(0);
            var tax = Big(0);
            var total = Big(0);
            var fareCodes = [];
            var flightClasses = [];
            var ticketPricesByPax = ticketPrices.filter(function (ticketPrice) {
                return ticketPrice.passengerId === pax.id;
            });
            ticketPricesByPax.forEach(function (ticketPrice) {
                fare = Big(ticketPrice.fare).plus(fare);
                tax = Big(ticketPrice.tax).plus(tax);
                total = Big(ticketPrice.total).plus(total);
                ticketPrice.fareCodes.forEach(function (fareCode) {
                    fareCodes.push(fareCode);
                });
                ticketPrice.flightClasses.forEach(function (flightClass) {
                    flightClasses.push(flightClass);
                });
            });
            if (ticketPricesByPax.length) {
                ticketPricesByPassengers.push({
                    passengerName: pax.firstName + ' ' + pax.lastName,
                    fare: fare.toFixed(2),
                    tax: tax.toFixed(2),
                    total: total.toFixed(2),
                    fareCodes: fareCodes,
                    flightClasses: flightClasses
                });
            }
        });
        return ticketPricesByPassengers;
    }

    function getTicketPricesByPassengerTypes(ticketPrices, taxesGroupsList) {
        var types = {};
        ticketPrices.forEach(function (ticketPrice) {
            if (!types[ticketPrice.passengerType]) {
                types[ticketPrice.passengerType] = {
                    passengerCount: 1,
                    passengerType: ticketPrice.passengerType,
                    tax: ticketPrice.tax,
                    taxes: mergePassengerTypeTaxes({}, ticketPrice.taxes || []),
                    fare: ticketPrice.fare,
                    total: ticketPrice.total
                };
            } else {
                types[ticketPrice.passengerType].tax = Big(types[ticketPrice.passengerType].tax).plus(ticketPrice.tax).toFixed(2);
                types[ticketPrice.passengerType].taxes = mergePassengerTypeTaxes(types[ticketPrice.passengerType].taxes, ticketPrice.taxes || []);
                types[ticketPrice.passengerType].fare = Big(types[ticketPrice.passengerType].fare).plus(ticketPrice.fare).toFixed(2);
                types[ticketPrice.passengerType].total = Big(types[ticketPrice.passengerType].total).plus(ticketPrice.total).toFixed(2);
                types[ticketPrice.passengerType].passengerCount++;
            }
        });
        return _.keys(types).map(function (passengerType) {
            types[passengerType].groupedTaxes = groupPassengerTypeTaxes(types[passengerType].taxes, taxesGroupsList);
            types[passengerType].otherTaxes = calcPassengerTypeOtherTaxes(types[passengerType].taxes, taxesGroupsList);
            return types[passengerType];
        });
    }

    function mergePassengerTypeTaxes(sourceObj, additionTaxesList) {
        additionTaxesList.forEach(function (tax) {
            if (!sourceObj[tax.code]) {
                sourceObj[tax.code] = tax.value;
            } else {
                sourceObj[tax.code] = Big(sourceObj[tax.code]).plus(tax.value).toFixed(2);
            }
        });
        return sourceObj;
    }

    function calcPassengerTypeOtherTaxes(taxes, taxesGroupsList) {
        if (!taxesGroupsList || !taxesGroupsList.length || !taxes) {
            return false;
        }
        var result = '0';
        var allTaxesGroups = [];
        taxesGroupsList.forEach(function (taxesGroupItem) {
            taxesGroupItem.groups.forEach(function (taxCode) {
                allTaxesGroups.push(taxCode);
            });
        });
        _.keys(taxes).forEach(function (taxCode) {
            if (!hasInList(allTaxesGroups, taxCode)) {
                result = Big(result).plus(taxes[taxCode]).toFixed(2);
            }
        });
        if (result === '0') {
            return false;
        }
        return result;
    }

    function groupPassengerTypeTaxes(taxes, taxesGroupsList) {
        if (!taxesGroupsList || !taxesGroupsList.length || !taxes) {
            return false;
        }
        return taxesGroupsList.map(function (taxesGroupItem) {
            return {
                groups: taxesGroupItem.groups,
                code: taxesGroupItem.code,
                showOnlyIfNotZero: taxesGroupItem.showOnlyIfNotZero,
                value: summTaxesByGroups(taxes, taxesGroupItem.groups)
            };
        }).filter(function (taxGroupItem) {
            return !(taxGroupItem.value === '0' && taxGroupItem.showOnlyIfNotZero);
        });
    }

    function summTaxesByGroups(taxes, groups) {
        var result = '0';
        groups.forEach(function (taxCode) {
            if (taxes[taxCode]) {
                result = Big(result).plus(taxes[taxCode]).toFixed(2);
            }
        });
        return result;
    }

    function getViewedServices() {
        return angular.fromJson($window.sessionStorage.websky_viewed_services || []);
    }

    function getViewedServicesItems() {
        return angular.fromJson($window.sessionStorage.websky_viewed_services_items || []);
    }

    function getRemovedServices() {
        return angular.fromJson($window.sessionStorage.websky_removed_services || []);
    }

    function addViewedService(code) {
        var viewedServices = getViewedServices();
        if (!hasInList(viewedServices, code)) {
            viewedServices.push(code);
            $window.sessionStorage.websky_viewed_services = angular.toJson(viewedServices);
        }
    }

    function addViewedServiceItem(code) {
        var viewedServicesItems = getViewedServicesItems();
        if (!hasInList(viewedServicesItems, code)) {
            viewedServicesItems.push(code);
            $window.sessionStorage.websky_viewed_services_items = angular.toJson(viewedServicesItems);
        }
    }

    function addRemovedService(code) {
        var removedServices = getRemovedServices();
        if (!hasInList(removedServices, code)) {
            removedServices.push(code);
            $window.sessionStorage.websky_removed_services = angular.toJson(removedServices);
        }
    }

    function clearServicesStatistics() {
        delete $window.sessionStorage.websky_viewed_services;
        delete $window.sessionStorage.websky_viewed_services_items;
        delete $window.sessionStorage.websky_removed_services;
        delete $window.sessionStorage.websky_removed_services_items;
    }

    function getPricesByOrderFlights(order) {

        if (!order || !order.flights || !order.prices || !order.prices.pricesByPassengerSegments) {
            return;
        }

        return order.flights.map(function (segment) {
            var orderFlightPrice = Big(0);
            segment.flights.forEach(function (flight) {
                order.prices.pricesByPassengerSegments.forEach(function (passengerSegmentPrice) {
                    if (passengerSegmentPrice.segmentId === flight.id) {
                        orderFlightPrice = orderFlightPrice.plus(passengerSegmentPrice.price);
                    }
                });
            });
            return {
                flights: segment.flights.map(function (flight) {
                    return flight.id;
                }),
                price: orderFlightPrice.toFixed(2)
            };
        });
    }

    function getSirenaPassengerNameTransliteration(input) {
        var output = '';
        var letters = {
            'А': 'A',
            'Б': 'B',
            'В': 'V',
            'Г': 'G',
            'Д': 'D',
            'Е': 'E',
            'Ё': 'E',
            'Ж': 'ZH',
            'З': 'Z',
            'И': 'I',
            'Й': 'I',
            'К': 'K',
            'Л': 'L',
            'М': 'M',
            'Н': 'N',
            'О': 'O',
            'П': 'P',
            'Р': 'R',
            'С': 'S',
            'Т': 'T',
            'У': 'U',
            'Ф': 'F',
            'Х': 'KH',
            'Ц': 'TS',
            'Ч': 'CH',
            'Ш': 'SH',
            'Щ': 'SHCH',
            'Ь': '',
            'Ы': 'Y',
            'Ъ': '',
            'Э': 'E',
            'Ю': 'IU',
            'Я': 'IA'
        };
        if (!input || !input.length) {
            return;
        }
        for (var i = 0; i < input.length; i++) {
            if (letters[input[i]] === undefined) {
                return;
            }
            output += letters[input[i]];
        }
        return output;
    }

    function checkSirenaPassengerFullName(lastName, firstName) {

        if (!lastName || !firstName) {
            return false;
        }

        var fullName = (lastName + ' ' + firstName).toUpperCase().replaceAll('Ё', 'Е').replaceAll('Ъ', 'Ь');
        var nameParts = fullName.split(' ');

        for (var i = 0; i < nameParts.length; i++) {
            if (nameParts[i][0] === 'Ь') {
                return false;
            }
        }

        var hasCyrillic = /[А-Я]/.test(fullName);
        var hasLatin = /[A-Z]/.test(fullName);

        if (hasCyrillic && hasLatin) {
            return false;
        }

        if (!hasCyrillic && !hasLatin) {
            return false;
        }

        return true;
    }

    function checkSirenaPassengerFullNameLength(lastName, firstName) {

        if (!firstName) {
            firstName = '';
        }
        if (!lastName) {
            lastName = '';
        }

        var fullName = (lastName + ' ' + firstName).toUpperCase().replaceAll('Ё', 'Е').replaceAll('Ъ', 'Ь');
        var nameParts = fullName.split(' ');

        var hasCyrillic = /[А-Я]/.test(fullName);
        var hasLatin = /[A-Z]/.test(fullName);

        if (hasLatin && fullName.length > 43) {
            return false;
        }

        if (hasCyrillic) {
            if (fullName.length > 50) {
                return false;
            }
            var fullNameTransliteration = nameParts.map(getSirenaPassengerNameTransliteration).join(' ');
            if (fullNameTransliteration.length > 43) {
                return false;
            }
        }

        return true;
    }

    function generateIndexByRfisc(cards) {
        var result = {};
        cards.forEach(function (card, cardNum) {
            result[card.rfisc] = cardNum;
        });
        return result;
    }

    function checkIsPassengerChildForBonusCard(passenger) {
        return passenger.categoryType === 'CHILD' || passenger.categoryType === 'INFANT_WITH_SEAT' || passenger.categoryType === 'INFANT_WITHOUT_SEAT';
    }
}]);

},{"babel-runtime/helpers/extends":9,"babel-runtime/helpers/slicedToArray":10,"babel-runtime/helpers/toConsumableArray":11,"babel-runtime/helpers/typeof":12}],153:[function(require,module,exports){
"use strict";

angular.module('ox').factory('watchman', ['utils', function (utils) {
    var listeners = [];
    var userInterfaceListeners = [];
    var orderEventsListeners = [];
    var supportedProviders = [{
        code: 'websky',
        name: 'Websky',
        url: './'
    }, {
        code: 'admitad',
        name: 'Admitad',
        url: 'https://www.admitad.com/'
    }, {
        code: 'googleAnalytics',
        name: 'Google Analytics',
        url: 'https://analytics.google.com/analytics'
    }, {
        code: 'skyscanner',
        name: 'Skyscanner',
        url: 'https://skyscanner.com/'
    }, {
        code: 'vk',
        name: 'Вконтакте',
        url: 'https://vk.com/'
    }, {
        code: 'yandexMarker',
        name: 'Yandex marker',
        url: 'https://travel.yandex.ru/avia/'
    }, {
        code: 'yandexMetrika',
        name: 'Yandex metrika',
        url: 'https://metrika.yandex.ru/'
    }, {
        code: 'mindbox',
        name: 'Mindbox',
        url: 'https://mindbox.ru/'
    }];
    var activeProviders = [];

    return {
        addListener: addListener,
        addUserInterfaceListener: addUserInterfaceListener,
        addOrderEventListener: addOrderEventListener,
        removeListener: removeListener,
        removeUserInterfaceListener: removeUserInterfaceListener,
        removeOrderEventListener: removeOrderEventListener,
        notify: notify,
        notifyUserInterfaceEvent: notifyUserInterfaceEvent,
        notifyOrderEvent: notifyOrderEvent,
        getActiveProvidersList: getActiveProvidersList,
        getActiveProvidersListDetailed: getActiveProvidersListDetailed
    };

    function addListener(cb, providerCode) {
        if (!checkProviderCode(providerCode)) {
            return;
        }
        if (getListenerIndex(cb, listeners) === -1) {
            return listeners.push(cb);
        }
    }

    function removeListener(cb) {
        var index = getListenerIndex(cb, listeners);
        if (getListenerIndex(cb, listeners) !== -1) {
            listeners.splice(index, 1);
        }
    }

    function notify(keyEvent) {
        listeners.forEach(function (listener) {
            try {
                listener(angular.copy(keyEvent));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Error in watchman overlooker: ', err);
            }
        });
    }

    function addUserInterfaceListener(cb, providerCode) {
        if (!checkProviderCode(providerCode)) {
            return;
        }
        if (getListenerIndex(cb, userInterfaceListeners) === -1) {
            return userInterfaceListeners.push(cb);
        }
    }

    function removeUserInterfaceListener(cb) {
        var index = getListenerIndex(cb, userInterfaceListeners);
        if (getListenerIndex(cb, userInterfaceListeners) !== -1) {
            userInterfaceListeners.splice(index, 1);
        }
    }

    function notifyUserInterfaceEvent(userInterfaceEvent) {
        userInterfaceListeners.forEach(function (listener) {
            try {
                listener(angular.copy(userInterfaceEvent));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Error in watchman overlooker: ', err);
            }
        });
    }

    function addOrderEventListener(cb, providerCode) {
        if (!checkProviderCode(providerCode)) {
            return;
        }
        if (getListenerIndex(cb, orderEventsListeners) === -1) {
            return orderEventsListeners.push(cb);
        }
    }

    function removeOrderEventListener(cb) {
        var index = getListenerIndex(cb, orderEventsListeners);
        if (getListenerIndex(cb, orderEventsListeners) !== -1) {
            orderEventsListeners.splice(index, 1);
        }
    }

    function notifyOrderEvent(orderEvent, orderInfo) {
        orderEventsListeners.forEach(function (orderEventsListener) {
            try {
                orderEventsListener(angular.copy(orderEvent), angular.copy(orderInfo));
            } catch (err) {
                // eslint-disable-next-line
                console.log('Error in watchman overlooker: ', err);
            }
        });
    }

    function getListenerIndex(cb, cbList) {
        var i = 0;
        while (i < cbList.length) {
            if (cb === cbList[i]) {
                return i;
            }
            i++;
        }
        return -1;
    }

    function checkProviderCode(code) {
        if (code && supportedProviders.some(function (item) {
            return item.code === code;
        })) {
            activateProvider(code);
            return true;
        }
        // eslint-disable-next-line
        console.log('Error in watchman: unknown provider: ', code);
        return false;
    }

    function activateProvider(code) {
        if (!utils.hasInList(activeProviders, code) && code !== 'websky') {
            activeProviders.push(code);
        }
    }

    function getActiveProvidersList() {
        return activeProviders;
    }

    function getActiveProvidersListDetailed() {
        return supportedProviders.filter(function (item) {
            return utils.hasInList(activeProviders, item.code);
        });
    }
}]);

},{}]},{},[146]);
